(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[168],{

/***/ 18805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ChevronForwardV4Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronForwardV4Icon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.21967 2.96967C5.51256 2.67678 5.98744 2.67678 6.28033 2.96967L10.7803 7.46967C11.0732 7.76256 11.0732 8.23744 10.7803 8.53033L6.28033 13.0303C5.98744 13.3232 5.51256 13.3232 5.21967 13.0303C4.92678 12.7374 4.92678 12.2626 5.21967 11.9697L9.18934 8L5.21967 4.03033C4.92678 3.73744 4.92678 3.26256 5.21967 2.96967Z",
            fill: "currentColor"
        })
    });
};


/***/ }),

/***/ 51580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ FAQBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/components/icons/ChevronForwardV4Icon.tsx
var ChevronForwardV4Icon = __webpack_require__(18805);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/FAQBlock/FAQBlock.module.scss
var FAQBlock_module = __webpack_require__(44341);
var FAQBlock_module_default = /*#__PURE__*/__webpack_require__.n(FAQBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/FAQBlock/FAQBlock.tsx













var FAQ_ITEMS = [
    {
        question: "What payment methods does SmartGates support?",
        answer: "We support a wide range of payment instruments to ensure global coverage. This includes major credit and debit cards (Visa, Mastercard, Maestro, MIR), popular e-wallets, Apple Pay, and Google Pay. Additionally, we provide access to local payment methods depending on your business region, such as bank transfers and alternative local systems."
    },
    {
        question: "How does the smart routing engine work?",
        answer: "Our engine analyzes every transaction request in real-time. Based on parameters like card type, issuing bank, geolocation, and current acquirer performance, the algorithm automatically selects the optimal path for the payment. This technology maximizes your conversion rates (approval rates) and minimizes processing costs."
    },
    {
        question: "What security standards does SmartGates comply with?",
        answer: "Security is our core priority. SmartGates is fully certified with PCI DSS Level 1, the highest security standard in the payment card industry. We also utilize 3D-Secure 2.0 protocols, advanced AI-driven anti-fraud systems, and end-to-end data encryption to protect every transaction."
    },
    {
        question: "How long does integration take?",
        answer: "Thanks to our comprehensive API documentation and ready-to-use modules for popular CMS platforms, the technical integration can be completed within a few hours to a couple of days. The full account activation also depends on the KYC (Know Your Customer) verification process, which typically takes 1–3 business days."
    },
    {
        question: "What reporting and analytics are available?",
        answer: "You get access to a powerful dashboard with real-time analytics in your merchant portal. You can track turnover dynamics, average transaction value, payer geography, and detailed breakdown of decline reasons. All data can be easily exported in CSV or XLS formats for your internal accounting and reporting."
    },
    {
        question: "Is there a minimum transaction volume required?",
        answer: "We work with businesses of all sizes, from startups to large enterprises. There is no strict minimum transaction volume required. However, we offer tiered pricing models: as your transaction volume grows, you can benefit from lower processing fees per operation."
    }, 
];
var FAQBlock = function(props) {
    var className = props.className;
    var idPrefix = (0,react.useId)().replace(/:/g, "");
    var ref = (0,react.useState)({}), openIds = ref[0], setOpenIds = ref[1];
    var toggleItem = (0,react.useCallback)(function(index) {
        setOpenIds(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, index, !prev[index]));
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (0,clsx_m/* default */.Z)((FAQBlock_module_default()).root, className),
        id: sections/* SECTIONS_IDS.faq */.s.faq,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FAQBlock_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    alignItems: "center",
                    className: (FAQBlock_module_default()).intro,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: (FAQBlock_module_default()).title,
                            align: "center",
                            children: "Frequently Asked Questions"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            align: "center",
                            children: "Everything you need to know about SmartGates payment platform"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FAQBlock_module_default()).list,
                    role: "list",
                    children: FAQ_ITEMS.map(function(param, index) {
                        var question = param.question, answer = param.answer;
                        var isOpen = Boolean(openIds[index]);
                        var regionId = "faq-panel-".concat(idPrefix, "-").concat(index);
                        var labelId = "faq-label-".concat(idPrefix, "-").concat(index);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: (FAQBlock_module_default()).item,
                            role: "listitem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    id: labelId,
                                    "aria-expanded": isOpen,
                                    "aria-controls": regionId,
                                    className: (FAQBlock_module_default()).itemButton,
                                    onClick: function() {
                                        return toggleItem(index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FAQBlock_module_default()).itemQuestionText,
                                            children: question
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": true,
                                            className: (0,clsx_m/* default */.Z)((FAQBlock_module_default()).chevronWrap, isOpen && (FAQBlock_module_default()).open),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((FAQBlock_module_default()).answerAccordion, isOpen && (FAQBlock_module_default()).answerAccordion_open),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FAQBlock_module_default()).answerAccordionInner,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: regionId,
                                            className: (FAQBlock_module_default()).answer,
                                            role: "region",
                                            "aria-labelledby": labelId,
                                            "aria-hidden": !isOpen,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                className: (FAQBlock_module_default()).answerText,
                                                type: "regular16",
                                                color: "white50",
                                                whiteSpace: "normal",
                                                children: answer
                                            })
                                        })
                                    })
                                })
                            ]
                        }, question);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    alignItems: "center",
                    className: (FAQBlock_module_default()).ctaWrap,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            align: "center",
                            children: "Still have questions?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                            href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                            children: "Contact our team"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/FAQBlock/index.ts



/***/ }),

/***/ 52898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ FeedbackBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 2 modules
var useMutation = __webpack_require__(61068);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(20377);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./generated/graphql.ts
/* eslint-disable */ var CascadeGateType;
(function(CascadeGateType) {
    CascadeGateType["All"] = "all";
    CascadeGateType["Invoice"] = "invoice";
    CascadeGateType["Withdraw"] = "withdraw";
})(CascadeGateType || (CascadeGateType = {}));
var DashboardV2ComparisonMode;
(function(DashboardV2ComparisonMode) {
    DashboardV2ComparisonMode["None"] = "none";
    DashboardV2ComparisonMode["PreviousPeriod"] = "previous_period";
    DashboardV2ComparisonMode["PreviousYear"] = "previous_year";
})(DashboardV2ComparisonMode || (DashboardV2ComparisonMode = {}));
var DashboardV2GroupBy;
(function(DashboardV2GroupBy) {
    DashboardV2GroupBy["Day"] = "day";
    DashboardV2GroupBy["Hour"] = "hour";
})(DashboardV2GroupBy || (DashboardV2GroupBy = {}));
var DashboardV2PeriodType;
(function(DashboardV2PeriodType) {
    DashboardV2PeriodType["HalfYear"] = "half_year";
    DashboardV2PeriodType["Last_7Days"] = "last_7_days";
    DashboardV2PeriodType["Last_14Days"] = "last_14_days";
    DashboardV2PeriodType["LastMonth"] = "last_month";
})(DashboardV2PeriodType || (DashboardV2PeriodType = {}));
var FormMethod;
(function(FormMethod) {
    FormMethod["Apm"] = "apm";
    FormMethod["ApmPersonal"] = "apm_personal";
    FormMethod["H2h"] = "h2h";
    FormMethod["H2hEmail"] = "h2h_email";
    FormMethod["P2p"] = "p2p";
    FormMethod["QrImage"] = "qr_image";
    FormMethod["Redirect"] = "redirect";
})(FormMethod || (FormMethod = {}));
var RevenueChartOperationType;
(function(RevenueChartOperationType) {
    RevenueChartOperationType["Invoice"] = "invoice";
    RevenueChartOperationType["Withdraw"] = "withdraw";
})(RevenueChartOperationType || (RevenueChartOperationType = {}));
var SalesChartOperationType;
(function(SalesChartOperationType) {
    SalesChartOperationType["All"] = "all";
    SalesChartOperationType["Invoice"] = "invoice";
    SalesChartOperationType["Withdraw"] = "withdraw";
})(SalesChartOperationType || (SalesChartOperationType = {}));
var StatusChartOperationType;
(function(StatusChartOperationType) {
    StatusChartOperationType["Invoice"] = "invoice";
    StatusChartOperationType["Withdraw"] = "withdraw";
})(StatusChartOperationType || (StatusChartOperationType = {}));
var TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus["Created"] = "created";
    TransactionStatus["Failed"] = "failed";
    TransactionStatus["Pending"] = "pending";
    TransactionStatus["Succeed"] = "succeed";
})(TransactionStatus || (TransactionStatus = {}));
var TransactionType;
(function(TransactionType) {
    TransactionType["Invoice"] = "invoice";
    TransactionType["Withdraw"] = "withdraw";
})(TransactionType || (TransactionType = {}));
var AuditConstraint;
(function(AuditConstraint) {
    AuditConstraint[/** unique or primary key constraint on columns "id" */ "AuditPkey"] = "audit_pkey";
})(AuditConstraint || (AuditConstraint = {}));
var AuditSelectColumn;
(function(AuditSelectColumn) {
    AuditSelectColumn[/** column name */ "Diff"] = "diff";
    AuditSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    AuditSelectColumn[/** column name */ "Id"] = "id";
    AuditSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    AuditSelectColumn[/** column name */ "OldValue"] = "old_value";
    AuditSelectColumn[/** column name */ "Operation"] = "operation";
    AuditSelectColumn[/** column name */ "PgUsername"] = "pg_username";
    AuditSelectColumn[/** column name */ "RoleId"] = "role_id";
    AuditSelectColumn[/** column name */ "RowId"] = "row_id";
    AuditSelectColumn[/** column name */ "TableName"] = "table_name";
    AuditSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    AuditSelectColumn[/** column name */ "UserId"] = "user_id";
})(AuditSelectColumn || (AuditSelectColumn = {}));
var AuditUpdateColumn;
(function(AuditUpdateColumn) {
    AuditUpdateColumn[/** column name */ "Diff"] = "diff";
    AuditUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    AuditUpdateColumn[/** column name */ "Id"] = "id";
    AuditUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    AuditUpdateColumn[/** column name */ "OldValue"] = "old_value";
    AuditUpdateColumn[/** column name */ "Operation"] = "operation";
    AuditUpdateColumn[/** column name */ "PgUsername"] = "pg_username";
    AuditUpdateColumn[/** column name */ "RoleId"] = "role_id";
    AuditUpdateColumn[/** column name */ "RowId"] = "row_id";
    AuditUpdateColumn[/** column name */ "TableName"] = "table_name";
    AuditUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    AuditUpdateColumn[/** column name */ "UserId"] = "user_id";
})(AuditUpdateColumn || (AuditUpdateColumn = {}));
var BlacklistConstraint;
(function(BlacklistConstraint) {
    BlacklistConstraint[/** unique or primary key constraint on columns "id" */ "BlacklistPkey"] = "blacklist_pkey";
    BlacklistConstraint[/** unique or primary key constraint on columns "sanitized_card", "cardholder" */ "SanitizedCardCardholder"] = "sanitized_card_cardholder";
})(BlacklistConstraint || (BlacklistConstraint = {}));
var BlacklistSelectColumn;
(function(BlacklistSelectColumn) {
    BlacklistSelectColumn[/** column name */ "AccountNumber"] = "account_number";
    BlacklistSelectColumn[/** column name */ "Cardholder"] = "cardholder";
    BlacklistSelectColumn[/** column name */ "Comment"] = "comment";
    BlacklistSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    BlacklistSelectColumn[/** column name */ "Email"] = "email";
    BlacklistSelectColumn[/** column name */ "FirstName"] = "first_name";
    BlacklistSelectColumn[/** column name */ "Id"] = "id";
    BlacklistSelectColumn[/** column name */ "LastName"] = "last_name";
    BlacklistSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    BlacklistSelectColumn[/** column name */ "SanitizedCard"] = "sanitized_card";
})(BlacklistSelectColumn || (BlacklistSelectColumn = {}));
var BlacklistUpdateColumn;
(function(BlacklistUpdateColumn) {
    BlacklistUpdateColumn[/** column name */ "AccountNumber"] = "account_number";
    BlacklistUpdateColumn[/** column name */ "Cardholder"] = "cardholder";
    BlacklistUpdateColumn[/** column name */ "Comment"] = "comment";
    BlacklistUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    BlacklistUpdateColumn[/** column name */ "Email"] = "email";
    BlacklistUpdateColumn[/** column name */ "FirstName"] = "first_name";
    BlacklistUpdateColumn[/** column name */ "Id"] = "id";
    BlacklistUpdateColumn[/** column name */ "LastName"] = "last_name";
    BlacklistUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    BlacklistUpdateColumn[/** column name */ "SanitizedCard"] = "sanitized_card";
})(BlacklistUpdateColumn || (BlacklistUpdateColumn = {}));
var CardSystemConstraint;
(function(CardSystemConstraint) {
    CardSystemConstraint[/** unique or primary key constraint on columns "id" */ "CardSystemPkey"] = "card_system_pkey";
})(CardSystemConstraint || (CardSystemConstraint = {}));
var CardSystemSelectColumn;
(function(CardSystemSelectColumn) {
    CardSystemSelectColumn[/** column name */ "Code"] = "code";
    CardSystemSelectColumn[/** column name */ "Id"] = "id";
    CardSystemSelectColumn[/** column name */ "Name"] = "name";
})(CardSystemSelectColumn || (CardSystemSelectColumn = {}));
var CardSystemUpdateColumn;
(function(CardSystemUpdateColumn) {
    CardSystemUpdateColumn[/** column name */ "Code"] = "code";
    CardSystemUpdateColumn[/** column name */ "Id"] = "id";
    CardSystemUpdateColumn[/** column name */ "Name"] = "name";
})(CardSystemUpdateColumn || (CardSystemUpdateColumn = {}));
var CardlinkInvoiceConstraint;
(function(CardlinkInvoiceConstraint) {
    CardlinkInvoiceConstraint[/** unique or primary key constraint on columns "id" */ "CardlinkInvoicePkey"] = "cardlink_invoice_pkey";
    CardlinkInvoiceConstraint[/** unique or primary key constraint on columns "provider_transaction_uid" */ "CardlinkInvoiceProviderTransactionUidKey"] = "cardlink_invoice_provider_transaction_uid_key";
    CardlinkInvoiceConstraint[/** unique or primary key constraint on columns "transaction_uid" */ "CardlinkInvoiceTransactionUidKey"] = "cardlink_invoice_transaction_uid_key";
})(CardlinkInvoiceConstraint || (CardlinkInvoiceConstraint = {}));
var CardlinkInvoiceSelectColumn;
(function(CardlinkInvoiceSelectColumn) {
    CardlinkInvoiceSelectColumn[/** column name */ "Amount"] = "amount";
    CardlinkInvoiceSelectColumn[/** column name */ "BillId"] = "bill_id";
    CardlinkInvoiceSelectColumn[/** column name */ "CanceledAt"] = "canceled_at";
    CardlinkInvoiceSelectColumn[/** column name */ "Commission"] = "commission";
    CardlinkInvoiceSelectColumn[/** column name */ "ConfirmedAt"] = "confirmed_at";
    CardlinkInvoiceSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CardlinkInvoiceSelectColumn[/** column name */ "Currency"] = "currency";
    CardlinkInvoiceSelectColumn[/** column name */ "ExchangeRate"] = "exchange_rate";
    CardlinkInvoiceSelectColumn[/** column name */ "ExpiredAt"] = "expired_at";
    CardlinkInvoiceSelectColumn[/** column name */ "Id"] = "id";
    CardlinkInvoiceSelectColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    CardlinkInvoiceSelectColumn[/** column name */ "RawRequest"] = "raw_request";
    CardlinkInvoiceSelectColumn[/** column name */ "RawResponse"] = "raw_response";
    CardlinkInvoiceSelectColumn[/** column name */ "Remark"] = "remark";
    CardlinkInvoiceSelectColumn[/** column name */ "SmartStatus"] = "smart_status";
    CardlinkInvoiceSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    CardlinkInvoiceSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    CardlinkInvoiceSelectColumn[/** column name */ "UsdtAmount"] = "usdt_amount";
    CardlinkInvoiceSelectColumn[/** column name */ "UsdtCommission"] = "usdt_commission";
})(CardlinkInvoiceSelectColumn || (CardlinkInvoiceSelectColumn = {}));
var CardlinkInvoiceUpdateColumn;
(function(CardlinkInvoiceUpdateColumn) {
    CardlinkInvoiceUpdateColumn[/** column name */ "Amount"] = "amount";
    CardlinkInvoiceUpdateColumn[/** column name */ "BillId"] = "bill_id";
    CardlinkInvoiceUpdateColumn[/** column name */ "CanceledAt"] = "canceled_at";
    CardlinkInvoiceUpdateColumn[/** column name */ "Commission"] = "commission";
    CardlinkInvoiceUpdateColumn[/** column name */ "ConfirmedAt"] = "confirmed_at";
    CardlinkInvoiceUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CardlinkInvoiceUpdateColumn[/** column name */ "Currency"] = "currency";
    CardlinkInvoiceUpdateColumn[/** column name */ "ExchangeRate"] = "exchange_rate";
    CardlinkInvoiceUpdateColumn[/** column name */ "ExpiredAt"] = "expired_at";
    CardlinkInvoiceUpdateColumn[/** column name */ "Id"] = "id";
    CardlinkInvoiceUpdateColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    CardlinkInvoiceUpdateColumn[/** column name */ "RawRequest"] = "raw_request";
    CardlinkInvoiceUpdateColumn[/** column name */ "RawResponse"] = "raw_response";
    CardlinkInvoiceUpdateColumn[/** column name */ "Remark"] = "remark";
    CardlinkInvoiceUpdateColumn[/** column name */ "SmartStatus"] = "smart_status";
    CardlinkInvoiceUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    CardlinkInvoiceUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    CardlinkInvoiceUpdateColumn[/** column name */ "UsdtAmount"] = "usdt_amount";
    CardlinkInvoiceUpdateColumn[/** column name */ "UsdtCommission"] = "usdt_commission";
})(CardlinkInvoiceUpdateColumn || (CardlinkInvoiceUpdateColumn = {}));
var CascadeItemConstraint;
(function(CascadeItemConstraint) {
    CascadeItemConstraint[/** unique or primary key constraint on columns "id" */ "CascadeItemPkey"] = "cascade_item_pkey";
})(CascadeItemConstraint || (CascadeItemConstraint = {}));
var CascadeItemSelectColumn;
(function(CascadeItemSelectColumn) {
    CascadeItemSelectColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeItemSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeItemSelectColumn[/** column name */ "DisableAt"] = "disable_at";
    CascadeItemSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    CascadeItemSelectColumn[/** column name */ "GateGroupOrder"] = "gate_group_order";
    CascadeItemSelectColumn[/** column name */ "Id"] = "id";
})(CascadeItemSelectColumn || (CascadeItemSelectColumn = {}));
var CascadeItemServiceIdConstraint;
(function(CascadeItemServiceIdConstraint) {
    CascadeItemServiceIdConstraint[/** unique or primary key constraint on columns "id" */ "CascadeItemServiceIdPkey"] = "cascade_item_service_id_pkey";
})(CascadeItemServiceIdConstraint || (CascadeItemServiceIdConstraint = {}));
var CascadeItemServiceIdSelectColumn;
(function(CascadeItemServiceIdSelectColumn) {
    CascadeItemServiceIdSelectColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeItemServiceIdSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeItemServiceIdSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    CascadeItemServiceIdSelectColumn[/** column name */ "DisableAt"] = "disable_at";
    CascadeItemServiceIdSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    CascadeItemServiceIdSelectColumn[/** column name */ "Id"] = "id";
    CascadeItemServiceIdSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    CascadeItemServiceIdSelectColumn[/** column name */ "ServiceId"] = "service_id";
    CascadeItemServiceIdSelectColumn[/** column name */ "ServiceIdOrder"] = "service_id_order";
})(CascadeItemServiceIdSelectColumn || (CascadeItemServiceIdSelectColumn = {}));
var CascadeItemServiceIdUpdateColumn;
(function(CascadeItemServiceIdUpdateColumn) {
    CascadeItemServiceIdUpdateColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeItemServiceIdUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "DisableAt"] = "disable_at";
    CascadeItemServiceIdUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "Id"] = "id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "ServiceId"] = "service_id";
    CascadeItemServiceIdUpdateColumn[/** column name */ "ServiceIdOrder"] = "service_id_order";
})(CascadeItemServiceIdUpdateColumn || (CascadeItemServiceIdUpdateColumn = {}));
var CascadeItemUpdateColumn;
(function(CascadeItemUpdateColumn) {
    CascadeItemUpdateColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeItemUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeItemUpdateColumn[/** column name */ "DisableAt"] = "disable_at";
    CascadeItemUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    CascadeItemUpdateColumn[/** column name */ "GateGroupOrder"] = "gate_group_order";
    CascadeItemUpdateColumn[/** column name */ "Id"] = "id";
})(CascadeItemUpdateColumn || (CascadeItemUpdateColumn = {}));
var CascadeRequestConstraint;
(function(CascadeRequestConstraint) {
    CascadeRequestConstraint[/** unique or primary key constraint on columns "id" */ "CascadeRequestPkey"] = "cascade_request_pkey";
})(CascadeRequestConstraint || (CascadeRequestConstraint = {}));
var CascadeRequestSelectColumn;
(function(CascadeRequestSelectColumn) {
    CascadeRequestSelectColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeRequestSelectColumn[/** column name */ "CascadeWorkerDone"] = "cascade_worker_done";
    CascadeRequestSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeRequestSelectColumn[/** column name */ "CurrentGateGroupOrder"] = "current_gate_group_order";
    CascadeRequestSelectColumn[/** column name */ "CurrentServiceIdOrder"] = "current_service_id_order";
    CascadeRequestSelectColumn[/** column name */ "Errors"] = "errors";
    CascadeRequestSelectColumn[/** column name */ "Id"] = "id";
    CascadeRequestSelectColumn[/** column name */ "IsSucceedCascadeRequest"] = "is_succeed_cascade_request";
    CascadeRequestSelectColumn[/** column name */ "MerchantErrors"] = "merchant_errors";
    CascadeRequestSelectColumn[/** column name */ "Payload"] = "payload";
    CascadeRequestSelectColumn[/** column name */ "PersonalData"] = "personal_data";
    CascadeRequestSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CascadeRequestSelectColumn || (CascadeRequestSelectColumn = {}));
var CascadeRequestUpdateColumn;
(function(CascadeRequestUpdateColumn) {
    CascadeRequestUpdateColumn[/** column name */ "CascadeId"] = "cascade_id";
    CascadeRequestUpdateColumn[/** column name */ "CascadeWorkerDone"] = "cascade_worker_done";
    CascadeRequestUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadeRequestUpdateColumn[/** column name */ "CurrentGateGroupOrder"] = "current_gate_group_order";
    CascadeRequestUpdateColumn[/** column name */ "CurrentServiceIdOrder"] = "current_service_id_order";
    CascadeRequestUpdateColumn[/** column name */ "Errors"] = "errors";
    CascadeRequestUpdateColumn[/** column name */ "Id"] = "id";
    CascadeRequestUpdateColumn[/** column name */ "IsSucceedCascadeRequest"] = "is_succeed_cascade_request";
    CascadeRequestUpdateColumn[/** column name */ "MerchantErrors"] = "merchant_errors";
    CascadeRequestUpdateColumn[/** column name */ "Payload"] = "payload";
    CascadeRequestUpdateColumn[/** column name */ "PersonalData"] = "personal_data";
    CascadeRequestUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CascadeRequestUpdateColumn || (CascadeRequestUpdateColumn = {}));
var CascadesConstraint;
(function(CascadesConstraint) {
    CascadesConstraint[/** unique or primary key constraint on columns "id" */ "CascadesPkey"] = "cascades_pkey";
})(CascadesConstraint || (CascadesConstraint = {}));
var CascadesSelectColumn;
(function(CascadesSelectColumn) {
    CascadesSelectColumn[/** column name */ "Active"] = "active";
    CascadesSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadesSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    CascadesSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    CascadesSelectColumn[/** column name */ "Id"] = "id";
    CascadesSelectColumn[/** column name */ "IsPrivateCascade"] = "is_private_cascade";
    CascadesSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    CascadesSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CascadesSelectColumn || (CascadesSelectColumn = {}));
var CascadesUpdateColumn;
(function(CascadesUpdateColumn) {
    CascadesUpdateColumn[/** column name */ "Active"] = "active";
    CascadesUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CascadesUpdateColumn[/** column name */ "DeletedAt"] = "deleted_at";
    CascadesUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    CascadesUpdateColumn[/** column name */ "Id"] = "id";
    CascadesUpdateColumn[/** column name */ "IsPrivateCascade"] = "is_private_cascade";
    CascadesUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    CascadesUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CascadesUpdateColumn || (CascadesUpdateColumn = {}));
var ClientLimitConstraint;
(function(ClientLimitConstraint) {
    ClientLimitConstraint[/** unique or primary key constraint on columns "id" */ "ClientLimitPkey"] = "client_limit_pkey";
    ClientLimitConstraint[/** unique or primary key constraint on columns "provider_id", "sanitized_mask", "currency_id" */ "ClientLimitProviderIdCurrencyIdSanitizedMaskKey"] = "client_limit_provider_id_currency_id_sanitized_mask_key";
})(ClientLimitConstraint || (ClientLimitConstraint = {}));
var ClientLimitSelectColumn;
(function(ClientLimitSelectColumn) {
    ClientLimitSelectColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    ClientLimitSelectColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    ClientLimitSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ClientLimitSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ClientLimitSelectColumn[/** column name */ "ExpiredAt"] = "expired_at";
    ClientLimitSelectColumn[/** column name */ "Id"] = "id";
    ClientLimitSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ClientLimitSelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    ClientLimitSelectColumn[/** column name */ "TotalAmount"] = "total_amount";
    ClientLimitSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ClientLimitSelectColumn || (ClientLimitSelectColumn = {}));
var ClientLimitUpdateColumn;
(function(ClientLimitUpdateColumn) {
    ClientLimitUpdateColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    ClientLimitUpdateColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    ClientLimitUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ClientLimitUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ClientLimitUpdateColumn[/** column name */ "ExpiredAt"] = "expired_at";
    ClientLimitUpdateColumn[/** column name */ "Id"] = "id";
    ClientLimitUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ClientLimitUpdateColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    ClientLimitUpdateColumn[/** column name */ "TotalAmount"] = "total_amount";
    ClientLimitUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ClientLimitUpdateColumn || (ClientLimitUpdateColumn = {}));
var CountryConstraint;
(function(CountryConstraint) {
    CountryConstraint[/** unique or primary key constraint on columns "id" */ "CountryPkey"] = "country_pkey";
})(CountryConstraint || (CountryConstraint = {}));
var CountryRegionConstraint;
(function(CountryRegionConstraint) {
    CountryRegionConstraint[/** unique or primary key constraint on columns "id" */ "CountryRegionPkey"] = "country_region_pkey";
})(CountryRegionConstraint || (CountryRegionConstraint = {}));
var CountryRegionSelectColumn;
(function(CountryRegionSelectColumn) {
    CountryRegionSelectColumn[/** column name */ "Id"] = "id";
    CountryRegionSelectColumn[/** column name */ "Name"] = "name";
})(CountryRegionSelectColumn || (CountryRegionSelectColumn = {}));
var CountryRegionUpdateColumn;
(function(CountryRegionUpdateColumn) {
    CountryRegionUpdateColumn[/** column name */ "Id"] = "id";
    CountryRegionUpdateColumn[/** column name */ "Name"] = "name";
})(CountryRegionUpdateColumn || (CountryRegionUpdateColumn = {}));
var CountrySelectColumn;
(function(CountrySelectColumn) {
    CountrySelectColumn[/** column name */ "CountryRegionId"] = "country_region_id";
    CountrySelectColumn[/** column name */ "Id"] = "id";
    CountrySelectColumn[/** column name */ "Name"] = "name";
})(CountrySelectColumn || (CountrySelectColumn = {}));
var CountryUpdateColumn;
(function(CountryUpdateColumn) {
    CountryUpdateColumn[/** column name */ "CountryRegionId"] = "country_region_id";
    CountryUpdateColumn[/** column name */ "Id"] = "id";
    CountryUpdateColumn[/** column name */ "Name"] = "name";
})(CountryUpdateColumn || (CountryUpdateColumn = {}));
var CryptoCurrencyConstraint;
(function(CryptoCurrencyConstraint) {
    CryptoCurrencyConstraint[/** unique or primary key constraint on columns "id" */ "CryptoCurrencyPkey"] = "crypto_currency_pkey";
})(CryptoCurrencyConstraint || (CryptoCurrencyConstraint = {}));
var CryptoCurrencySelectColumn;
(function(CryptoCurrencySelectColumn) {
    CryptoCurrencySelectColumn[/** column name */ "Id"] = "id";
})(CryptoCurrencySelectColumn || (CryptoCurrencySelectColumn = {}));
var CryptoCurrencyUpdateColumn;
(function(CryptoCurrencyUpdateColumn) {
    CryptoCurrencyUpdateColumn[/** column name */ "Id"] = "id";
})(CryptoCurrencyUpdateColumn || (CryptoCurrencyUpdateColumn = {}));
var CryptoWithdrawRequestConstraint;
(function(CryptoWithdrawRequestConstraint) {
    CryptoWithdrawRequestConstraint[/** unique or primary key constraint on columns "id" */ "CryptoWithdrawRequestPkey"] = "crypto_withdraw_request_pkey";
    CryptoWithdrawRequestConstraint[/** unique or primary key constraint on columns "transaction_uid" */ "CryptoWithdrawRequestTransactionUidKey"] = "crypto_withdraw_request_transaction_uid_key";
})(CryptoWithdrawRequestConstraint || (CryptoWithdrawRequestConstraint = {}));
var CryptoWithdrawRequestSelectColumn;
(function(CryptoWithdrawRequestSelectColumn) {
    CryptoWithdrawRequestSelectColumn[/** column name */ "AccountNumber"] = "account_number";
    CryptoWithdrawRequestSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    CryptoWithdrawRequestSelectColumn[/** column name */ "CryptoAmount"] = "crypto_amount";
    CryptoWithdrawRequestSelectColumn[/** column name */ "CryptoCurrencyId"] = "crypto_currency_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "CryptoWithdrawRequestStatusId"] = "crypto_withdraw_request_status_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "Description"] = "description";
    CryptoWithdrawRequestSelectColumn[/** column name */ "FiatAmount"] = "fiat_amount";
    CryptoWithdrawRequestSelectColumn[/** column name */ "FiatCurrencyId"] = "fiat_currency_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "GateId"] = "gate_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "Id"] = "id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "KeyApprove"] = "key_approve";
    CryptoWithdrawRequestSelectColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    CryptoWithdrawRequestSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "MerchantSettlementFeeAmount"] = "merchant_settlement_fee_amount";
    CryptoWithdrawRequestSelectColumn[/** column name */ "MerchantSettlementFeePercent"] = "merchant_settlement_fee_percent";
    CryptoWithdrawRequestSelectColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    CryptoWithdrawRequestSelectColumn[/** column name */ "PayoutAmount"] = "payout_amount";
    CryptoWithdrawRequestSelectColumn[/** column name */ "Profit"] = "profit";
    CryptoWithdrawRequestSelectColumn[/** column name */ "ProviderFeePercent"] = "provider_fee_percent";
    CryptoWithdrawRequestSelectColumn[/** column name */ "ProviderSettlementFeeAmount"] = "provider_settlement_fee_amount";
    CryptoWithdrawRequestSelectColumn[/** column name */ "ProviderSettlementFeePercent"] = "provider_settlement_fee_percent";
    CryptoWithdrawRequestSelectColumn[/** column name */ "Rate"] = "rate";
    CryptoWithdrawRequestSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    CryptoWithdrawRequestSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CryptoWithdrawRequestSelectColumn || (CryptoWithdrawRequestSelectColumn = {}));
var CryptoWithdrawRequestStatusConstraint;
(function(CryptoWithdrawRequestStatusConstraint) {
    CryptoWithdrawRequestStatusConstraint[/** unique or primary key constraint on columns "id" */ "CryptoWithdrawRequestStatusPkey"] = "crypto_withdraw_request_status_pkey";
})(CryptoWithdrawRequestStatusConstraint || (CryptoWithdrawRequestStatusConstraint = {}));
var CryptoWithdrawRequestStatusSelectColumn;
(function(CryptoWithdrawRequestStatusSelectColumn) {
    CryptoWithdrawRequestStatusSelectColumn[/** column name */ "Id"] = "id";
    CryptoWithdrawRequestStatusSelectColumn[/** column name */ "Name"] = "name";
})(CryptoWithdrawRequestStatusSelectColumn || (CryptoWithdrawRequestStatusSelectColumn = {}));
var CryptoWithdrawRequestStatusUpdateColumn;
(function(CryptoWithdrawRequestStatusUpdateColumn) {
    CryptoWithdrawRequestStatusUpdateColumn[/** column name */ "Id"] = "id";
    CryptoWithdrawRequestStatusUpdateColumn[/** column name */ "Name"] = "name";
})(CryptoWithdrawRequestStatusUpdateColumn || (CryptoWithdrawRequestStatusUpdateColumn = {}));
var CryptoWithdrawRequestUpdateColumn;
(function(CryptoWithdrawRequestUpdateColumn) {
    CryptoWithdrawRequestUpdateColumn[/** column name */ "AccountNumber"] = "account_number";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "CryptoAmount"] = "crypto_amount";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "CryptoCurrencyId"] = "crypto_currency_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "CryptoWithdrawRequestStatusId"] = "crypto_withdraw_request_status_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "Description"] = "description";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "FiatAmount"] = "fiat_amount";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "FiatCurrencyId"] = "fiat_currency_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "GateId"] = "gate_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "Id"] = "id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "KeyApprove"] = "key_approve";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "MerchantSettlementFeeAmount"] = "merchant_settlement_fee_amount";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "MerchantSettlementFeePercent"] = "merchant_settlement_fee_percent";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "PayoutAmount"] = "payout_amount";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "Profit"] = "profit";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "ProviderFeePercent"] = "provider_fee_percent";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "ProviderSettlementFeeAmount"] = "provider_settlement_fee_amount";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "ProviderSettlementFeePercent"] = "provider_settlement_fee_percent";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "Rate"] = "rate";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    CryptoWithdrawRequestUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(CryptoWithdrawRequestUpdateColumn || (CryptoWithdrawRequestUpdateColumn = {}));
var CurrencyConstraint;
(function(CurrencyConstraint) {
    CurrencyConstraint[/** unique or primary key constraint on columns "id" */ "CurrencyPkey"] = "currency_pkey";
})(CurrencyConstraint || (CurrencyConstraint = {}));
var CurrencySelectColumn;
(function(CurrencySelectColumn) {
    CurrencySelectColumn[/** column name */ "Color"] = "color";
    CurrencySelectColumn[/** column name */ "Icon"] = "icon";
    CurrencySelectColumn[/** column name */ "Id"] = "id";
    CurrencySelectColumn[/** column name */ "Name"] = "name";
})(CurrencySelectColumn || (CurrencySelectColumn = {}));
var CurrencyUpdateColumn;
(function(CurrencyUpdateColumn) {
    CurrencyUpdateColumn[/** column name */ "Color"] = "color";
    CurrencyUpdateColumn[/** column name */ "Icon"] = "icon";
    CurrencyUpdateColumn[/** column name */ "Id"] = "id";
    CurrencyUpdateColumn[/** column name */ "Name"] = "name";
})(CurrencyUpdateColumn || (CurrencyUpdateColumn = {}));
var DynamicFeeConstraint;
(function(DynamicFeeConstraint) {
    DynamicFeeConstraint[/** unique or primary key constraint on columns "id" */ "DynamicFeePkey"] = "dynamic_fee_pkey";
})(DynamicFeeConstraint || (DynamicFeeConstraint = {}));
var DynamicFeeSelectColumn;
(function(DynamicFeeSelectColumn) {
    DynamicFeeSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    DynamicFeeSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    DynamicFeeSelectColumn[/** column name */ "FeeAmount"] = "fee_amount";
    DynamicFeeSelectColumn[/** column name */ "FeePercentage"] = "fee_percentage";
    DynamicFeeSelectColumn[/** column name */ "GateId"] = "gate_id";
    DynamicFeeSelectColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    DynamicFeeSelectColumn[/** column name */ "Id"] = "id";
    DynamicFeeSelectColumn[/** column name */ "MerchantFeeAmount"] = "merchant_fee_amount";
    DynamicFeeSelectColumn[/** column name */ "MerchantFeePercentage"] = "merchant_fee_percentage";
    DynamicFeeSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    DynamicFeeSelectColumn[/** column name */ "RangeFrom"] = "range_from";
    DynamicFeeSelectColumn[/** column name */ "RangeTo"] = "range_to";
    DynamicFeeSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(DynamicFeeSelectColumn || (DynamicFeeSelectColumn = {}));
var DynamicFeeUpdateColumn;
(function(DynamicFeeUpdateColumn) {
    DynamicFeeUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    DynamicFeeUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    DynamicFeeUpdateColumn[/** column name */ "FeeAmount"] = "fee_amount";
    DynamicFeeUpdateColumn[/** column name */ "FeePercentage"] = "fee_percentage";
    DynamicFeeUpdateColumn[/** column name */ "GateId"] = "gate_id";
    DynamicFeeUpdateColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    DynamicFeeUpdateColumn[/** column name */ "Id"] = "id";
    DynamicFeeUpdateColumn[/** column name */ "MerchantFeeAmount"] = "merchant_fee_amount";
    DynamicFeeUpdateColumn[/** column name */ "MerchantFeePercentage"] = "merchant_fee_percentage";
    DynamicFeeUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    DynamicFeeUpdateColumn[/** column name */ "RangeFrom"] = "range_from";
    DynamicFeeUpdateColumn[/** column name */ "RangeTo"] = "range_to";
    DynamicFeeUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(DynamicFeeUpdateColumn || (DynamicFeeUpdateColumn = {}));
var GateConstraint;
(function(GateConstraint) {
    GateConstraint[/** unique or primary key constraint on columns "gate_type_id", "gate_group_id" */ "GateGateTypeIdGateGroupIdConstraint"] = "gate_gate_type_id_gate_group_id_constraint";
    GateConstraint[/** unique or primary key constraint on columns "id" */ "GatePkey"] = "gate_pkey";
})(GateConstraint || (GateConstraint = {}));
var GateGroupBalanceConstraint;
(function(GateGroupBalanceConstraint) {
    GateGroupBalanceConstraint[/** unique or primary key constraint on columns "gate_group_id" */ "GateGroupBalancePkey"] = "gate_group_balance_pkey";
})(GateGroupBalanceConstraint || (GateGroupBalanceConstraint = {}));
var GateGroupBalanceSelectColumn;
(function(GateGroupBalanceSelectColumn) {
    GateGroupBalanceSelectColumn[/** column name */ "Balance"] = "balance";
    GateGroupBalanceSelectColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    GateGroupBalanceSelectColumn[/** column name */ "CalculatedHoldBalance"] = "calculated_hold_balance";
    GateGroupBalanceSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    GateGroupBalanceSelectColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    GateGroupBalanceSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    GateGroupBalanceSelectColumn[/** column name */ "HoldBalance"] = "hold_balance";
    GateGroupBalanceSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateGroupBalanceSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateGroupBalanceSelectColumn || (GateGroupBalanceSelectColumn = {}));
var GateGroupBalanceUpdateColumn;
(function(GateGroupBalanceUpdateColumn) {
    GateGroupBalanceUpdateColumn[/** column name */ "Balance"] = "balance";
    GateGroupBalanceUpdateColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    GateGroupBalanceUpdateColumn[/** column name */ "CalculatedHoldBalance"] = "calculated_hold_balance";
    GateGroupBalanceUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    GateGroupBalanceUpdateColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    GateGroupBalanceUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    GateGroupBalanceUpdateColumn[/** column name */ "HoldBalance"] = "hold_balance";
    GateGroupBalanceUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateGroupBalanceUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateGroupBalanceUpdateColumn || (GateGroupBalanceUpdateColumn = {}));
var GateGroupConstraint;
(function(GateGroupConstraint) {
    GateGroupConstraint[/** unique or primary key constraint on columns "id" */ "GateGroupPkey"] = "gate_group_pkey";
})(GateGroupConstraint || (GateGroupConstraint = {}));
var GateGroupSelectColumn;
(function(GateGroupSelectColumn) {
    GateGroupSelectColumn[/** column name */ "CascadeId"] = "cascade_id";
    GateGroupSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    GateGroupSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    GateGroupSelectColumn[/** column name */ "Id"] = "id";
    GateGroupSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateGroupSelectColumn[/** column name */ "Name"] = "name";
    GateGroupSelectColumn[/** column name */ "ProviderFamily"] = "provider_family";
    GateGroupSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateGroupSelectColumn || (GateGroupSelectColumn = {}));
var GateGroupUpdateColumn;
(function(GateGroupUpdateColumn) {
    GateGroupUpdateColumn[/** column name */ "CascadeId"] = "cascade_id";
    GateGroupUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    GateGroupUpdateColumn[/** column name */ "DeletedAt"] = "deleted_at";
    GateGroupUpdateColumn[/** column name */ "Id"] = "id";
    GateGroupUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateGroupUpdateColumn[/** column name */ "Name"] = "name";
    GateGroupUpdateColumn[/** column name */ "ProviderFamily"] = "provider_family";
    GateGroupUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateGroupUpdateColumn || (GateGroupUpdateColumn = {}));
var GateSelectColumn;
(function(GateSelectColumn) {
    GateSelectColumn[/** column name */ "Alias"] = "alias";
    GateSelectColumn[/** column name */ "BlockedAt"] = "blocked_at";
    GateSelectColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    GateSelectColumn[/** column name */ "CanRecurrent"] = "can_recurrent";
    GateSelectColumn[/** column name */ "CardSystem"] = "card_system";
    GateSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    GateSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    GateSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    GateSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    GateSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    GateSelectColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    GateSelectColumn[/** column name */ "Id"] = "id";
    GateSelectColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    GateSelectColumn[/** column name */ "IsDynamicFee"] = "is_dynamic_fee";
    GateSelectColumn[/** column name */ "MerchantConstantFee"] = "merchant_constant_fee";
    GateSelectColumn[/** column name */ "MerchantFeeMinAmount"] = "merchant_fee_min_amount";
    GateSelectColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    GateSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateSelectColumn[/** column name */ "MerchantSettlementUsdtFeePercent"] = "merchant_settlement_usdt_fee_percent";
    GateSelectColumn[/** column name */ "MerchantTransactionDeclineFeeAmount"] = "merchant_transaction_decline_fee_amount";
    GateSelectColumn[/** column name */ "MerchantTransactionFeeAmount"] = "merchant_transaction_fee_amount";
    GateSelectColumn[/** column name */ "NeedsCode"] = "needs_code";
    GateSelectColumn[/** column name */ "OtpEnabled"] = "otp_enabled";
    GateSelectColumn[/** column name */ "PaymentLimitAmount"] = "payment_limit_amount";
    GateSelectColumn[/** column name */ "PaymentLimitDuration"] = "payment_limit_duration";
    GateSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    GateSelectColumn[/** column name */ "PocketReferenceGateId"] = "pocket_reference_gate_id";
    GateSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    GateSelectColumn[/** column name */ "PublishedAt"] = "published_at";
    GateSelectColumn[/** column name */ "RefundFeeAmount"] = "refund_fee_amount";
    GateSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    GateSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    GateSelectColumn[/** column name */ "ServiceId"] = "service_id";
    GateSelectColumn[/** column name */ "SettlementUsdtFeePercent"] = "settlement_usdt_fee_percent";
    GateSelectColumn[/** column name */ "Sort"] = "sort";
    GateSelectColumn[/** column name */ "TrafficTypeId"] = "traffic_type_id";
    GateSelectColumn[/** column name */ "TransactionFeeAmount"] = "transaction_fee_amount";
    GateSelectColumn[/** column name */ "UnlockedAt"] = "unlocked_at";
    GateSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateSelectColumn || (GateSelectColumn = {}));
var GateTypeConstraint;
(function(GateTypeConstraint) {
    GateTypeConstraint[/** unique or primary key constraint on columns "id" */ "GateTypePkey"] = "gate_type_pkey";
})(GateTypeConstraint || (GateTypeConstraint = {}));
var GateTypeSelectColumn;
(function(GateTypeSelectColumn) {
    GateTypeSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    GateTypeSelectColumn[/** column name */ "Id"] = "id";
})(GateTypeSelectColumn || (GateTypeSelectColumn = {}));
var GateTypeUpdateColumn;
(function(GateTypeUpdateColumn) {
    GateTypeUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    GateTypeUpdateColumn[/** column name */ "Id"] = "id";
})(GateTypeUpdateColumn || (GateTypeUpdateColumn = {}));
var GateUpdateColumn;
(function(GateUpdateColumn) {
    GateUpdateColumn[/** column name */ "Alias"] = "alias";
    GateUpdateColumn[/** column name */ "BlockedAt"] = "blocked_at";
    GateUpdateColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    GateUpdateColumn[/** column name */ "CanRecurrent"] = "can_recurrent";
    GateUpdateColumn[/** column name */ "CardSystem"] = "card_system";
    GateUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    GateUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    GateUpdateColumn[/** column name */ "DeletedAt"] = "deleted_at";
    GateUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    GateUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    GateUpdateColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    GateUpdateColumn[/** column name */ "Id"] = "id";
    GateUpdateColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    GateUpdateColumn[/** column name */ "IsDynamicFee"] = "is_dynamic_fee";
    GateUpdateColumn[/** column name */ "MerchantConstantFee"] = "merchant_constant_fee";
    GateUpdateColumn[/** column name */ "MerchantFeeMinAmount"] = "merchant_fee_min_amount";
    GateUpdateColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    GateUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    GateUpdateColumn[/** column name */ "MerchantSettlementUsdtFeePercent"] = "merchant_settlement_usdt_fee_percent";
    GateUpdateColumn[/** column name */ "MerchantTransactionDeclineFeeAmount"] = "merchant_transaction_decline_fee_amount";
    GateUpdateColumn[/** column name */ "MerchantTransactionFeeAmount"] = "merchant_transaction_fee_amount";
    GateUpdateColumn[/** column name */ "NeedsCode"] = "needs_code";
    GateUpdateColumn[/** column name */ "OtpEnabled"] = "otp_enabled";
    GateUpdateColumn[/** column name */ "PaymentLimitAmount"] = "payment_limit_amount";
    GateUpdateColumn[/** column name */ "PaymentLimitDuration"] = "payment_limit_duration";
    GateUpdateColumn[/** column name */ "PaymentSystem"] = "payment_system";
    GateUpdateColumn[/** column name */ "PocketReferenceGateId"] = "pocket_reference_gate_id";
    GateUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    GateUpdateColumn[/** column name */ "PublishedAt"] = "published_at";
    GateUpdateColumn[/** column name */ "RefundFeeAmount"] = "refund_fee_amount";
    GateUpdateColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    GateUpdateColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    GateUpdateColumn[/** column name */ "ServiceId"] = "service_id";
    GateUpdateColumn[/** column name */ "SettlementUsdtFeePercent"] = "settlement_usdt_fee_percent";
    GateUpdateColumn[/** column name */ "Sort"] = "sort";
    GateUpdateColumn[/** column name */ "TrafficTypeId"] = "traffic_type_id";
    GateUpdateColumn[/** column name */ "TransactionFeeAmount"] = "transaction_fee_amount";
    GateUpdateColumn[/** column name */ "UnlockedAt"] = "unlocked_at";
    GateUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(GateUpdateColumn || (GateUpdateColumn = {}));
var GenderConstraint;
(function(GenderConstraint) {
    GenderConstraint[/** unique or primary key constraint on columns "id" */ "GenderPkey"] = "gender_pkey";
})(GenderConstraint || (GenderConstraint = {}));
var GenderSelectColumn;
(function(GenderSelectColumn) {
    GenderSelectColumn[/** column name */ "Id"] = "id";
    GenderSelectColumn[/** column name */ "Name"] = "name";
})(GenderSelectColumn || (GenderSelectColumn = {}));
var GenderUpdateColumn;
(function(GenderUpdateColumn) {
    GenderUpdateColumn[/** column name */ "Id"] = "id";
    GenderUpdateColumn[/** column name */ "Name"] = "name";
})(GenderUpdateColumn || (GenderUpdateColumn = {}));
var HelpConstraint;
(function(HelpConstraint) {
    HelpConstraint[/** unique or primary key constraint on columns "id" */ "HelpPkey"] = "help_pkey";
})(HelpConstraint || (HelpConstraint = {}));
var HelpSectionConstraint;
(function(HelpSectionConstraint) {
    HelpSectionConstraint[/** unique or primary key constraint on columns "id" */ "HelpSectionPkey"] = "help_section_pkey";
})(HelpSectionConstraint || (HelpSectionConstraint = {}));
var HelpSectionSelectColumn;
(function(HelpSectionSelectColumn) {
    HelpSectionSelectColumn[/** column name */ "Id"] = "id";
    HelpSectionSelectColumn[/** column name */ "LanguageId"] = "language_id";
    HelpSectionSelectColumn[/** column name */ "Name"] = "name";
})(HelpSectionSelectColumn || (HelpSectionSelectColumn = {}));
var HelpSectionUpdateColumn;
(function(HelpSectionUpdateColumn) {
    HelpSectionUpdateColumn[/** column name */ "Id"] = "id";
    HelpSectionUpdateColumn[/** column name */ "LanguageId"] = "language_id";
    HelpSectionUpdateColumn[/** column name */ "Name"] = "name";
})(HelpSectionUpdateColumn || (HelpSectionUpdateColumn = {}));
var HelpSelectColumn;
(function(HelpSelectColumn) {
    HelpSelectColumn[/** column name */ "Answer"] = "answer";
    HelpSelectColumn[/** column name */ "HelpSectionId"] = "help_section_id";
    HelpSelectColumn[/** column name */ "Id"] = "id";
    HelpSelectColumn[/** column name */ "Question"] = "question";
})(HelpSelectColumn || (HelpSelectColumn = {}));
var HelpUpdateColumn;
(function(HelpUpdateColumn) {
    HelpUpdateColumn[/** column name */ "Answer"] = "answer";
    HelpUpdateColumn[/** column name */ "HelpSectionId"] = "help_section_id";
    HelpUpdateColumn[/** column name */ "Id"] = "id";
    HelpUpdateColumn[/** column name */ "Question"] = "question";
})(HelpUpdateColumn || (HelpUpdateColumn = {}));
var InvoiceConstraint;
(function(InvoiceConstraint) {
    InvoiceConstraint[/** unique or primary key constraint on columns "external_id", "merchant_id", "gate_id" */ "InvoiceMerchantIdExternalIdGateIdKey"] = "invoice_merchant_id_external_id_gate_id_key";
    InvoiceConstraint[/** unique or primary key constraint on columns "id" */ "InvoicePkey"] = "invoice_pkey";
    InvoiceConstraint[/** unique or primary key constraint on columns "provider_transaction_uid" */ "InvoiceUidKey"] = "invoice_uid_key";
    InvoiceConstraint[/** unique or primary key constraint on columns "transaction_uid" */ "TransactionUidKey"] = "transaction_uid_key";
})(InvoiceConstraint || (InvoiceConstraint = {}));
var InvoiceSelectColumn;
(function(InvoiceSelectColumn) {
    InvoiceSelectColumn[/** column name */ "AdditionalData"] = "additional_data";
    InvoiceSelectColumn[/** column name */ "Amount"] = "amount";
    InvoiceSelectColumn[/** column name */ "BankId"] = "bank_id";
    InvoiceSelectColumn[/** column name */ "CallbackUrl"] = "callback_url";
    InvoiceSelectColumn[/** column name */ "CardSystemId"] = "card_system_id";
    InvoiceSelectColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    InvoiceSelectColumn[/** column name */ "ClientIp"] = "client_ip";
    InvoiceSelectColumn[/** column name */ "Comment"] = "comment";
    InvoiceSelectColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    InvoiceSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    InvoiceSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    InvoiceSelectColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    InvoiceSelectColumn[/** column name */ "ExternalId"] = "external_id";
    InvoiceSelectColumn[/** column name */ "FormMethod"] = "form_method";
    InvoiceSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    InvoiceSelectColumn[/** column name */ "GateId"] = "gate_id";
    InvoiceSelectColumn[/** column name */ "Id"] = "id";
    InvoiceSelectColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    InvoiceSelectColumn[/** column name */ "Invoice_3dsUrl"] = "invoice_3ds_url";
    InvoiceSelectColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    InvoiceSelectColumn[/** column name */ "InvoiceUrl"] = "invoice_url";
    InvoiceSelectColumn[/** column name */ "IsChargeback"] = "is_chargeback";
    InvoiceSelectColumn[/** column name */ "IsHidden"] = "is_hidden";
    InvoiceSelectColumn[/** column name */ "IsManual"] = "is_manual";
    InvoiceSelectColumn[/** column name */ "IsRecurrent"] = "is_recurrent";
    InvoiceSelectColumn[/** column name */ "IsRefund"] = "is_refund";
    InvoiceSelectColumn[/** column name */ "IsUnhold"] = "is_unhold";
    InvoiceSelectColumn[/** column name */ "IssuePaymentToken"] = "issue_payment_token";
    InvoiceSelectColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    InvoiceSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeIsPayed"] = "merchant_invoice_decline_transaction_fee_is_payed";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceFee"] = "merchant_invoice_fee";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    InvoiceSelectColumn[/** column name */ "MerchantInvoiceTransactionFeeIsPayed"] = "merchant_invoice_transaction_fee_is_payed";
    InvoiceSelectColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    InvoiceSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    InvoiceSelectColumn[/** column name */ "PersonalData"] = "personal_data";
    InvoiceSelectColumn[/** column name */ "Profit"] = "profit";
    InvoiceSelectColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    InvoiceSelectColumn[/** column name */ "ProviderFamily"] = "provider_family";
    InvoiceSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    InvoiceSelectColumn[/** column name */ "ProviderInvoiceFee"] = "provider_invoice_fee";
    InvoiceSelectColumn[/** column name */ "ProviderInvoiceFeePercent"] = "provider_invoice_fee_percent";
    InvoiceSelectColumn[/** column name */ "ProviderInvoiceId"] = "provider_invoice_id";
    InvoiceSelectColumn[/** column name */ "ProviderPaymentSystem"] = "provider_payment_system";
    InvoiceSelectColumn[/** column name */ "ProviderRawStatus"] = "provider_raw_status";
    InvoiceSelectColumn[/** column name */ "ProviderStatus"] = "provider_status";
    InvoiceSelectColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    InvoiceSelectColumn[/** column name */ "Recalculated"] = "recalculated";
    InvoiceSelectColumn[/** column name */ "RecalculatedAt"] = "recalculated_at";
    InvoiceSelectColumn[/** column name */ "ReconciliatedAt"] = "reconciliated_at";
    InvoiceSelectColumn[/** column name */ "ReconciliationProviderFee"] = "reconciliation_provider_fee";
    InvoiceSelectColumn[/** column name */ "RecurrentToken"] = "recurrent_token";
    InvoiceSelectColumn[/** column name */ "RedirectFailedUrl"] = "redirect_failed_url";
    InvoiceSelectColumn[/** column name */ "RedirectSuccessUrl"] = "redirect_success_url";
    InvoiceSelectColumn[/** column name */ "Refund"] = "refund";
    InvoiceSelectColumn[/** column name */ "RefundAmount"] = "refund_amount";
    InvoiceSelectColumn[/** column name */ "Remark"] = "remark";
    InvoiceSelectColumn[/** column name */ "RollingReserveAmount"] = "rolling_reserve_amount";
    InvoiceSelectColumn[/** column name */ "RollingReserveExpiredAt"] = "rolling_reserve_expired_at";
    InvoiceSelectColumn[/** column name */ "RollingReserveUnholdAt"] = "rolling_reserve_unhold_at";
    InvoiceSelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    InvoiceSelectColumn[/** column name */ "SmartRemark"] = "smart_remark";
    InvoiceSelectColumn[/** column name */ "Status"] = "status";
    InvoiceSelectColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    InvoiceSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    InvoiceSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(InvoiceSelectColumn || (InvoiceSelectColumn = {}));
var InvoiceUpdateColumn;
(function(InvoiceUpdateColumn) {
    InvoiceUpdateColumn[/** column name */ "AdditionalData"] = "additional_data";
    InvoiceUpdateColumn[/** column name */ "Amount"] = "amount";
    InvoiceUpdateColumn[/** column name */ "BankId"] = "bank_id";
    InvoiceUpdateColumn[/** column name */ "CallbackUrl"] = "callback_url";
    InvoiceUpdateColumn[/** column name */ "CardSystemId"] = "card_system_id";
    InvoiceUpdateColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    InvoiceUpdateColumn[/** column name */ "ClientIp"] = "client_ip";
    InvoiceUpdateColumn[/** column name */ "Comment"] = "comment";
    InvoiceUpdateColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    InvoiceUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    InvoiceUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    InvoiceUpdateColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    InvoiceUpdateColumn[/** column name */ "ExternalId"] = "external_id";
    InvoiceUpdateColumn[/** column name */ "FormMethod"] = "form_method";
    InvoiceUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    InvoiceUpdateColumn[/** column name */ "GateId"] = "gate_id";
    InvoiceUpdateColumn[/** column name */ "Id"] = "id";
    InvoiceUpdateColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    InvoiceUpdateColumn[/** column name */ "Invoice_3dsUrl"] = "invoice_3ds_url";
    InvoiceUpdateColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    InvoiceUpdateColumn[/** column name */ "InvoiceUrl"] = "invoice_url";
    InvoiceUpdateColumn[/** column name */ "IsChargeback"] = "is_chargeback";
    InvoiceUpdateColumn[/** column name */ "IsHidden"] = "is_hidden";
    InvoiceUpdateColumn[/** column name */ "IsManual"] = "is_manual";
    InvoiceUpdateColumn[/** column name */ "IsRecurrent"] = "is_recurrent";
    InvoiceUpdateColumn[/** column name */ "IsRefund"] = "is_refund";
    InvoiceUpdateColumn[/** column name */ "IsUnhold"] = "is_unhold";
    InvoiceUpdateColumn[/** column name */ "IssuePaymentToken"] = "issue_payment_token";
    InvoiceUpdateColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    InvoiceUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeIsPayed"] = "merchant_invoice_decline_transaction_fee_is_payed";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceFee"] = "merchant_invoice_fee";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    InvoiceUpdateColumn[/** column name */ "MerchantInvoiceTransactionFeeIsPayed"] = "merchant_invoice_transaction_fee_is_payed";
    InvoiceUpdateColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    InvoiceUpdateColumn[/** column name */ "PaymentSystem"] = "payment_system";
    InvoiceUpdateColumn[/** column name */ "PersonalData"] = "personal_data";
    InvoiceUpdateColumn[/** column name */ "Profit"] = "profit";
    InvoiceUpdateColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    InvoiceUpdateColumn[/** column name */ "ProviderFamily"] = "provider_family";
    InvoiceUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    InvoiceUpdateColumn[/** column name */ "ProviderInvoiceFee"] = "provider_invoice_fee";
    InvoiceUpdateColumn[/** column name */ "ProviderInvoiceFeePercent"] = "provider_invoice_fee_percent";
    InvoiceUpdateColumn[/** column name */ "ProviderInvoiceId"] = "provider_invoice_id";
    InvoiceUpdateColumn[/** column name */ "ProviderPaymentSystem"] = "provider_payment_system";
    InvoiceUpdateColumn[/** column name */ "ProviderRawStatus"] = "provider_raw_status";
    InvoiceUpdateColumn[/** column name */ "ProviderStatus"] = "provider_status";
    InvoiceUpdateColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    InvoiceUpdateColumn[/** column name */ "Recalculated"] = "recalculated";
    InvoiceUpdateColumn[/** column name */ "RecalculatedAt"] = "recalculated_at";
    InvoiceUpdateColumn[/** column name */ "ReconciliatedAt"] = "reconciliated_at";
    InvoiceUpdateColumn[/** column name */ "ReconciliationProviderFee"] = "reconciliation_provider_fee";
    InvoiceUpdateColumn[/** column name */ "RecurrentToken"] = "recurrent_token";
    InvoiceUpdateColumn[/** column name */ "RedirectFailedUrl"] = "redirect_failed_url";
    InvoiceUpdateColumn[/** column name */ "RedirectSuccessUrl"] = "redirect_success_url";
    InvoiceUpdateColumn[/** column name */ "Refund"] = "refund";
    InvoiceUpdateColumn[/** column name */ "RefundAmount"] = "refund_amount";
    InvoiceUpdateColumn[/** column name */ "Remark"] = "remark";
    InvoiceUpdateColumn[/** column name */ "RollingReserveAmount"] = "rolling_reserve_amount";
    InvoiceUpdateColumn[/** column name */ "RollingReserveExpiredAt"] = "rolling_reserve_expired_at";
    InvoiceUpdateColumn[/** column name */ "RollingReserveUnholdAt"] = "rolling_reserve_unhold_at";
    InvoiceUpdateColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    InvoiceUpdateColumn[/** column name */ "SmartRemark"] = "smart_remark";
    InvoiceUpdateColumn[/** column name */ "Status"] = "status";
    InvoiceUpdateColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    InvoiceUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    InvoiceUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(InvoiceUpdateColumn || (InvoiceUpdateColumn = {}));
var LanguageConstraint;
(function(LanguageConstraint) {
    LanguageConstraint[/** unique or primary key constraint on columns "id" */ "LanguagePkey"] = "language_pkey";
})(LanguageConstraint || (LanguageConstraint = {}));
var LanguageSelectColumn;
(function(LanguageSelectColumn) {
    LanguageSelectColumn[/** column name */ "Id"] = "id";
    LanguageSelectColumn[/** column name */ "Name"] = "name";
})(LanguageSelectColumn || (LanguageSelectColumn = {}));
var LanguageUpdateColumn;
(function(LanguageUpdateColumn) {
    LanguageUpdateColumn[/** column name */ "Id"] = "id";
    LanguageUpdateColumn[/** column name */ "Name"] = "name";
})(LanguageUpdateColumn || (LanguageUpdateColumn = {}));
var MerchantApiTokenConstraint;
(function(MerchantApiTokenConstraint) {
    MerchantApiTokenConstraint[/** unique or primary key constraint on columns "id" */ "MerchantApiTokenPkey"] = "merchant_api_token_pkey";
    MerchantApiTokenConstraint[/** unique or primary key constraint on columns "token" */ "MerchantApiTokenTokenKey"] = "merchant_api_token_token_key";
})(MerchantApiTokenConstraint || (MerchantApiTokenConstraint = {}));
var MerchantApiTokenSelectColumn;
(function(MerchantApiTokenSelectColumn) {
    MerchantApiTokenSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantApiTokenSelectColumn[/** column name */ "Id"] = "id";
    MerchantApiTokenSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantApiTokenSelectColumn[/** column name */ "Name"] = "name";
    MerchantApiTokenSelectColumn[/** column name */ "Token"] = "token";
})(MerchantApiTokenSelectColumn || (MerchantApiTokenSelectColumn = {}));
var MerchantApiTokenUpdateColumn;
(function(MerchantApiTokenUpdateColumn) {
    MerchantApiTokenUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantApiTokenUpdateColumn[/** column name */ "Id"] = "id";
    MerchantApiTokenUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantApiTokenUpdateColumn[/** column name */ "Name"] = "name";
    MerchantApiTokenUpdateColumn[/** column name */ "Token"] = "token";
})(MerchantApiTokenUpdateColumn || (MerchantApiTokenUpdateColumn = {}));
var MerchantBalanceConstraint;
(function(MerchantBalanceConstraint) {
    MerchantBalanceConstraint[/** unique or primary key constraint on columns "provider_id", "is_total", "currency_id", "merchant_id" */ "MerchantBalanceMerchantIdCurrencyIdProviderIdIsTotalK"] = "merchant_balance_merchant_id_currency_id_provider_id_is_total_k";
    MerchantBalanceConstraint[/** unique or primary key constraint on columns "id" */ "MerchantBalancePkey"] = "merchant_balance_pkey";
})(MerchantBalanceConstraint || (MerchantBalanceConstraint = {}));
var MerchantBalanceSelectColumn;
(function(MerchantBalanceSelectColumn) {
    MerchantBalanceSelectColumn[/** column name */ "Balance"] = "balance";
    MerchantBalanceSelectColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    MerchantBalanceSelectColumn[/** column name */ "CalculatedHoldBalance"] = "calculated_hold_balance";
    MerchantBalanceSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantBalanceSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantBalanceSelectColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    MerchantBalanceSelectColumn[/** column name */ "HoldBalance"] = "hold_balance";
    MerchantBalanceSelectColumn[/** column name */ "Id"] = "id";
    MerchantBalanceSelectColumn[/** column name */ "IsTotal"] = "is_total";
    MerchantBalanceSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantBalanceSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    MerchantBalanceSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantBalanceSelectColumn || (MerchantBalanceSelectColumn = {}));
var MerchantBalanceUpdateColumn;
(function(MerchantBalanceUpdateColumn) {
    MerchantBalanceUpdateColumn[/** column name */ "Balance"] = "balance";
    MerchantBalanceUpdateColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    MerchantBalanceUpdateColumn[/** column name */ "CalculatedHoldBalance"] = "calculated_hold_balance";
    MerchantBalanceUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantBalanceUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantBalanceUpdateColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    MerchantBalanceUpdateColumn[/** column name */ "HoldBalance"] = "hold_balance";
    MerchantBalanceUpdateColumn[/** column name */ "Id"] = "id";
    MerchantBalanceUpdateColumn[/** column name */ "IsTotal"] = "is_total";
    MerchantBalanceUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantBalanceUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    MerchantBalanceUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantBalanceUpdateColumn || (MerchantBalanceUpdateColumn = {}));
var MerchantConstraint;
(function(MerchantConstraint) {
    MerchantConstraint[/** unique or primary key constraint on columns "api_token" */ "MerchantApiTokenKey"] = "merchant_api_token_key";
    MerchantConstraint[/** unique or primary key constraint on columns "id" */ "MerchantPkey"] = "merchant_pkey";
    MerchantConstraint[/** unique or primary key constraint on columns "secret_key" */ "MerchantSecretKeyKey"] = "merchant_secret_key_key";
})(MerchantConstraint || (MerchantConstraint = {}));
var MerchantCurrencyConstraint;
(function(MerchantCurrencyConstraint) {
    MerchantCurrencyConstraint[/** unique or primary key constraint on columns "currency_id", "merchant_id" */ "MerchantCurrencyMerchantIdCurrencyIdKey"] = "merchant_currency_merchant_id_currency_id_key";
    MerchantCurrencyConstraint[/** unique or primary key constraint on columns "id" */ "MerchantCurrencyPkey"] = "merchant_currency_pkey";
})(MerchantCurrencyConstraint || (MerchantCurrencyConstraint = {}));
var MerchantCurrencySelectColumn;
(function(MerchantCurrencySelectColumn) {
    MerchantCurrencySelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantCurrencySelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantCurrencySelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantCurrencySelectColumn[/** column name */ "Id"] = "id";
    MerchantCurrencySelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantCurrencySelectColumn[/** column name */ "ShowInHeader"] = "show_in_header";
    MerchantCurrencySelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantCurrencySelectColumn || (MerchantCurrencySelectColumn = {}));
var MerchantCurrencyUpdateColumn;
(function(MerchantCurrencyUpdateColumn) {
    MerchantCurrencyUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantCurrencyUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantCurrencyUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantCurrencyUpdateColumn[/** column name */ "Id"] = "id";
    MerchantCurrencyUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantCurrencyUpdateColumn[/** column name */ "ShowInHeader"] = "show_in_header";
    MerchantCurrencyUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantCurrencyUpdateColumn || (MerchantCurrencyUpdateColumn = {}));
var MerchantFeeConstraint;
(function(MerchantFeeConstraint) {
    MerchantFeeConstraint[/** unique or primary key constraint on columns "provider_id", "currency_id", "merchant_id" */ "MerchantFeeMerchantIdCurrencyIdProviderIdKey"] = "merchant_fee_merchant_id_currency_id_provider_id_key";
    MerchantFeeConstraint[/** unique or primary key constraint on columns "id" */ "MerchantFeePkey"] = "merchant_fee_pkey";
})(MerchantFeeConstraint || (MerchantFeeConstraint = {}));
var MerchantFeeSelectColumn;
(function(MerchantFeeSelectColumn) {
    MerchantFeeSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantFeeSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantFeeSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantFeeSelectColumn[/** column name */ "Id"] = "id";
    MerchantFeeSelectColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    MerchantFeeSelectColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    MerchantFeeSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantFeeSelectColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    MerchantFeeSelectColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    MerchantFeeSelectColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    MerchantFeeSelectColumn[/** column name */ "MerchantWithdrawSettlementUsdtFeePercent"] = "merchant_withdraw_settlement_usdt_fee_percent";
    MerchantFeeSelectColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    MerchantFeeSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    MerchantFeeSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    MerchantFeeSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    MerchantFeeSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantFeeSelectColumn[/** column name */ "WithdrawSettlementUsdtFeePercent"] = "withdraw_settlement_usdt_fee_percent";
    MerchantFeeSelectColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
})(MerchantFeeSelectColumn || (MerchantFeeSelectColumn = {}));
var MerchantFeeUpdateColumn;
(function(MerchantFeeUpdateColumn) {
    MerchantFeeUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantFeeUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    MerchantFeeUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantFeeUpdateColumn[/** column name */ "Id"] = "id";
    MerchantFeeUpdateColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    MerchantFeeUpdateColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    MerchantFeeUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantFeeUpdateColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    MerchantFeeUpdateColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    MerchantFeeUpdateColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    MerchantFeeUpdateColumn[/** column name */ "MerchantWithdrawSettlementUsdtFeePercent"] = "merchant_withdraw_settlement_usdt_fee_percent";
    MerchantFeeUpdateColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    MerchantFeeUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    MerchantFeeUpdateColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    MerchantFeeUpdateColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    MerchantFeeUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantFeeUpdateColumn[/** column name */ "WithdrawSettlementUsdtFeePercent"] = "withdraw_settlement_usdt_fee_percent";
    MerchantFeeUpdateColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
})(MerchantFeeUpdateColumn || (MerchantFeeUpdateColumn = {}));
var MerchantFileConstraint;
(function(MerchantFileConstraint) {
    MerchantFileConstraint[/** unique or primary key constraint on columns "id" */ "MerchantFilePkey"] = "merchant_file_pkey";
})(MerchantFileConstraint || (MerchantFileConstraint = {}));
var MerchantFileSelectColumn;
(function(MerchantFileSelectColumn) {
    MerchantFileSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantFileSelectColumn[/** column name */ "FilePath"] = "file_path";
    MerchantFileSelectColumn[/** column name */ "Id"] = "id";
    MerchantFileSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantFileSelectColumn[/** column name */ "MerchantTaskId"] = "merchant_task_id";
    MerchantFileSelectColumn[/** column name */ "Status"] = "status";
    MerchantFileSelectColumn[/** column name */ "Type"] = "type";
    MerchantFileSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantFileSelectColumn[/** column name */ "UploadFileName"] = "upload_file_name";
})(MerchantFileSelectColumn || (MerchantFileSelectColumn = {}));
var MerchantFileUpdateColumn;
(function(MerchantFileUpdateColumn) {
    MerchantFileUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantFileUpdateColumn[/** column name */ "FilePath"] = "file_path";
    MerchantFileUpdateColumn[/** column name */ "Id"] = "id";
    MerchantFileUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantFileUpdateColumn[/** column name */ "MerchantTaskId"] = "merchant_task_id";
    MerchantFileUpdateColumn[/** column name */ "Status"] = "status";
    MerchantFileUpdateColumn[/** column name */ "Type"] = "type";
    MerchantFileUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantFileUpdateColumn[/** column name */ "UploadFileName"] = "upload_file_name";
})(MerchantFileUpdateColumn || (MerchantFileUpdateColumn = {}));
var MerchantInfoConstraint;
(function(MerchantInfoConstraint) {
    MerchantInfoConstraint[/** unique or primary key constraint on columns "merchant_id" */ "MerchantInfoPkey"] = "merchant_info_pkey";
})(MerchantInfoConstraint || (MerchantInfoConstraint = {}));
var MerchantInfoSelectColumn;
(function(MerchantInfoSelectColumn) {
    MerchantInfoSelectColumn[/** column name */ "BusinessAddress"] = "business_address";
    MerchantInfoSelectColumn[/** column name */ "ChargebackRatio"] = "chargeback_ratio";
    MerchantInfoSelectColumn[/** column name */ "Comment"] = "comment";
    MerchantInfoSelectColumn[/** column name */ "CompanyName"] = "company_name";
    MerchantInfoSelectColumn[/** column name */ "CompanyWebsite"] = "company_website";
    MerchantInfoSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantInfoSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantInfoSelectColumn[/** column name */ "Id"] = "id";
    MerchantInfoSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantInfoSelectColumn[/** column name */ "MonthTurnover"] = "month_turnover";
    MerchantInfoSelectColumn[/** column name */ "PaymentsGeo"] = "payments_geo";
    MerchantInfoSelectColumn[/** column name */ "RegisteredAddress"] = "registered_address";
    MerchantInfoSelectColumn[/** column name */ "RegistrationData"] = "registration_data";
    MerchantInfoSelectColumn[/** column name */ "RegistrationNumber"] = "registration_number";
    MerchantInfoSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantInfoSelectColumn || (MerchantInfoSelectColumn = {}));
var MerchantInfoUpdateColumn;
(function(MerchantInfoUpdateColumn) {
    MerchantInfoUpdateColumn[/** column name */ "BusinessAddress"] = "business_address";
    MerchantInfoUpdateColumn[/** column name */ "ChargebackRatio"] = "chargeback_ratio";
    MerchantInfoUpdateColumn[/** column name */ "Comment"] = "comment";
    MerchantInfoUpdateColumn[/** column name */ "CompanyName"] = "company_name";
    MerchantInfoUpdateColumn[/** column name */ "CompanyWebsite"] = "company_website";
    MerchantInfoUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantInfoUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantInfoUpdateColumn[/** column name */ "Id"] = "id";
    MerchantInfoUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantInfoUpdateColumn[/** column name */ "MonthTurnover"] = "month_turnover";
    MerchantInfoUpdateColumn[/** column name */ "PaymentsGeo"] = "payments_geo";
    MerchantInfoUpdateColumn[/** column name */ "RegisteredAddress"] = "registered_address";
    MerchantInfoUpdateColumn[/** column name */ "RegistrationData"] = "registration_data";
    MerchantInfoUpdateColumn[/** column name */ "RegistrationNumber"] = "registration_number";
    MerchantInfoUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantInfoUpdateColumn || (MerchantInfoUpdateColumn = {}));
var MerchantIpWhitelistConstraint;
(function(MerchantIpWhitelistConstraint) {
    MerchantIpWhitelistConstraint[/** unique or primary key constraint on columns "merchant_id", "ip_cidr" */ "MerchantIpWhitelistMerchantIdIpCidrKey"] = "merchant_ip_whitelist_merchant_id_ip_cidr_key";
    MerchantIpWhitelistConstraint[/** unique or primary key constraint on columns "id" */ "MerchantIpWhitelistPkey"] = "merchant_ip_whitelist_pkey";
})(MerchantIpWhitelistConstraint || (MerchantIpWhitelistConstraint = {}));
var MerchantIpWhitelistSelectColumn;
(function(MerchantIpWhitelistSelectColumn) {
    MerchantIpWhitelistSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantIpWhitelistSelectColumn[/** column name */ "CreatedBy"] = "created_by";
    MerchantIpWhitelistSelectColumn[/** column name */ "Description"] = "description";
    MerchantIpWhitelistSelectColumn[/** column name */ "Id"] = "id";
    MerchantIpWhitelistSelectColumn[/** column name */ "IpCidr"] = "ip_cidr";
    MerchantIpWhitelistSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
})(MerchantIpWhitelistSelectColumn || (MerchantIpWhitelistSelectColumn = {}));
var MerchantIpWhitelistUpdateColumn;
(function(MerchantIpWhitelistUpdateColumn) {
    MerchantIpWhitelistUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantIpWhitelistUpdateColumn[/** column name */ "CreatedBy"] = "created_by";
    MerchantIpWhitelistUpdateColumn[/** column name */ "Description"] = "description";
    MerchantIpWhitelistUpdateColumn[/** column name */ "Id"] = "id";
    MerchantIpWhitelistUpdateColumn[/** column name */ "IpCidr"] = "ip_cidr";
    MerchantIpWhitelistUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
})(MerchantIpWhitelistUpdateColumn || (MerchantIpWhitelistUpdateColumn = {}));
var MerchantNotificationConstraint;
(function(MerchantNotificationConstraint) {
    MerchantNotificationConstraint[/** unique or primary key constraint on columns "id" */ "MerchantNotificationPkey"] = "merchant_notification_pkey";
})(MerchantNotificationConstraint || (MerchantNotificationConstraint = {}));
var MerchantNotificationSelectColumn;
(function(MerchantNotificationSelectColumn) {
    MerchantNotificationSelectColumn[/** column name */ "Active"] = "active";
    MerchantNotificationSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantNotificationSelectColumn[/** column name */ "Id"] = "id";
    MerchantNotificationSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantNotificationSelectColumn[/** column name */ "NotificationTypeId"] = "notification_type_id";
    MerchantNotificationSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantNotificationSelectColumn[/** column name */ "Value"] = "value";
})(MerchantNotificationSelectColumn || (MerchantNotificationSelectColumn = {}));
var MerchantNotificationUpdateColumn;
(function(MerchantNotificationUpdateColumn) {
    MerchantNotificationUpdateColumn[/** column name */ "Active"] = "active";
    MerchantNotificationUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantNotificationUpdateColumn[/** column name */ "Id"] = "id";
    MerchantNotificationUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantNotificationUpdateColumn[/** column name */ "NotificationTypeId"] = "notification_type_id";
    MerchantNotificationUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantNotificationUpdateColumn[/** column name */ "Value"] = "value";
})(MerchantNotificationUpdateColumn || (MerchantNotificationUpdateColumn = {}));
var MerchantSelectColumn;
(function(MerchantSelectColumn) {
    MerchantSelectColumn[/** column name */ "ApiToken"] = "api_token";
    MerchantSelectColumn[/** column name */ "Balance"] = "balance";
    MerchantSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantSelectColumn[/** column name */ "CurrentProviderId"] = "current_provider_id";
    MerchantSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantSelectColumn[/** column name */ "HoldBalance"] = "hold_balance";
    MerchantSelectColumn[/** column name */ "Id"] = "id";
    MerchantSelectColumn[/** column name */ "InvoiceCallbackUrl"] = "invoice_callback_url";
    MerchantSelectColumn[/** column name */ "InvoiceEnabled"] = "invoice_enabled";
    MerchantSelectColumn[/** column name */ "InvoiceFeePercent"] = "invoice_fee_percent";
    MerchantSelectColumn[/** column name */ "InvoiceH2hEnabled"] = "invoice_h2h_enabled";
    MerchantSelectColumn[/** column name */ "InvoiceQiwiEnabled"] = "invoice_qiwi_enabled";
    MerchantSelectColumn[/** column name */ "InvoiceS2pEnabled"] = "invoice_s2p_enabled";
    MerchantSelectColumn[/** column name */ "IpWhitelistEnabled"] = "ip_whitelist_enabled";
    MerchantSelectColumn[/** column name */ "MassWithdrawEnabled"] = "mass_withdraw_enabled";
    MerchantSelectColumn[/** column name */ "MerchantStatusId"] = "merchant_status_id";
    MerchantSelectColumn[/** column name */ "MerchantTypeId"] = "merchant_type_id";
    MerchantSelectColumn[/** column name */ "QiwiMassWithdrawEnabled"] = "qiwi_mass_withdraw_enabled";
    MerchantSelectColumn[/** column name */ "RedirectFailedUrl"] = "redirect_failed_url";
    MerchantSelectColumn[/** column name */ "RedirectSuccessUrl"] = "redirect_success_url";
    MerchantSelectColumn[/** column name */ "RefundEnabled"] = "refund_enabled";
    MerchantSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    MerchantSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    MerchantSelectColumn[/** column name */ "S2pWithdrawEnabled"] = "s2p_withdraw_enabled";
    MerchantSelectColumn[/** column name */ "SecretKey"] = "secret_key";
    MerchantSelectColumn[/** column name */ "TelegramNotificationChatId"] = "telegram_notification_chat_id";
    MerchantSelectColumn[/** column name */ "TelegramNotificationEnabled"] = "telegram_notification_enabled";
    MerchantSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantSelectColumn[/** column name */ "WithdrawCallbackUrl"] = "withdraw_callback_url";
    MerchantSelectColumn[/** column name */ "WithdrawEnabled"] = "withdraw_enabled";
    MerchantSelectColumn[/** column name */ "WithdrawFeePercent"] = "withdraw_fee_percent";
})(MerchantSelectColumn || (MerchantSelectColumn = {}));
var MerchantTaskConstraint;
(function(MerchantTaskConstraint) {
    MerchantTaskConstraint[/** unique or primary key constraint on columns "id" */ "MerchantTaskPkey"] = "merchant_task_pkey";
})(MerchantTaskConstraint || (MerchantTaskConstraint = {}));
var MerchantTaskSelectColumn;
(function(MerchantTaskSelectColumn) {
    MerchantTaskSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantTaskSelectColumn[/** column name */ "DeliveredAt"] = "delivered_at";
    MerchantTaskSelectColumn[/** column name */ "Error"] = "error";
    MerchantTaskSelectColumn[/** column name */ "Id"] = "id";
    MerchantTaskSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantTaskSelectColumn[/** column name */ "MerchantTaskStatusId"] = "merchant_task_status_id";
    MerchantTaskSelectColumn[/** column name */ "MerchantTaskTypeId"] = "merchant_task_type_id";
    MerchantTaskSelectColumn[/** column name */ "Payload"] = "payload";
    MerchantTaskSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantTaskSelectColumn || (MerchantTaskSelectColumn = {}));
var MerchantTaskStatusConstraint;
(function(MerchantTaskStatusConstraint) {
    MerchantTaskStatusConstraint[/** unique or primary key constraint on columns "id" */ "MerchantTaskStatusPkey"] = "merchant_task_status_pkey";
})(MerchantTaskStatusConstraint || (MerchantTaskStatusConstraint = {}));
var MerchantTaskStatusSelectColumn;
(function(MerchantTaskStatusSelectColumn) {
    MerchantTaskStatusSelectColumn[/** column name */ "Id"] = "id";
    MerchantTaskStatusSelectColumn[/** column name */ "Name"] = "name";
})(MerchantTaskStatusSelectColumn || (MerchantTaskStatusSelectColumn = {}));
var MerchantTaskStatusUpdateColumn;
(function(MerchantTaskStatusUpdateColumn) {
    MerchantTaskStatusUpdateColumn[/** column name */ "Id"] = "id";
    MerchantTaskStatusUpdateColumn[/** column name */ "Name"] = "name";
})(MerchantTaskStatusUpdateColumn || (MerchantTaskStatusUpdateColumn = {}));
var MerchantTaskTypeConstraint;
(function(MerchantTaskTypeConstraint) {
    MerchantTaskTypeConstraint[/** unique or primary key constraint on columns "id" */ "MerchantTaskTypePkey"] = "merchant_task_type_pkey";
})(MerchantTaskTypeConstraint || (MerchantTaskTypeConstraint = {}));
var MerchantTaskTypeSelectColumn;
(function(MerchantTaskTypeSelectColumn) {
    MerchantTaskTypeSelectColumn[/** column name */ "Id"] = "id";
    MerchantTaskTypeSelectColumn[/** column name */ "Name"] = "name";
})(MerchantTaskTypeSelectColumn || (MerchantTaskTypeSelectColumn = {}));
var MerchantTaskTypeUpdateColumn;
(function(MerchantTaskTypeUpdateColumn) {
    MerchantTaskTypeUpdateColumn[/** column name */ "Id"] = "id";
    MerchantTaskTypeUpdateColumn[/** column name */ "Name"] = "name";
})(MerchantTaskTypeUpdateColumn || (MerchantTaskTypeUpdateColumn = {}));
var MerchantTaskUpdateColumn;
(function(MerchantTaskUpdateColumn) {
    MerchantTaskUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantTaskUpdateColumn[/** column name */ "DeliveredAt"] = "delivered_at";
    MerchantTaskUpdateColumn[/** column name */ "Error"] = "error";
    MerchantTaskUpdateColumn[/** column name */ "Id"] = "id";
    MerchantTaskUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantTaskUpdateColumn[/** column name */ "MerchantTaskStatusId"] = "merchant_task_status_id";
    MerchantTaskUpdateColumn[/** column name */ "MerchantTaskTypeId"] = "merchant_task_type_id";
    MerchantTaskUpdateColumn[/** column name */ "Payload"] = "payload";
    MerchantTaskUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantTaskUpdateColumn || (MerchantTaskUpdateColumn = {}));
var MerchantTourConstraint;
(function(MerchantTourConstraint) {
    MerchantTourConstraint[/** unique or primary key constraint on columns "id" */ "MerchantTourPkey"] = "merchant_tour_pkey";
})(MerchantTourConstraint || (MerchantTourConstraint = {}));
var MerchantTourSelectColumn;
(function(MerchantTourSelectColumn) {
    MerchantTourSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantTourSelectColumn[/** column name */ "CurrentStep"] = "current_step";
    MerchantTourSelectColumn[/** column name */ "Id"] = "id";
    MerchantTourSelectColumn[/** column name */ "IsCompleted"] = "is_completed";
    MerchantTourSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantTourSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantTourSelectColumn || (MerchantTourSelectColumn = {}));
var MerchantTourUpdateColumn;
(function(MerchantTourUpdateColumn) {
    MerchantTourUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantTourUpdateColumn[/** column name */ "CurrentStep"] = "current_step";
    MerchantTourUpdateColumn[/** column name */ "Id"] = "id";
    MerchantTourUpdateColumn[/** column name */ "IsCompleted"] = "is_completed";
    MerchantTourUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantTourUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(MerchantTourUpdateColumn || (MerchantTourUpdateColumn = {}));
var MerchantTypeConstraint;
(function(MerchantTypeConstraint) {
    MerchantTypeConstraint[/** unique or primary key constraint on columns "id" */ "MerchantTypePkey"] = "merchant_type_pkey";
})(MerchantTypeConstraint || (MerchantTypeConstraint = {}));
var MerchantTypeSelectColumn;
(function(MerchantTypeSelectColumn) {
    MerchantTypeSelectColumn[/** column name */ "Id"] = "id";
    MerchantTypeSelectColumn[/** column name */ "Name"] = "name";
})(MerchantTypeSelectColumn || (MerchantTypeSelectColumn = {}));
var MerchantTypeUpdateColumn;
(function(MerchantTypeUpdateColumn) {
    MerchantTypeUpdateColumn[/** column name */ "Id"] = "id";
    MerchantTypeUpdateColumn[/** column name */ "Name"] = "name";
})(MerchantTypeUpdateColumn || (MerchantTypeUpdateColumn = {}));
var MerchantUpdateColumn;
(function(MerchantUpdateColumn) {
    MerchantUpdateColumn[/** column name */ "ApiToken"] = "api_token";
    MerchantUpdateColumn[/** column name */ "Balance"] = "balance";
    MerchantUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantUpdateColumn[/** column name */ "CurrentProviderId"] = "current_provider_id";
    MerchantUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantUpdateColumn[/** column name */ "HoldBalance"] = "hold_balance";
    MerchantUpdateColumn[/** column name */ "Id"] = "id";
    MerchantUpdateColumn[/** column name */ "InvoiceCallbackUrl"] = "invoice_callback_url";
    MerchantUpdateColumn[/** column name */ "InvoiceEnabled"] = "invoice_enabled";
    MerchantUpdateColumn[/** column name */ "InvoiceFeePercent"] = "invoice_fee_percent";
    MerchantUpdateColumn[/** column name */ "InvoiceH2hEnabled"] = "invoice_h2h_enabled";
    MerchantUpdateColumn[/** column name */ "InvoiceQiwiEnabled"] = "invoice_qiwi_enabled";
    MerchantUpdateColumn[/** column name */ "InvoiceS2pEnabled"] = "invoice_s2p_enabled";
    MerchantUpdateColumn[/** column name */ "IpWhitelistEnabled"] = "ip_whitelist_enabled";
    MerchantUpdateColumn[/** column name */ "MassWithdrawEnabled"] = "mass_withdraw_enabled";
    MerchantUpdateColumn[/** column name */ "MerchantStatusId"] = "merchant_status_id";
    MerchantUpdateColumn[/** column name */ "MerchantTypeId"] = "merchant_type_id";
    MerchantUpdateColumn[/** column name */ "QiwiMassWithdrawEnabled"] = "qiwi_mass_withdraw_enabled";
    MerchantUpdateColumn[/** column name */ "RedirectFailedUrl"] = "redirect_failed_url";
    MerchantUpdateColumn[/** column name */ "RedirectSuccessUrl"] = "redirect_success_url";
    MerchantUpdateColumn[/** column name */ "RefundEnabled"] = "refund_enabled";
    MerchantUpdateColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    MerchantUpdateColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    MerchantUpdateColumn[/** column name */ "S2pWithdrawEnabled"] = "s2p_withdraw_enabled";
    MerchantUpdateColumn[/** column name */ "SecretKey"] = "secret_key";
    MerchantUpdateColumn[/** column name */ "TelegramNotificationChatId"] = "telegram_notification_chat_id";
    MerchantUpdateColumn[/** column name */ "TelegramNotificationEnabled"] = "telegram_notification_enabled";
    MerchantUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantUpdateColumn[/** column name */ "WithdrawCallbackUrl"] = "withdraw_callback_url";
    MerchantUpdateColumn[/** column name */ "WithdrawEnabled"] = "withdraw_enabled";
    MerchantUpdateColumn[/** column name */ "WithdrawFeePercent"] = "withdraw_fee_percent";
})(MerchantUpdateColumn || (MerchantUpdateColumn = {}));
var MerchantUserConstraint;
(function(MerchantUserConstraint) {
    MerchantUserConstraint[/** unique or primary key constraint on columns "id" */ "MerchantUserPkey"] = "merchant_user_pkey";
    MerchantUserConstraint[/** unique or primary key constraint on columns "user_id" */ "UserIdKey"] = "user_id_key";
})(MerchantUserConstraint || (MerchantUserConstraint = {}));
var MerchantUserRoleConstraint;
(function(MerchantUserRoleConstraint) {
    MerchantUserRoleConstraint[/** unique or primary key constraint on columns "id" */ "MerchantUserRolePkey"] = "merchant_user_role_pkey";
})(MerchantUserRoleConstraint || (MerchantUserRoleConstraint = {}));
var MerchantUserRoleSelectColumn;
(function(MerchantUserRoleSelectColumn) {
    MerchantUserRoleSelectColumn[/** column name */ "Id"] = "id";
    MerchantUserRoleSelectColumn[/** column name */ "Name"] = "name";
})(MerchantUserRoleSelectColumn || (MerchantUserRoleSelectColumn = {}));
var MerchantUserRoleUpdateColumn;
(function(MerchantUserRoleUpdateColumn) {
    MerchantUserRoleUpdateColumn[/** column name */ "Id"] = "id";
    MerchantUserRoleUpdateColumn[/** column name */ "Name"] = "name";
})(MerchantUserRoleUpdateColumn || (MerchantUserRoleUpdateColumn = {}));
var MerchantUserSelectColumn;
(function(MerchantUserSelectColumn) {
    MerchantUserSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantUserSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantUserSelectColumn[/** column name */ "Id"] = "id";
    MerchantUserSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantUserSelectColumn[/** column name */ "MerchantUserRoleId"] = "merchant_user_role_id";
    MerchantUserSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantUserSelectColumn[/** column name */ "UserId"] = "user_id";
})(MerchantUserSelectColumn || (MerchantUserSelectColumn = {}));
var MerchantUserUpdateColumn;
(function(MerchantUserUpdateColumn) {
    MerchantUserUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantUserUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    MerchantUserUpdateColumn[/** column name */ "Id"] = "id";
    MerchantUserUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantUserUpdateColumn[/** column name */ "MerchantUserRoleId"] = "merchant_user_role_id";
    MerchantUserUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantUserUpdateColumn[/** column name */ "UserId"] = "user_id";
})(MerchantUserUpdateColumn || (MerchantUserUpdateColumn = {}));
var MerchantWidgetConstraint;
(function(MerchantWidgetConstraint) {
    MerchantWidgetConstraint[/** unique or primary key constraint on columns "id" */ "MerchantWidgetPkey"] = "merchant_widget_pkey";
})(MerchantWidgetConstraint || (MerchantWidgetConstraint = {}));
var MerchantWidgetSelectColumn;
(function(MerchantWidgetSelectColumn) {
    MerchantWidgetSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantWidgetSelectColumn[/** column name */ "Id"] = "id";
    MerchantWidgetSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantWidgetSelectColumn[/** column name */ "Params"] = "params";
    MerchantWidgetSelectColumn[/** column name */ "Sort"] = "sort";
    MerchantWidgetSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantWidgetSelectColumn[/** column name */ "WidgetType"] = "widget_type";
})(MerchantWidgetSelectColumn || (MerchantWidgetSelectColumn = {}));
var MerchantWidgetUpdateColumn;
(function(MerchantWidgetUpdateColumn) {
    MerchantWidgetUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MerchantWidgetUpdateColumn[/** column name */ "Id"] = "id";
    MerchantWidgetUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    MerchantWidgetUpdateColumn[/** column name */ "Params"] = "params";
    MerchantWidgetUpdateColumn[/** column name */ "Sort"] = "sort";
    MerchantWidgetUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    MerchantWidgetUpdateColumn[/** column name */ "WidgetType"] = "widget_type";
})(MerchantWidgetUpdateColumn || (MerchantWidgetUpdateColumn = {}));
var MutexConstraint;
(function(MutexConstraint) {
    MutexConstraint[/** unique or primary key constraint on columns "id" */ "MutexPkey"] = "mutex_pkey";
})(MutexConstraint || (MutexConstraint = {}));
var MutexSelectColumn;
(function(MutexSelectColumn) {
    MutexSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    MutexSelectColumn[/** column name */ "Id"] = "id";
    MutexSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
})(MutexSelectColumn || (MutexSelectColumn = {}));
var MutexUpdateColumn;
(function(MutexUpdateColumn) {
    MutexUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    MutexUpdateColumn[/** column name */ "Id"] = "id";
    MutexUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
})(MutexUpdateColumn || (MutexUpdateColumn = {}));
var NotificationTypeConstraint;
(function(NotificationTypeConstraint) {
    NotificationTypeConstraint[/** unique or primary key constraint on columns "id" */ "NotificationTypePkey"] = "notification_type_pkey";
})(NotificationTypeConstraint || (NotificationTypeConstraint = {}));
var NotificationTypeSelectColumn;
(function(NotificationTypeSelectColumn) {
    NotificationTypeSelectColumn[/** column name */ "Id"] = "id";
    NotificationTypeSelectColumn[/** column name */ "Name"] = "name";
})(NotificationTypeSelectColumn || (NotificationTypeSelectColumn = {}));
var NotificationTypeUpdateColumn;
(function(NotificationTypeUpdateColumn) {
    NotificationTypeUpdateColumn[/** column name */ "Id"] = "id";
    NotificationTypeUpdateColumn[/** column name */ "Name"] = "name";
})(NotificationTypeUpdateColumn || (NotificationTypeUpdateColumn = {}));
var OrderBy;
(function(OrderBy) {
    OrderBy[/** in ascending order, nulls last */ "Asc"] = "asc";
    OrderBy[/** in ascending order, nulls first */ "AscNullsFirst"] = "asc_nulls_first";
    OrderBy[/** in ascending order, nulls last */ "AscNullsLast"] = "asc_nulls_last";
    OrderBy[/** in descending order, nulls first */ "Desc"] = "desc";
    OrderBy[/** in descending order, nulls first */ "DescNullsFirst"] = "desc_nulls_first";
    OrderBy[/** in descending order, nulls last */ "DescNullsLast"] = "desc_nulls_last";
})(OrderBy || (OrderBy = {}));
var PaymentSystemConstraint;
(function(PaymentSystemConstraint) {
    PaymentSystemConstraint[/** unique or primary key constraint on columns "id" */ "PaymentSystemPkey"] = "payment_system_pkey";
})(PaymentSystemConstraint || (PaymentSystemConstraint = {}));
var PaymentSystemSelectColumn;
(function(PaymentSystemSelectColumn) {
    PaymentSystemSelectColumn[/** column name */ "Id"] = "id";
    PaymentSystemSelectColumn[/** column name */ "Name"] = "name";
})(PaymentSystemSelectColumn || (PaymentSystemSelectColumn = {}));
var PaymentSystemUpdateColumn;
(function(PaymentSystemUpdateColumn) {
    PaymentSystemUpdateColumn[/** column name */ "Id"] = "id";
    PaymentSystemUpdateColumn[/** column name */ "Name"] = "name";
})(PaymentSystemUpdateColumn || (PaymentSystemUpdateColumn = {}));
var ProfitProviderConstraint;
(function(ProfitProviderConstraint) {
    ProfitProviderConstraint[/** unique or primary key constraint on columns "id" */ "ProfitProviderPkey"] = "profit_provider_pkey";
})(ProfitProviderConstraint || (ProfitProviderConstraint = {}));
var ProfitProviderSelectColumn;
(function(ProfitProviderSelectColumn) {
    ProfitProviderSelectColumn[/** column name */ "Amount"] = "amount";
    ProfitProviderSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProfitProviderSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProfitProviderSelectColumn[/** column name */ "Id"] = "id";
    ProfitProviderSelectColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProfitProviderSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProfitProviderSelectColumn || (ProfitProviderSelectColumn = {}));
var ProfitProviderUpdateColumn;
(function(ProfitProviderUpdateColumn) {
    ProfitProviderUpdateColumn[/** column name */ "Amount"] = "amount";
    ProfitProviderUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProfitProviderUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProfitProviderUpdateColumn[/** column name */ "Id"] = "id";
    ProfitProviderUpdateColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProfitProviderUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProfitProviderUpdateColumn || (ProfitProviderUpdateColumn = {}));
var ProfitWithdrawConstraint;
(function(ProfitWithdrawConstraint) {
    ProfitWithdrawConstraint[/** unique or primary key constraint on columns "id" */ "ProfitWithdrawPkey"] = "profit_withdraw_pkey";
})(ProfitWithdrawConstraint || (ProfitWithdrawConstraint = {}));
var ProfitWithdrawSelectColumn;
(function(ProfitWithdrawSelectColumn) {
    ProfitWithdrawSelectColumn[/** column name */ "Amount"] = "amount";
    ProfitWithdrawSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProfitWithdrawSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProfitWithdrawSelectColumn[/** column name */ "Description"] = "description";
    ProfitWithdrawSelectColumn[/** column name */ "Fee"] = "fee";
    ProfitWithdrawSelectColumn[/** column name */ "Id"] = "id";
    ProfitWithdrawSelectColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProfitWithdrawSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ProfitWithdrawSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProfitWithdrawSelectColumn || (ProfitWithdrawSelectColumn = {}));
var ProfitWithdrawUpdateColumn;
(function(ProfitWithdrawUpdateColumn) {
    ProfitWithdrawUpdateColumn[/** column name */ "Amount"] = "amount";
    ProfitWithdrawUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProfitWithdrawUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProfitWithdrawUpdateColumn[/** column name */ "Description"] = "description";
    ProfitWithdrawUpdateColumn[/** column name */ "Fee"] = "fee";
    ProfitWithdrawUpdateColumn[/** column name */ "Id"] = "id";
    ProfitWithdrawUpdateColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProfitWithdrawUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ProfitWithdrawUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProfitWithdrawUpdateColumn || (ProfitWithdrawUpdateColumn = {}));
var ProviderConstraint;
(function(ProviderConstraint) {
    ProviderConstraint[/** unique or primary key constraint on columns "alias" */ "AliasUniqueConstraint"] = "alias_unique_constraint";
    ProviderConstraint[/** unique or primary key constraint on columns "id" */ "ProviderPkey"] = "provider_pkey";
})(ProviderConstraint || (ProviderConstraint = {}));
var ProviderCountryConstraint;
(function(ProviderCountryConstraint) {
    ProviderCountryConstraint[/** unique or primary key constraint on columns "id" */ "ProviderCountryPkey"] = "provider_country_pkey";
    ProviderCountryConstraint[/** unique or primary key constraint on columns "provider_country_state_id", "provider_id", "country_id" */ "ProviderCountryProviderIdCountryIdKeyProviderCountrySt"] = "provider_country_provider_id_country_id_key_provider_country_st";
})(ProviderCountryConstraint || (ProviderCountryConstraint = {}));
var ProviderCountrySelectColumn;
(function(ProviderCountrySelectColumn) {
    ProviderCountrySelectColumn[/** column name */ "CountryId"] = "country_id";
    ProviderCountrySelectColumn[/** column name */ "Id"] = "id";
    ProviderCountrySelectColumn[/** column name */ "ProviderCountryStateId"] = "provider_country_state_id";
    ProviderCountrySelectColumn[/** column name */ "ProviderId"] = "provider_id";
})(ProviderCountrySelectColumn || (ProviderCountrySelectColumn = {}));
var ProviderCountryStateConstraint;
(function(ProviderCountryStateConstraint) {
    ProviderCountryStateConstraint[/** unique or primary key constraint on columns "id" */ "ProviderCountryStatePkey"] = "provider_country_state_pkey";
})(ProviderCountryStateConstraint || (ProviderCountryStateConstraint = {}));
var ProviderCountryStateSelectColumn;
(function(ProviderCountryStateSelectColumn) {
    ProviderCountryStateSelectColumn[/** column name */ "Id"] = "id";
    ProviderCountryStateSelectColumn[/** column name */ "Name"] = "name";
})(ProviderCountryStateSelectColumn || (ProviderCountryStateSelectColumn = {}));
var ProviderCountryStateUpdateColumn;
(function(ProviderCountryStateUpdateColumn) {
    ProviderCountryStateUpdateColumn[/** column name */ "Id"] = "id";
    ProviderCountryStateUpdateColumn[/** column name */ "Name"] = "name";
})(ProviderCountryStateUpdateColumn || (ProviderCountryStateUpdateColumn = {}));
var ProviderCountryUpdateColumn;
(function(ProviderCountryUpdateColumn) {
    ProviderCountryUpdateColumn[/** column name */ "CountryId"] = "country_id";
    ProviderCountryUpdateColumn[/** column name */ "Id"] = "id";
    ProviderCountryUpdateColumn[/** column name */ "ProviderCountryStateId"] = "provider_country_state_id";
    ProviderCountryUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
})(ProviderCountryUpdateColumn || (ProviderCountryUpdateColumn = {}));
var ProviderFamilyConstraint;
(function(ProviderFamilyConstraint) {
    ProviderFamilyConstraint[/** unique or primary key constraint on columns "code" */ "ProviderFamilyCodeKey"] = "provider_family_code_key";
    ProviderFamilyConstraint[/** unique or primary key constraint on columns "id" */ "ProviderFamilyPkey"] = "provider_family_pkey";
})(ProviderFamilyConstraint || (ProviderFamilyConstraint = {}));
var ProviderFamilyPaymentSystemConstraint;
(function(ProviderFamilyPaymentSystemConstraint) {
    ProviderFamilyPaymentSystemConstraint[/** unique or primary key constraint on columns "provider_family_id", "payment_system" */ "PaymentSystemProviderFamily"] = "payment_system_provider_family";
    ProviderFamilyPaymentSystemConstraint[/** unique or primary key constraint on columns "id" */ "ProviderFamilyPaymentSystemPkey"] = "provider_family_payment_system_pkey";
})(ProviderFamilyPaymentSystemConstraint || (ProviderFamilyPaymentSystemConstraint = {}));
var ProviderFamilyPaymentSystemSelectColumn;
(function(ProviderFamilyPaymentSystemSelectColumn) {
    ProviderFamilyPaymentSystemSelectColumn[/** column name */ "Description"] = "description";
    ProviderFamilyPaymentSystemSelectColumn[/** column name */ "Id"] = "id";
    ProviderFamilyPaymentSystemSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    ProviderFamilyPaymentSystemSelectColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
})(ProviderFamilyPaymentSystemSelectColumn || (ProviderFamilyPaymentSystemSelectColumn = {}));
var ProviderFamilyPaymentSystemUpdateColumn;
(function(ProviderFamilyPaymentSystemUpdateColumn) {
    ProviderFamilyPaymentSystemUpdateColumn[/** column name */ "Description"] = "description";
    ProviderFamilyPaymentSystemUpdateColumn[/** column name */ "Id"] = "id";
    ProviderFamilyPaymentSystemUpdateColumn[/** column name */ "PaymentSystem"] = "payment_system";
    ProviderFamilyPaymentSystemUpdateColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
})(ProviderFamilyPaymentSystemUpdateColumn || (ProviderFamilyPaymentSystemUpdateColumn = {}));
var ProviderFamilySelectColumn;
(function(ProviderFamilySelectColumn) {
    ProviderFamilySelectColumn[/** column name */ "Code"] = "code";
    ProviderFamilySelectColumn[/** column name */ "Id"] = "id";
    ProviderFamilySelectColumn[/** column name */ "InvoiceReconciliation"] = "invoice_reconciliation";
    ProviderFamilySelectColumn[/** column name */ "Name"] = "name";
    ProviderFamilySelectColumn[/** column name */ "WithdrawReconciliation"] = "withdraw_reconciliation";
})(ProviderFamilySelectColumn || (ProviderFamilySelectColumn = {}));
var ProviderFamilyUpdateColumn;
(function(ProviderFamilyUpdateColumn) {
    ProviderFamilyUpdateColumn[/** column name */ "Code"] = "code";
    ProviderFamilyUpdateColumn[/** column name */ "Id"] = "id";
    ProviderFamilyUpdateColumn[/** column name */ "InvoiceReconciliation"] = "invoice_reconciliation";
    ProviderFamilyUpdateColumn[/** column name */ "Name"] = "name";
    ProviderFamilyUpdateColumn[/** column name */ "WithdrawReconciliation"] = "withdraw_reconciliation";
})(ProviderFamilyUpdateColumn || (ProviderFamilyUpdateColumn = {}));
var ProviderFeeConstraint;
(function(ProviderFeeConstraint) {
    ProviderFeeConstraint[/** unique or primary key constraint on columns "provider_id", "currency_id" */ "ProviderFeeCurrencyIdProviderIdKey"] = "provider_fee_currency_id_provider_id_key";
    ProviderFeeConstraint[/** unique or primary key constraint on columns "id" */ "ProviderFeePkey"] = "provider_fee_pkey";
})(ProviderFeeConstraint || (ProviderFeeConstraint = {}));
var ProviderFeeSelectColumn;
(function(ProviderFeeSelectColumn) {
    ProviderFeeSelectColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    ProviderFeeSelectColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    ProviderFeeSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderFeeSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderFeeSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ProviderFeeSelectColumn[/** column name */ "Id"] = "id";
    ProviderFeeSelectColumn[/** column name */ "InvoiceFeeMinAmount"] = "invoice_fee_min_amount";
    ProviderFeeSelectColumn[/** column name */ "InvoiceFeePercent"] = "invoice_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    ProviderFeeSelectColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    ProviderFeeSelectColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    ProviderFeeSelectColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "MerchantWithdrawSettlementUsdtFeePercent"] = "merchant_withdraw_settlement_usdt_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    ProviderFeeSelectColumn[/** column name */ "ProviderFamilyCode"] = "provider_family_code";
    ProviderFeeSelectColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProviderFeeSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderFeeSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    ProviderFeeSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    ProviderFeeSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    ProviderFeeSelectColumn[/** column name */ "WithdrawFeeMinAmount"] = "withdraw_fee_min_amount";
    ProviderFeeSelectColumn[/** column name */ "WithdrawFeePercent"] = "withdraw_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "WithdrawSettlementUsdtFeePercent"] = "withdraw_settlement_usdt_fee_percent";
    ProviderFeeSelectColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
})(ProviderFeeSelectColumn || (ProviderFeeSelectColumn = {}));
var ProviderFeeUpdateColumn;
(function(ProviderFeeUpdateColumn) {
    ProviderFeeUpdateColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    ProviderFeeUpdateColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    ProviderFeeUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderFeeUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderFeeUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ProviderFeeUpdateColumn[/** column name */ "Id"] = "id";
    ProviderFeeUpdateColumn[/** column name */ "InvoiceFeeMinAmount"] = "invoice_fee_min_amount";
    ProviderFeeUpdateColumn[/** column name */ "InvoiceFeePercent"] = "invoice_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "InvoiceTransactionFeeAmount"] = "invoice_transaction_fee_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    ProviderFeeUpdateColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    ProviderFeeUpdateColumn[/** column name */ "MerchantInvoiceDeclineTransactionFeeAmount"] = "merchant_invoice_decline_transaction_fee_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    ProviderFeeUpdateColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "MerchantWithdrawSettlementUsdtFeePercent"] = "merchant_withdraw_settlement_usdt_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    ProviderFeeUpdateColumn[/** column name */ "ProviderFamilyCode"] = "provider_family_code";
    ProviderFeeUpdateColumn[/** column name */ "ProviderFamilyId"] = "provider_family_id";
    ProviderFeeUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderFeeUpdateColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    ProviderFeeUpdateColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    ProviderFeeUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    ProviderFeeUpdateColumn[/** column name */ "WithdrawFeeMinAmount"] = "withdraw_fee_min_amount";
    ProviderFeeUpdateColumn[/** column name */ "WithdrawFeePercent"] = "withdraw_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "WithdrawSettlementUsdtFeePercent"] = "withdraw_settlement_usdt_fee_percent";
    ProviderFeeUpdateColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
})(ProviderFeeUpdateColumn || (ProviderFeeUpdateColumn = {}));
var ProviderInvocationLogConstraint;
(function(ProviderInvocationLogConstraint) {
    ProviderInvocationLogConstraint[/** unique or primary key constraint on columns "id" */ "ProviderInvocationLogPkey"] = "provider_invocation_log_pkey";
})(ProviderInvocationLogConstraint || (ProviderInvocationLogConstraint = {}));
var ProviderInvocationLogSelectColumn;
(function(ProviderInvocationLogSelectColumn) {
    ProviderInvocationLogSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderInvocationLogSelectColumn[/** column name */ "Id"] = "id";
    ProviderInvocationLogSelectColumn[/** column name */ "IsError"] = "is_error";
    ProviderInvocationLogSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderInvocationLogSelectColumn[/** column name */ "Request"] = "request";
    ProviderInvocationLogSelectColumn[/** column name */ "Response"] = "response";
    ProviderInvocationLogSelectColumn[/** column name */ "Status"] = "status";
    ProviderInvocationLogSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
})(ProviderInvocationLogSelectColumn || (ProviderInvocationLogSelectColumn = {}));
var ProviderInvocationLogUpdateColumn;
(function(ProviderInvocationLogUpdateColumn) {
    ProviderInvocationLogUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderInvocationLogUpdateColumn[/** column name */ "Id"] = "id";
    ProviderInvocationLogUpdateColumn[/** column name */ "IsError"] = "is_error";
    ProviderInvocationLogUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderInvocationLogUpdateColumn[/** column name */ "Request"] = "request";
    ProviderInvocationLogUpdateColumn[/** column name */ "Response"] = "response";
    ProviderInvocationLogUpdateColumn[/** column name */ "Status"] = "status";
    ProviderInvocationLogUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
})(ProviderInvocationLogUpdateColumn || (ProviderInvocationLogUpdateColumn = {}));
var ProviderLimitConstraint;
(function(ProviderLimitConstraint) {
    ProviderLimitConstraint[/** unique or primary key constraint on columns "id" */ "ProviderLimitPkey"] = "provider_limit_pkey";
    ProviderLimitConstraint[/** unique or primary key constraint on columns "type", "provider_id", "currency_id" */ "ProviderLimitProviderIdCurrencyIdTypeKey"] = "provider_limit_provider_id_currency_id_type_key";
})(ProviderLimitConstraint || (ProviderLimitConstraint = {}));
var ProviderLimitSelectColumn;
(function(ProviderLimitSelectColumn) {
    ProviderLimitSelectColumn[/** column name */ "ClientLimit"] = "client_limit";
    ProviderLimitSelectColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    ProviderLimitSelectColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    ProviderLimitSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderLimitSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderLimitSelectColumn[/** column name */ "Id"] = "id";
    ProviderLimitSelectColumn[/** column name */ "MaxLimit"] = "max_limit";
    ProviderLimitSelectColumn[/** column name */ "MinLimit"] = "min_limit";
    ProviderLimitSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderLimitSelectColumn[/** column name */ "Type"] = "type";
})(ProviderLimitSelectColumn || (ProviderLimitSelectColumn = {}));
var ProviderLimitUpdateColumn;
(function(ProviderLimitUpdateColumn) {
    ProviderLimitUpdateColumn[/** column name */ "ClientLimit"] = "client_limit";
    ProviderLimitUpdateColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    ProviderLimitUpdateColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    ProviderLimitUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderLimitUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderLimitUpdateColumn[/** column name */ "Id"] = "id";
    ProviderLimitUpdateColumn[/** column name */ "MaxLimit"] = "max_limit";
    ProviderLimitUpdateColumn[/** column name */ "MinLimit"] = "min_limit";
    ProviderLimitUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderLimitUpdateColumn[/** column name */ "Type"] = "type";
})(ProviderLimitUpdateColumn || (ProviderLimitUpdateColumn = {}));
var ProviderPaymentSystemConstraint;
(function(ProviderPaymentSystemConstraint) {
    ProviderPaymentSystemConstraint[/** unique or primary key constraint on columns "id" */ "ProviderPaymentSystemPkey"] = "provider_payment_system_pkey";
    ProviderPaymentSystemConstraint[/** unique or primary key constraint on columns "provider_id", "payment_system_id" */ "ProviderPaymentSystemProviderIdPaymentSystemIdKey"] = "provider_payment_system_provider_id_payment_system_id_key";
})(ProviderPaymentSystemConstraint || (ProviderPaymentSystemConstraint = {}));
var ProviderPaymentSystemSelectColumn;
(function(ProviderPaymentSystemSelectColumn) {
    ProviderPaymentSystemSelectColumn[/** column name */ "Id"] = "id";
    ProviderPaymentSystemSelectColumn[/** column name */ "PaymentSystemId"] = "payment_system_id";
    ProviderPaymentSystemSelectColumn[/** column name */ "ProviderId"] = "provider_id";
})(ProviderPaymentSystemSelectColumn || (ProviderPaymentSystemSelectColumn = {}));
var ProviderPaymentSystemUpdateColumn;
(function(ProviderPaymentSystemUpdateColumn) {
    ProviderPaymentSystemUpdateColumn[/** column name */ "Id"] = "id";
    ProviderPaymentSystemUpdateColumn[/** column name */ "PaymentSystemId"] = "payment_system_id";
    ProviderPaymentSystemUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
})(ProviderPaymentSystemUpdateColumn || (ProviderPaymentSystemUpdateColumn = {}));
var ProviderSelectColumn;
(function(ProviderSelectColumn) {
    ProviderSelectColumn[/** column name */ "Alias"] = "alias";
    ProviderSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderSelectColumn[/** column name */ "DefaultDateColumnAnalytics"] = "default_date_column_analytics";
    ProviderSelectColumn[/** column name */ "DefaultPaymentSystem"] = "default_payment_system";
    ProviderSelectColumn[/** column name */ "DefaultTrafficTypeId"] = "default_traffic_type_id";
    ProviderSelectColumn[/** column name */ "DisplayName"] = "display_name";
    ProviderSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ProviderSelectColumn[/** column name */ "FortId"] = "fort_id";
    ProviderSelectColumn[/** column name */ "Id"] = "id";
    ProviderSelectColumn[/** column name */ "IsNew"] = "is_new";
    ProviderSelectColumn[/** column name */ "Name"] = "name";
    ProviderSelectColumn[/** column name */ "ProviderFamily"] = "provider_family";
    ProviderSelectColumn[/** column name */ "ProviderFamilyPaymentSystem"] = "provider_family_payment_system";
    ProviderSelectColumn[/** column name */ "ProviderStatusId"] = "provider_status_id";
    ProviderSelectColumn[/** column name */ "ProviderTypeId"] = "provider_type_id";
    ProviderSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProviderSelectColumn || (ProviderSelectColumn = {}));
var ProviderServiceIdConstraint;
(function(ProviderServiceIdConstraint) {
    ProviderServiceIdConstraint[/** unique or primary key constraint on columns "provider_id", "service_id", "currency_id" */ "ProviderServiceIdPkey"] = "provider_service_id_pkey";
})(ProviderServiceIdConstraint || (ProviderServiceIdConstraint = {}));
var ProviderServiceIdSelectColumn;
(function(ProviderServiceIdSelectColumn) {
    ProviderServiceIdSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderServiceIdSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderServiceIdSelectColumn[/** column name */ "ServiceId"] = "service_id";
})(ProviderServiceIdSelectColumn || (ProviderServiceIdSelectColumn = {}));
var ProviderServiceIdUpdateColumn;
(function(ProviderServiceIdUpdateColumn) {
    ProviderServiceIdUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    ProviderServiceIdUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ProviderServiceIdUpdateColumn[/** column name */ "ServiceId"] = "service_id";
})(ProviderServiceIdUpdateColumn || (ProviderServiceIdUpdateColumn = {}));
var ProviderStatusConstraint;
(function(ProviderStatusConstraint) {
    ProviderStatusConstraint[/** unique or primary key constraint on columns "id" */ "ProviderStatusPkey"] = "provider_status_pkey";
})(ProviderStatusConstraint || (ProviderStatusConstraint = {}));
var ProviderStatusSelectColumn;
(function(ProviderStatusSelectColumn) {
    ProviderStatusSelectColumn[/** column name */ "Id"] = "id";
    ProviderStatusSelectColumn[/** column name */ "Name"] = "name";
})(ProviderStatusSelectColumn || (ProviderStatusSelectColumn = {}));
var ProviderStatusUpdateColumn;
(function(ProviderStatusUpdateColumn) {
    ProviderStatusUpdateColumn[/** column name */ "Id"] = "id";
    ProviderStatusUpdateColumn[/** column name */ "Name"] = "name";
})(ProviderStatusUpdateColumn || (ProviderStatusUpdateColumn = {}));
var ProviderUpdateColumn;
(function(ProviderUpdateColumn) {
    ProviderUpdateColumn[/** column name */ "Alias"] = "alias";
    ProviderUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ProviderUpdateColumn[/** column name */ "DefaultDateColumnAnalytics"] = "default_date_column_analytics";
    ProviderUpdateColumn[/** column name */ "DefaultPaymentSystem"] = "default_payment_system";
    ProviderUpdateColumn[/** column name */ "DefaultTrafficTypeId"] = "default_traffic_type_id";
    ProviderUpdateColumn[/** column name */ "DisplayName"] = "display_name";
    ProviderUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ProviderUpdateColumn[/** column name */ "FortId"] = "fort_id";
    ProviderUpdateColumn[/** column name */ "Id"] = "id";
    ProviderUpdateColumn[/** column name */ "IsNew"] = "is_new";
    ProviderUpdateColumn[/** column name */ "Name"] = "name";
    ProviderUpdateColumn[/** column name */ "ProviderFamily"] = "provider_family";
    ProviderUpdateColumn[/** column name */ "ProviderFamilyPaymentSystem"] = "provider_family_payment_system";
    ProviderUpdateColumn[/** column name */ "ProviderStatusId"] = "provider_status_id";
    ProviderUpdateColumn[/** column name */ "ProviderTypeId"] = "provider_type_id";
    ProviderUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ProviderUpdateColumn || (ProviderUpdateColumn = {}));
var ReconciliationConstraint;
(function(ReconciliationConstraint) {
    ReconciliationConstraint[/** unique or primary key constraint on columns "id" */ "ReconciliationPkey"] = "reconciliation_pkey";
    ReconciliationConstraint[/** unique or primary key constraint on columns "transaction_uid" */ "ReconciliationTransactionUidKey"] = "reconciliation_transaction_uid_key";
})(ReconciliationConstraint || (ReconciliationConstraint = {}));
var ReconciliationExceptionsConstraint;
(function(ReconciliationExceptionsConstraint) {
    ReconciliationExceptionsConstraint[/** unique or primary key constraint on columns "id" */ "ReconciliationExceptionsPkey"] = "reconciliation_exceptions_pkey";
    ReconciliationExceptionsConstraint[/** unique or primary key constraint on columns "transaction_type", "transaction_uid" */ "ReconciliationExceptionsTransactionUidTransactionTypeKey"] = "reconciliation_exceptions_transaction_uid_transaction_type_key";
})(ReconciliationExceptionsConstraint || (ReconciliationExceptionsConstraint = {}));
var ReconciliationExceptionsSelectColumn;
(function(ReconciliationExceptionsSelectColumn) {
    ReconciliationExceptionsSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ReconciliationExceptionsSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ReconciliationExceptionsSelectColumn[/** column name */ "Id"] = "id";
    ReconciliationExceptionsSelectColumn[/** column name */ "TransactionType"] = "transaction_type";
    ReconciliationExceptionsSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
})(ReconciliationExceptionsSelectColumn || (ReconciliationExceptionsSelectColumn = {}));
var ReconciliationExceptionsUpdateColumn;
(function(ReconciliationExceptionsUpdateColumn) {
    ReconciliationExceptionsUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ReconciliationExceptionsUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ReconciliationExceptionsUpdateColumn[/** column name */ "Id"] = "id";
    ReconciliationExceptionsUpdateColumn[/** column name */ "TransactionType"] = "transaction_type";
    ReconciliationExceptionsUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
})(ReconciliationExceptionsUpdateColumn || (ReconciliationExceptionsUpdateColumn = {}));
var ReconciliationSelectColumn;
(function(ReconciliationSelectColumn) {
    ReconciliationSelectColumn[/** column name */ "Amount"] = "amount";
    ReconciliationSelectColumn[/** column name */ "AmountDiscrepancy"] = "amount_discrepancy";
    ReconciliationSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    ReconciliationSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ReconciliationSelectColumn[/** column name */ "Id"] = "id";
    ReconciliationSelectColumn[/** column name */ "IsMerchantIssueClose"] = "is_merchant_issue_close";
    ReconciliationSelectColumn[/** column name */ "IsResolved"] = "is_resolved";
    ReconciliationSelectColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    ReconciliationSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    ReconciliationSelectColumn[/** column name */ "ProviderStatus"] = "provider_status";
    ReconciliationSelectColumn[/** column name */ "ResolvedAt"] = "resolved_at";
    ReconciliationSelectColumn[/** column name */ "Status"] = "status";
    ReconciliationSelectColumn[/** column name */ "StatusDiscrepancy"] = "status_discrepancy";
    ReconciliationSelectColumn[/** column name */ "TransactionType"] = "transaction_type";
    ReconciliationSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    ReconciliationSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ReconciliationSelectColumn || (ReconciliationSelectColumn = {}));
var ReconciliationUpdateColumn;
(function(ReconciliationUpdateColumn) {
    ReconciliationUpdateColumn[/** column name */ "Amount"] = "amount";
    ReconciliationUpdateColumn[/** column name */ "AmountDiscrepancy"] = "amount_discrepancy";
    ReconciliationUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    ReconciliationUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    ReconciliationUpdateColumn[/** column name */ "Id"] = "id";
    ReconciliationUpdateColumn[/** column name */ "IsMerchantIssueClose"] = "is_merchant_issue_close";
    ReconciliationUpdateColumn[/** column name */ "IsResolved"] = "is_resolved";
    ReconciliationUpdateColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    ReconciliationUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    ReconciliationUpdateColumn[/** column name */ "ProviderStatus"] = "provider_status";
    ReconciliationUpdateColumn[/** column name */ "ResolvedAt"] = "resolved_at";
    ReconciliationUpdateColumn[/** column name */ "Status"] = "status";
    ReconciliationUpdateColumn[/** column name */ "StatusDiscrepancy"] = "status_discrepancy";
    ReconciliationUpdateColumn[/** column name */ "TransactionType"] = "transaction_type";
    ReconciliationUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    ReconciliationUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(ReconciliationUpdateColumn || (ReconciliationUpdateColumn = {}));
var RefundRequestStatusConstraint;
(function(RefundRequestStatusConstraint) {
    RefundRequestStatusConstraint[/** unique or primary key constraint on columns "id" */ "RefundRequestStatusPkey"] = "refund_request_status_pkey";
})(RefundRequestStatusConstraint || (RefundRequestStatusConstraint = {}));
var RefundRequestStatusSelectColumn;
(function(RefundRequestStatusSelectColumn) {
    RefundRequestStatusSelectColumn[/** column name */ "Id"] = "id";
    RefundRequestStatusSelectColumn[/** column name */ "Name"] = "name";
})(RefundRequestStatusSelectColumn || (RefundRequestStatusSelectColumn = {}));
var RefundRequestStatusUpdateColumn;
(function(RefundRequestStatusUpdateColumn) {
    RefundRequestStatusUpdateColumn[/** column name */ "Id"] = "id";
    RefundRequestStatusUpdateColumn[/** column name */ "Name"] = "name";
})(RefundRequestStatusUpdateColumn || (RefundRequestStatusUpdateColumn = {}));
var RefundTableConstraint;
(function(RefundTableConstraint) {
    RefundTableConstraint[/** unique or primary key constraint on columns "invoice_transaction_uid" */ "RefundTableInvoiceTransactionUidKey"] = "refund_table_invoice_transaction_uid_key";
    RefundTableConstraint[/** unique or primary key constraint on columns "id" */ "RefundTablePkey"] = "refund_table_pkey";
    RefundTableConstraint[/** unique or primary key constraint on columns "withdraw_transaction_uid" */ "RefundTableWithdrawTransactionUidKey"] = "refund_table_withdraw_transaction_uid_key";
})(RefundTableConstraint || (RefundTableConstraint = {}));
var RefundTableSelectColumn;
(function(RefundTableSelectColumn) {
    RefundTableSelectColumn[/** column name */ "Amount"] = "amount";
    RefundTableSelectColumn[/** column name */ "Comment"] = "comment";
    RefundTableSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    RefundTableSelectColumn[/** column name */ "Id"] = "id";
    RefundTableSelectColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    RefundTableSelectColumn[/** column name */ "IsPaid"] = "is_paid";
    RefundTableSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    RefundTableSelectColumn[/** column name */ "RefundFee"] = "refund_fee";
    RefundTableSelectColumn[/** column name */ "RefundReason"] = "refund_reason";
    RefundTableSelectColumn[/** column name */ "RefundRequestStatusId"] = "refund_request_status_id";
    RefundTableSelectColumn[/** column name */ "RejectReason"] = "reject_reason";
    RefundTableSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(RefundTableSelectColumn || (RefundTableSelectColumn = {}));
var RefundTableUpdateColumn;
(function(RefundTableUpdateColumn) {
    RefundTableUpdateColumn[/** column name */ "Amount"] = "amount";
    RefundTableUpdateColumn[/** column name */ "Comment"] = "comment";
    RefundTableUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    RefundTableUpdateColumn[/** column name */ "Id"] = "id";
    RefundTableUpdateColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    RefundTableUpdateColumn[/** column name */ "IsPaid"] = "is_paid";
    RefundTableUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    RefundTableUpdateColumn[/** column name */ "RefundFee"] = "refund_fee";
    RefundTableUpdateColumn[/** column name */ "RefundReason"] = "refund_reason";
    RefundTableUpdateColumn[/** column name */ "RefundRequestStatusId"] = "refund_request_status_id";
    RefundTableUpdateColumn[/** column name */ "RejectReason"] = "reject_reason";
    RefundTableUpdateColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(RefundTableUpdateColumn || (RefundTableUpdateColumn = {}));
var RegistrationInfoConstraint;
(function(RegistrationInfoConstraint) {
    RegistrationInfoConstraint[/** unique or primary key constraint on columns "id" */ "RegistrationInfoPkey"] = "registration_info_pkey";
})(RegistrationInfoConstraint || (RegistrationInfoConstraint = {}));
var RegistrationInfoSelectColumn;
(function(RegistrationInfoSelectColumn) {
    RegistrationInfoSelectColumn[/** column name */ "ApprovedAt"] = "approved_at";
    RegistrationInfoSelectColumn[/** column name */ "BusinessAddress"] = "business_address";
    RegistrationInfoSelectColumn[/** column name */ "ChargebackRatio"] = "chargeback_ratio";
    RegistrationInfoSelectColumn[/** column name */ "CompanyName"] = "company_name";
    RegistrationInfoSelectColumn[/** column name */ "CompanyWebsite"] = "company_website";
    RegistrationInfoSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    RegistrationInfoSelectColumn[/** column name */ "Email"] = "email";
    RegistrationInfoSelectColumn[/** column name */ "EmailTest"] = "email_test";
    RegistrationInfoSelectColumn[/** column name */ "Id"] = "id";
    RegistrationInfoSelectColumn[/** column name */ "Meta"] = "meta";
    RegistrationInfoSelectColumn[/** column name */ "MonthTurnover"] = "month_turnover";
    RegistrationInfoSelectColumn[/** column name */ "PasswordHash"] = "password_hash";
    RegistrationInfoSelectColumn[/** column name */ "PaymentsCurrencies"] = "payments_currencies";
    RegistrationInfoSelectColumn[/** column name */ "PaymentsGeo"] = "payments_geo";
    RegistrationInfoSelectColumn[/** column name */ "Phone"] = "phone";
    RegistrationInfoSelectColumn[/** column name */ "RegisteredAddress"] = "registered_address";
    RegistrationInfoSelectColumn[/** column name */ "RegistrationData"] = "registration_data";
    RegistrationInfoSelectColumn[/** column name */ "RegistrationNumber"] = "registration_number";
    RegistrationInfoSelectColumn[/** column name */ "RegistrationStatusId"] = "registration_status_id";
    RegistrationInfoSelectColumn[/** column name */ "RejectReason"] = "reject_reason";
    RegistrationInfoSelectColumn[/** column name */ "RejectSendAt"] = "reject_send_at";
    RegistrationInfoSelectColumn[/** column name */ "RejectedAt"] = "rejected_at";
    RegistrationInfoSelectColumn[/** column name */ "Telegram"] = "telegram";
    RegistrationInfoSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    RegistrationInfoSelectColumn[/** column name */ "Whatsapp"] = "whatsapp";
})(RegistrationInfoSelectColumn || (RegistrationInfoSelectColumn = {}));
var RegistrationInfoUpdateColumn;
(function(RegistrationInfoUpdateColumn) {
    RegistrationInfoUpdateColumn[/** column name */ "ApprovedAt"] = "approved_at";
    RegistrationInfoUpdateColumn[/** column name */ "BusinessAddress"] = "business_address";
    RegistrationInfoUpdateColumn[/** column name */ "ChargebackRatio"] = "chargeback_ratio";
    RegistrationInfoUpdateColumn[/** column name */ "CompanyName"] = "company_name";
    RegistrationInfoUpdateColumn[/** column name */ "CompanyWebsite"] = "company_website";
    RegistrationInfoUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    RegistrationInfoUpdateColumn[/** column name */ "Email"] = "email";
    RegistrationInfoUpdateColumn[/** column name */ "EmailTest"] = "email_test";
    RegistrationInfoUpdateColumn[/** column name */ "Id"] = "id";
    RegistrationInfoUpdateColumn[/** column name */ "Meta"] = "meta";
    RegistrationInfoUpdateColumn[/** column name */ "MonthTurnover"] = "month_turnover";
    RegistrationInfoUpdateColumn[/** column name */ "PasswordHash"] = "password_hash";
    RegistrationInfoUpdateColumn[/** column name */ "PaymentsCurrencies"] = "payments_currencies";
    RegistrationInfoUpdateColumn[/** column name */ "PaymentsGeo"] = "payments_geo";
    RegistrationInfoUpdateColumn[/** column name */ "Phone"] = "phone";
    RegistrationInfoUpdateColumn[/** column name */ "RegisteredAddress"] = "registered_address";
    RegistrationInfoUpdateColumn[/** column name */ "RegistrationData"] = "registration_data";
    RegistrationInfoUpdateColumn[/** column name */ "RegistrationNumber"] = "registration_number";
    RegistrationInfoUpdateColumn[/** column name */ "RegistrationStatusId"] = "registration_status_id";
    RegistrationInfoUpdateColumn[/** column name */ "RejectReason"] = "reject_reason";
    RegistrationInfoUpdateColumn[/** column name */ "RejectSendAt"] = "reject_send_at";
    RegistrationInfoUpdateColumn[/** column name */ "RejectedAt"] = "rejected_at";
    RegistrationInfoUpdateColumn[/** column name */ "Telegram"] = "telegram";
    RegistrationInfoUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    RegistrationInfoUpdateColumn[/** column name */ "Whatsapp"] = "whatsapp";
})(RegistrationInfoUpdateColumn || (RegistrationInfoUpdateColumn = {}));
var RegistrationStatusConstraint;
(function(RegistrationStatusConstraint) {
    RegistrationStatusConstraint[/** unique or primary key constraint on columns "id" */ "RegistrationStatusPkey"] = "registration_status_pkey";
})(RegistrationStatusConstraint || (RegistrationStatusConstraint = {}));
var RegistrationStatusSelectColumn;
(function(RegistrationStatusSelectColumn) {
    RegistrationStatusSelectColumn[/** column name */ "Id"] = "id";
    RegistrationStatusSelectColumn[/** column name */ "Name"] = "name";
})(RegistrationStatusSelectColumn || (RegistrationStatusSelectColumn = {}));
var RegistrationStatusUpdateColumn;
(function(RegistrationStatusUpdateColumn) {
    RegistrationStatusUpdateColumn[/** column name */ "Id"] = "id";
    RegistrationStatusUpdateColumn[/** column name */ "Name"] = "name";
})(RegistrationStatusUpdateColumn || (RegistrationStatusUpdateColumn = {}));
var RoleConstraint;
(function(RoleConstraint) {
    RoleConstraint[/** unique or primary key constraint on columns "id" */ "RolePkey"] = "role_pkey";
})(RoleConstraint || (RoleConstraint = {}));
var RoleSelectColumn;
(function(RoleSelectColumn) {
    RoleSelectColumn[/** column name */ "Id"] = "id";
    RoleSelectColumn[/** column name */ "Name"] = "name";
})(RoleSelectColumn || (RoleSelectColumn = {}));
var RoleUpdateColumn;
(function(RoleUpdateColumn) {
    RoleUpdateColumn[/** column name */ "Id"] = "id";
    RoleUpdateColumn[/** column name */ "Name"] = "name";
})(RoleUpdateColumn || (RoleUpdateColumn = {}));
var RollingReserveConstraint;
(function(RollingReserveConstraint) {
    RollingReserveConstraint[/** unique or primary key constraint on columns "invoice_transaction_uid" */ "RollingReserveInvoiceTransactionUidKey"] = "rolling_reserve_invoice_transaction_uid_key";
    RollingReserveConstraint[/** unique or primary key constraint on columns "id" */ "RollingReservePkey"] = "rolling_reserve_pkey";
    RollingReserveConstraint[/** unique or primary key constraint on columns "withdraw_transaction_uid" */ "RollingReserveWithdrawTransactionUidKey"] = "rolling_reserve_withdraw_transaction_uid_key";
})(RollingReserveConstraint || (RollingReserveConstraint = {}));
var RollingReserveSelectColumn;
(function(RollingReserveSelectColumn) {
    RollingReserveSelectColumn[/** column name */ "Amount"] = "amount";
    RollingReserveSelectColumn[/** column name */ "Comment"] = "comment";
    RollingReserveSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    RollingReserveSelectColumn[/** column name */ "Id"] = "id";
    RollingReserveSelectColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    RollingReserveSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    RollingReserveSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(RollingReserveSelectColumn || (RollingReserveSelectColumn = {}));
var RollingReserveUpdateColumn;
(function(RollingReserveUpdateColumn) {
    RollingReserveUpdateColumn[/** column name */ "Amount"] = "amount";
    RollingReserveUpdateColumn[/** column name */ "Comment"] = "comment";
    RollingReserveUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    RollingReserveUpdateColumn[/** column name */ "Id"] = "id";
    RollingReserveUpdateColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    RollingReserveUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    RollingReserveUpdateColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(RollingReserveUpdateColumn || (RollingReserveUpdateColumn = {}));
var SettingConstraint;
(function(SettingConstraint) {
    SettingConstraint[/** unique or primary key constraint on columns "key" */ "SettingPkey"] = "setting_pkey";
})(SettingConstraint || (SettingConstraint = {}));
var SettingSelectColumn;
(function(SettingSelectColumn) {
    SettingSelectColumn[/** column name */ "Key"] = "key";
    SettingSelectColumn[/** column name */ "Type"] = "type";
    SettingSelectColumn[/** column name */ "Value"] = "value";
})(SettingSelectColumn || (SettingSelectColumn = {}));
var SettingUpdateColumn;
(function(SettingUpdateColumn) {
    SettingUpdateColumn[/** column name */ "Key"] = "key";
    SettingUpdateColumn[/** column name */ "Type"] = "type";
    SettingUpdateColumn[/** column name */ "Value"] = "value";
})(SettingUpdateColumn || (SettingUpdateColumn = {}));
var SettlementConstraint;
(function(SettlementConstraint) {
    SettlementConstraint[/** unique or primary key constraint on columns "id" */ "SettlementPkey"] = "settlement_pkey";
    SettlementConstraint[/** unique or primary key constraint on columns "withdraw_transaction_uid" */ "SettlementWithdrawTransactionUidKey"] = "settlement_withdraw_transaction_uid_key";
})(SettlementConstraint || (SettlementConstraint = {}));
var SettlementSelectColumn;
(function(SettlementSelectColumn) {
    SettlementSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    SettlementSelectColumn[/** column name */ "CryptoCurrencyId"] = "crypto_currency_id";
    SettlementSelectColumn[/** column name */ "Description"] = "description";
    SettlementSelectColumn[/** column name */ "FiatAmount"] = "fiat_amount";
    SettlementSelectColumn[/** column name */ "FiatCurrencyId"] = "fiat_currency_id";
    SettlementSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    SettlementSelectColumn[/** column name */ "Id"] = "id";
    SettlementSelectColumn[/** column name */ "MerchantCryptoAccountNumber"] = "merchant_crypto_account_number";
    SettlementSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    SettlementSelectColumn[/** column name */ "MerchantSettlementAmount"] = "merchant_settlement_amount";
    SettlementSelectColumn[/** column name */ "MerchantSettlementFee"] = "merchant_settlement_fee";
    SettlementSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(SettlementSelectColumn || (SettlementSelectColumn = {}));
var SettlementUpdateColumn;
(function(SettlementUpdateColumn) {
    SettlementUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    SettlementUpdateColumn[/** column name */ "CryptoCurrencyId"] = "crypto_currency_id";
    SettlementUpdateColumn[/** column name */ "Description"] = "description";
    SettlementUpdateColumn[/** column name */ "FiatAmount"] = "fiat_amount";
    SettlementUpdateColumn[/** column name */ "FiatCurrencyId"] = "fiat_currency_id";
    SettlementUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    SettlementUpdateColumn[/** column name */ "Id"] = "id";
    SettlementUpdateColumn[/** column name */ "MerchantCryptoAccountNumber"] = "merchant_crypto_account_number";
    SettlementUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    SettlementUpdateColumn[/** column name */ "MerchantSettlementAmount"] = "merchant_settlement_amount";
    SettlementUpdateColumn[/** column name */ "MerchantSettlementFee"] = "merchant_settlement_fee";
    SettlementUpdateColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(SettlementUpdateColumn || (SettlementUpdateColumn = {}));
var TrafficTypeConstraint;
(function(TrafficTypeConstraint) {
    TrafficTypeConstraint[/** unique or primary key constraint on columns "id" */ "TrafficTypePkey"] = "traffic_type_pkey";
})(TrafficTypeConstraint || (TrafficTypeConstraint = {}));
var TrafficTypeSelectColumn;
(function(TrafficTypeSelectColumn) {
    TrafficTypeSelectColumn[/** column name */ "Id"] = "id";
    TrafficTypeSelectColumn[/** column name */ "Name"] = "name";
})(TrafficTypeSelectColumn || (TrafficTypeSelectColumn = {}));
var TrafficTypeUpdateColumn;
(function(TrafficTypeUpdateColumn) {
    TrafficTypeUpdateColumn[/** column name */ "Id"] = "id";
    TrafficTypeUpdateColumn[/** column name */ "Name"] = "name";
})(TrafficTypeUpdateColumn || (TrafficTypeUpdateColumn = {}));
var TransactionHistoryConstraint;
(function(TransactionHistoryConstraint) {
    TransactionHistoryConstraint[/** unique or primary key constraint on columns "id" */ "TransactionPkey"] = "transaction_pkey";
})(TransactionHistoryConstraint || (TransactionHistoryConstraint = {}));
var TransactionHistorySelectColumn;
(function(TransactionHistorySelectColumn) {
    TransactionHistorySelectColumn[/** column name */ "Amount"] = "amount";
    TransactionHistorySelectColumn[/** column name */ "Balance"] = "balance";
    TransactionHistorySelectColumn[/** column name */ "BankId"] = "bank_id";
    TransactionHistorySelectColumn[/** column name */ "CardSystemId"] = "card_system_id";
    TransactionHistorySelectColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    TransactionHistorySelectColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    TransactionHistorySelectColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    TransactionHistorySelectColumn[/** column name */ "CreatedAt"] = "created_at";
    TransactionHistorySelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    TransactionHistorySelectColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    TransactionHistorySelectColumn[/** column name */ "CurrencyRateProviderId"] = "currency_rate_provider_id";
    TransactionHistorySelectColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    TransactionHistorySelectColumn[/** column name */ "GateCurrencyAmount"] = "gate_currency_amount";
    TransactionHistorySelectColumn[/** column name */ "GateCurrencyRate"] = "gate_currency_rate";
    TransactionHistorySelectColumn[/** column name */ "GateId"] = "gate_id";
    TransactionHistorySelectColumn[/** column name */ "HoldAmount"] = "hold_amount";
    TransactionHistorySelectColumn[/** column name */ "HoldBalance"] = "hold_balance";
    TransactionHistorySelectColumn[/** column name */ "Id"] = "id";
    TransactionHistorySelectColumn[/** column name */ "InputCurrencyAmount"] = "input_currency_amount";
    TransactionHistorySelectColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    TransactionHistorySelectColumn[/** column name */ "IsHidden"] = "is_hidden";
    TransactionHistorySelectColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    TransactionHistorySelectColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    TransactionHistorySelectColumn[/** column name */ "MerchantFee"] = "merchant_fee";
    TransactionHistorySelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    TransactionHistorySelectColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    TransactionHistorySelectColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    TransactionHistorySelectColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    TransactionHistorySelectColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    TransactionHistorySelectColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    TransactionHistorySelectColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    TransactionHistorySelectColumn[/** column name */ "ProviderFee"] = "provider_fee";
    TransactionHistorySelectColumn[/** column name */ "ProviderId"] = "provider_id";
    TransactionHistorySelectColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    TransactionHistorySelectColumn[/** column name */ "Remark"] = "remark";
    TransactionHistorySelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    TransactionHistorySelectColumn[/** column name */ "Status"] = "status";
    TransactionHistorySelectColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    TransactionHistorySelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    TransactionHistorySelectColumn[/** column name */ "Type"] = "type";
})(TransactionHistorySelectColumn || (TransactionHistorySelectColumn = {}));
var TransactionHistoryUpdateColumn;
(function(TransactionHistoryUpdateColumn) {
    TransactionHistoryUpdateColumn[/** column name */ "Amount"] = "amount";
    TransactionHistoryUpdateColumn[/** column name */ "Balance"] = "balance";
    TransactionHistoryUpdateColumn[/** column name */ "BankId"] = "bank_id";
    TransactionHistoryUpdateColumn[/** column name */ "CardSystemId"] = "card_system_id";
    TransactionHistoryUpdateColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    TransactionHistoryUpdateColumn[/** column name */ "ConstantInvoiceFee"] = "constant_invoice_fee";
    TransactionHistoryUpdateColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    TransactionHistoryUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    TransactionHistoryUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    TransactionHistoryUpdateColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    TransactionHistoryUpdateColumn[/** column name */ "CurrencyRateProviderId"] = "currency_rate_provider_id";
    TransactionHistoryUpdateColumn[/** column name */ "FrozenWithdrawBalance"] = "frozen_withdraw_balance";
    TransactionHistoryUpdateColumn[/** column name */ "GateCurrencyAmount"] = "gate_currency_amount";
    TransactionHistoryUpdateColumn[/** column name */ "GateCurrencyRate"] = "gate_currency_rate";
    TransactionHistoryUpdateColumn[/** column name */ "GateId"] = "gate_id";
    TransactionHistoryUpdateColumn[/** column name */ "HoldAmount"] = "hold_amount";
    TransactionHistoryUpdateColumn[/** column name */ "HoldBalance"] = "hold_balance";
    TransactionHistoryUpdateColumn[/** column name */ "Id"] = "id";
    TransactionHistoryUpdateColumn[/** column name */ "InputCurrencyAmount"] = "input_currency_amount";
    TransactionHistoryUpdateColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    TransactionHistoryUpdateColumn[/** column name */ "IsHidden"] = "is_hidden";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantConstantInvoiceFee"] = "merchant_constant_invoice_fee";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantFee"] = "merchant_fee";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantInvoiceFeeMinAmount"] = "merchant_invoice_fee_min_amount";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantInvoiceFeePercent"] = "merchant_invoice_fee_percent";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantInvoiceTransactionFeeAmount"] = "merchant_invoice_transaction_fee_amount";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    TransactionHistoryUpdateColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    TransactionHistoryUpdateColumn[/** column name */ "ProviderFee"] = "provider_fee";
    TransactionHistoryUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    TransactionHistoryUpdateColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    TransactionHistoryUpdateColumn[/** column name */ "Remark"] = "remark";
    TransactionHistoryUpdateColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    TransactionHistoryUpdateColumn[/** column name */ "Status"] = "status";
    TransactionHistoryUpdateColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    TransactionHistoryUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    TransactionHistoryUpdateColumn[/** column name */ "Type"] = "type";
})(TransactionHistoryUpdateColumn || (TransactionHistoryUpdateColumn = {}));
var UserActivateTokenConstraint;
(function(UserActivateTokenConstraint) {
    UserActivateTokenConstraint[/** unique or primary key constraint on columns "token" */ "UserActivateTokenPkey"] = "user_activate_token_pkey";
    UserActivateTokenConstraint[/** unique or primary key constraint on columns "token" */ "UserActivateTokenTokenKey"] = "user_activate_token_token_key";
})(UserActivateTokenConstraint || (UserActivateTokenConstraint = {}));
var UserActivateTokenSelectColumn;
(function(UserActivateTokenSelectColumn) {
    UserActivateTokenSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    UserActivateTokenSelectColumn[/** column name */ "ExpiredAt"] = "expired_at";
    UserActivateTokenSelectColumn[/** column name */ "SentAt"] = "sent_at";
    UserActivateTokenSelectColumn[/** column name */ "Token"] = "token";
    UserActivateTokenSelectColumn[/** column name */ "UserActivateTokenTypeId"] = "user_activate_token_type_id";
    UserActivateTokenSelectColumn[/** column name */ "UserId"] = "user_id";
})(UserActivateTokenSelectColumn || (UserActivateTokenSelectColumn = {}));
var UserActivateTokenUpdateColumn;
(function(UserActivateTokenUpdateColumn) {
    UserActivateTokenUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    UserActivateTokenUpdateColumn[/** column name */ "ExpiredAt"] = "expired_at";
    UserActivateTokenUpdateColumn[/** column name */ "SentAt"] = "sent_at";
    UserActivateTokenUpdateColumn[/** column name */ "Token"] = "token";
    UserActivateTokenUpdateColumn[/** column name */ "UserActivateTokenTypeId"] = "user_activate_token_type_id";
    UserActivateTokenUpdateColumn[/** column name */ "UserId"] = "user_id";
})(UserActivateTokenUpdateColumn || (UserActivateTokenUpdateColumn = {}));
var UserAuditConstraint;
(function(UserAuditConstraint) {
    UserAuditConstraint[/** unique or primary key constraint on columns "id" */ "UserAuditPkey"] = "user_audit_pkey";
})(UserAuditConstraint || (UserAuditConstraint = {}));
var UserAuditSelectColumn;
(function(UserAuditSelectColumn) {
    UserAuditSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    UserAuditSelectColumn[/** column name */ "Id"] = "id";
    UserAuditSelectColumn[/** column name */ "Message"] = "message";
    UserAuditSelectColumn[/** column name */ "Payload"] = "payload";
    UserAuditSelectColumn[/** column name */ "UserId"] = "user_id";
})(UserAuditSelectColumn || (UserAuditSelectColumn = {}));
var UserAuditUpdateColumn;
(function(UserAuditUpdateColumn) {
    UserAuditUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    UserAuditUpdateColumn[/** column name */ "Id"] = "id";
    UserAuditUpdateColumn[/** column name */ "Message"] = "message";
    UserAuditUpdateColumn[/** column name */ "Payload"] = "payload";
    UserAuditUpdateColumn[/** column name */ "UserId"] = "user_id";
})(UserAuditUpdateColumn || (UserAuditUpdateColumn = {}));
var UserConstraint;
(function(UserConstraint) {
    UserConstraint[/** unique or primary key constraint on columns "id" */ "UserPkey"] = "user_pkey";
    UserConstraint[/** unique or primary key constraint on columns "username" */ "UserUsernameKey"] = "user_username_key";
})(UserConstraint || (UserConstraint = {}));
var UserInfoConstraint;
(function(UserInfoConstraint) {
    UserInfoConstraint[/** unique or primary key constraint on columns "user_id" */ "UserInfoPkey"] = "user_info_pkey";
})(UserInfoConstraint || (UserInfoConstraint = {}));
var UserInfoSelectColumn;
(function(UserInfoSelectColumn) {
    UserInfoSelectColumn[/** column name */ "Birthday"] = "birthday";
    UserInfoSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    UserInfoSelectColumn[/** column name */ "Email"] = "email";
    UserInfoSelectColumn[/** column name */ "GenderId"] = "gender_id";
    UserInfoSelectColumn[/** column name */ "Id"] = "id";
    UserInfoSelectColumn[/** column name */ "Name"] = "name";
    UserInfoSelectColumn[/** column name */ "Phone"] = "phone";
    UserInfoSelectColumn[/** column name */ "Telegram"] = "telegram";
    UserInfoSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    UserInfoSelectColumn[/** column name */ "UserId"] = "user_id";
    UserInfoSelectColumn[/** column name */ "Whatsapp"] = "whatsapp";
})(UserInfoSelectColumn || (UserInfoSelectColumn = {}));
var UserInfoUpdateColumn;
(function(UserInfoUpdateColumn) {
    UserInfoUpdateColumn[/** column name */ "Birthday"] = "birthday";
    UserInfoUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    UserInfoUpdateColumn[/** column name */ "Email"] = "email";
    UserInfoUpdateColumn[/** column name */ "GenderId"] = "gender_id";
    UserInfoUpdateColumn[/** column name */ "Id"] = "id";
    UserInfoUpdateColumn[/** column name */ "Name"] = "name";
    UserInfoUpdateColumn[/** column name */ "Phone"] = "phone";
    UserInfoUpdateColumn[/** column name */ "Telegram"] = "telegram";
    UserInfoUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    UserInfoUpdateColumn[/** column name */ "UserId"] = "user_id";
    UserInfoUpdateColumn[/** column name */ "Whatsapp"] = "whatsapp";
})(UserInfoUpdateColumn || (UserInfoUpdateColumn = {}));
var UserReportsConstraint;
(function(UserReportsConstraint) {
    UserReportsConstraint[/** unique or primary key constraint on columns "id" */ "UserReportsPkey"] = "user_reports_pkey";
})(UserReportsConstraint || (UserReportsConstraint = {}));
var UserReportsSelectColumn;
(function(UserReportsSelectColumn) {
    UserReportsSelectColumn[/** column name */ "Data"] = "data";
    UserReportsSelectColumn[/** column name */ "DateFrom"] = "date_from";
    UserReportsSelectColumn[/** column name */ "DateTo"] = "date_to";
    UserReportsSelectColumn[/** column name */ "Id"] = "id";
    UserReportsSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    UserReportsSelectColumn[/** column name */ "Name"] = "name";
    UserReportsSelectColumn[/** column name */ "UserId"] = "user_id";
})(UserReportsSelectColumn || (UserReportsSelectColumn = {}));
var UserReportsUpdateColumn;
(function(UserReportsUpdateColumn) {
    UserReportsUpdateColumn[/** column name */ "Data"] = "data";
    UserReportsUpdateColumn[/** column name */ "DateFrom"] = "date_from";
    UserReportsUpdateColumn[/** column name */ "DateTo"] = "date_to";
    UserReportsUpdateColumn[/** column name */ "Id"] = "id";
    UserReportsUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    UserReportsUpdateColumn[/** column name */ "Name"] = "name";
    UserReportsUpdateColumn[/** column name */ "UserId"] = "user_id";
})(UserReportsUpdateColumn || (UserReportsUpdateColumn = {}));
var UserSelectColumn;
(function(UserSelectColumn) {
    UserSelectColumn[/** column name */ "ActivatedAt"] = "activated_at";
    UserSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    UserSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    UserSelectColumn[/** column name */ "Id"] = "id";
    UserSelectColumn[/** column name */ "OtpEnable"] = "otp_enable";
    UserSelectColumn[/** column name */ "PasswordHash"] = "password_hash";
    UserSelectColumn[/** column name */ "RegistrationInfoId"] = "registration_info_id";
    UserSelectColumn[/** column name */ "RoleId"] = "role_id";
    UserSelectColumn[/** column name */ "ShowWelcomeHint"] = "show_welcome_hint";
    UserSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    UserSelectColumn[/** column name */ "UserSecretId"] = "user_secret_id";
    UserSelectColumn[/** column name */ "Username"] = "username";
})(UserSelectColumn || (UserSelectColumn = {}));
var UserUpdateColumn;
(function(UserUpdateColumn) {
    UserUpdateColumn[/** column name */ "ActivatedAt"] = "activated_at";
    UserUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    UserUpdateColumn[/** column name */ "EditUserId"] = "edit_user_id";
    UserUpdateColumn[/** column name */ "Id"] = "id";
    UserUpdateColumn[/** column name */ "OtpEnable"] = "otp_enable";
    UserUpdateColumn[/** column name */ "PasswordHash"] = "password_hash";
    UserUpdateColumn[/** column name */ "RegistrationInfoId"] = "registration_info_id";
    UserUpdateColumn[/** column name */ "RoleId"] = "role_id";
    UserUpdateColumn[/** column name */ "ShowWelcomeHint"] = "show_welcome_hint";
    UserUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    UserUpdateColumn[/** column name */ "UserSecretId"] = "user_secret_id";
    UserUpdateColumn[/** column name */ "Username"] = "username";
})(UserUpdateColumn || (UserUpdateColumn = {}));
var VActiveGateSelectColumn;
(function(VActiveGateSelectColumn) {
    VActiveGateSelectColumn[/** column name */ "Alias"] = "alias";
    VActiveGateSelectColumn[/** column name */ "BlockedAt"] = "blocked_at";
    VActiveGateSelectColumn[/** column name */ "CardSystem"] = "card_system";
    VActiveGateSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VActiveGateSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VActiveGateSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    VActiveGateSelectColumn[/** column name */ "EditUserId"] = "edit_user_id";
    VActiveGateSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    VActiveGateSelectColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    VActiveGateSelectColumn[/** column name */ "Id"] = "id";
    VActiveGateSelectColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    VActiveGateSelectColumn[/** column name */ "MerchantConstantFee"] = "merchant_constant_fee";
    VActiveGateSelectColumn[/** column name */ "MerchantFeeMinAmount"] = "merchant_fee_min_amount";
    VActiveGateSelectColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    VActiveGateSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VActiveGateSelectColumn[/** column name */ "MerchantSettlementUsdtFeePercent"] = "merchant_settlement_usdt_fee_percent";
    VActiveGateSelectColumn[/** column name */ "MerchantTransactionFeeAmount"] = "merchant_transaction_fee_amount";
    VActiveGateSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    VActiveGateSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VActiveGateSelectColumn[/** column name */ "PublishedAt"] = "published_at";
    VActiveGateSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    VActiveGateSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    VActiveGateSelectColumn[/** column name */ "SettlementUsdtFeePercent"] = "settlement_usdt_fee_percent";
    VActiveGateSelectColumn[/** column name */ "Sort"] = "sort";
    VActiveGateSelectColumn[/** column name */ "TrafficTypeId"] = "traffic_type_id";
    VActiveGateSelectColumn[/** column name */ "TransactionFeeAmount"] = "transaction_fee_amount";
    VActiveGateSelectColumn[/** column name */ "UnlockedAt"] = "unlocked_at";
    VActiveGateSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(VActiveGateSelectColumn || (VActiveGateSelectColumn = {}));
var VActiveProviderSelectColumn;
(function(VActiveProviderSelectColumn) {
    VActiveProviderSelectColumn[/** column name */ "Alias"] = "alias";
    VActiveProviderSelectColumn[/** column name */ "DefaultPaymentSystem"] = "default_payment_system";
    VActiveProviderSelectColumn[/** column name */ "DefaultTrafficTypeId"] = "default_traffic_type_id";
    VActiveProviderSelectColumn[/** column name */ "Id"] = "id";
    VActiveProviderSelectColumn[/** column name */ "Name"] = "name";
    VActiveProviderSelectColumn[/** column name */ "ProviderStatusId"] = "provider_status_id";
    VActiveProviderSelectColumn[/** column name */ "ProviderTypeId"] = "provider_type_id";
})(VActiveProviderSelectColumn || (VActiveProviderSelectColumn = {}));
var VActiveRollingReserveSelectColumn;
(function(VActiveRollingReserveSelectColumn) {
    VActiveRollingReserveSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VActiveRollingReserveSelectColumn[/** column name */ "GateId"] = "gate_id";
    VActiveRollingReserveSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VActiveRollingReserveSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VActiveRollingReserveSelectColumn[/** column name */ "RollingReserveAmount"] = "rolling_reserve_amount";
})(VActiveRollingReserveSelectColumn || (VActiveRollingReserveSelectColumn = {}));
var VAdminChargebackSelectColumn;
(function(VAdminChargebackSelectColumn) {
    VAdminChargebackSelectColumn[/** column name */ "Amount"] = "amount";
    VAdminChargebackSelectColumn[/** column name */ "ChargebackFee"] = "chargeback_fee";
    VAdminChargebackSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VAdminChargebackSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VAdminChargebackSelectColumn[/** column name */ "GateGroupName"] = "gate_group_name";
    VAdminChargebackSelectColumn[/** column name */ "GateId"] = "gate_id";
    VAdminChargebackSelectColumn[/** column name */ "Id"] = "id";
    VAdminChargebackSelectColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    VAdminChargebackSelectColumn[/** column name */ "IsPaid"] = "is_paid";
    VAdminChargebackSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VAdminChargebackSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VAdminChargebackSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(VAdminChargebackSelectColumn || (VAdminChargebackSelectColumn = {}));
var VAdminGateListSelectColumn;
(function(VAdminGateListSelectColumn) {
    VAdminGateListSelectColumn[/** column name */ "Alias"] = "alias";
    VAdminGateListSelectColumn[/** column name */ "CardSystem"] = "card_system";
    VAdminGateListSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VAdminGateListSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    VAdminGateListSelectColumn[/** column name */ "GateGroupName"] = "gate_group_name";
    VAdminGateListSelectColumn[/** column name */ "GateTypeId"] = "gate_type_id";
    VAdminGateListSelectColumn[/** column name */ "Id"] = "id";
    VAdminGateListSelectColumn[/** column name */ "MerchantConstantFee"] = "merchant_constant_fee";
    VAdminGateListSelectColumn[/** column name */ "MerchantFeeMinAmount"] = "merchant_fee_min_amount";
    VAdminGateListSelectColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    VAdminGateListSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VAdminGateListSelectColumn[/** column name */ "MerchantSettlementUsdtFeePercent"] = "merchant_settlement_usdt_fee_percent";
    VAdminGateListSelectColumn[/** column name */ "MerchantTransactionFeeAmount"] = "merchant_transaction_fee_amount";
    VAdminGateListSelectColumn[/** column name */ "PaymentLimitAmount"] = "payment_limit_amount";
    VAdminGateListSelectColumn[/** column name */ "PaymentLimitDuration"] = "payment_limit_duration";
    VAdminGateListSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    VAdminGateListSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VAdminGateListSelectColumn[/** column name */ "PublishedAt"] = "published_at";
    VAdminGateListSelectColumn[/** column name */ "RollingReserveDuration"] = "rolling_reserve_duration";
    VAdminGateListSelectColumn[/** column name */ "RollingReservePercent"] = "rolling_reserve_percent";
    VAdminGateListSelectColumn[/** column name */ "SettlementUsdtFeePercent"] = "settlement_usdt_fee_percent";
    VAdminGateListSelectColumn[/** column name */ "TransactionFeeAmount"] = "transaction_fee_amount";
    VAdminGateListSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(VAdminGateListSelectColumn || (VAdminGateListSelectColumn = {}));
var VAdminMerchantListSelectColumn;
(function(VAdminMerchantListSelectColumn) {
    VAdminMerchantListSelectColumn[/** column name */ "Balances"] = "balances";
    VAdminMerchantListSelectColumn[/** column name */ "Comment"] = "comment";
    VAdminMerchantListSelectColumn[/** column name */ "CompanyName"] = "company_name";
    VAdminMerchantListSelectColumn[/** column name */ "GateInfo"] = "gate_info";
    VAdminMerchantListSelectColumn[/** column name */ "HoldBalance"] = "hold_balance";
    VAdminMerchantListSelectColumn[/** column name */ "Id"] = "id";
    VAdminMerchantListSelectColumn[/** column name */ "MerchantStatusId"] = "merchant_status_id";
    VAdminMerchantListSelectColumn[/** column name */ "MerchantTypeId"] = "merchant_type_id";
    VAdminMerchantListSelectColumn[/** column name */ "Usernames"] = "usernames";
})(VAdminMerchantListSelectColumn || (VAdminMerchantListSelectColumn = {}));
var VAdminMonitoringSelectColumn;
(function(VAdminMonitoringSelectColumn) {
    VAdminMonitoringSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VAdminMonitoringSelectColumn[/** column name */ "Description"] = "description";
    VAdminMonitoringSelectColumn[/** column name */ "EventType"] = "event_type";
    VAdminMonitoringSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    VAdminMonitoringSelectColumn[/** column name */ "GateGroupName"] = "gate_group_name";
    VAdminMonitoringSelectColumn[/** column name */ "GateGroupProviderFamily"] = "gate_group_provider_family";
    VAdminMonitoringSelectColumn[/** column name */ "GateId"] = "gate_id";
    VAdminMonitoringSelectColumn[/** column name */ "Id"] = "id";
    VAdminMonitoringSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VAdminMonitoringSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
})(VAdminMonitoringSelectColumn || (VAdminMonitoringSelectColumn = {}));
var VAdminPaymentSystemProviderSelectColumn;
(function(VAdminPaymentSystemProviderSelectColumn) {
    VAdminPaymentSystemProviderSelectColumn[/** column name */ "Id"] = "id";
    VAdminPaymentSystemProviderSelectColumn[/** column name */ "PaymentSystemName"] = "payment_system_name";
    VAdminPaymentSystemProviderSelectColumn[/** column name */ "ProviderId"] = "provider_id";
})(VAdminPaymentSystemProviderSelectColumn || (VAdminPaymentSystemProviderSelectColumn = {}));
var VAdminRefundSelectColumn;
(function(VAdminRefundSelectColumn) {
    VAdminRefundSelectColumn[/** column name */ "Amount"] = "amount";
    VAdminRefundSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VAdminRefundSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VAdminRefundSelectColumn[/** column name */ "GateGroupName"] = "gate_group_name";
    VAdminRefundSelectColumn[/** column name */ "GateId"] = "gate_id";
    VAdminRefundSelectColumn[/** column name */ "Id"] = "id";
    VAdminRefundSelectColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    VAdminRefundSelectColumn[/** column name */ "IsPaid"] = "is_paid";
    VAdminRefundSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VAdminRefundSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VAdminRefundSelectColumn[/** column name */ "RefundFee"] = "refund_fee";
    VAdminRefundSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(VAdminRefundSelectColumn || (VAdminRefundSelectColumn = {}));
var VAdminWithdrawRequestSelectColumn;
(function(VAdminWithdrawRequestSelectColumn) {
    VAdminWithdrawRequestSelectColumn[/** column name */ "Amount"] = "amount";
    VAdminWithdrawRequestSelectColumn[/** column name */ "ApprovedAt"] = "approved_at";
    VAdminWithdrawRequestSelectColumn[/** column name */ "ClientIp"] = "client_ip";
    VAdminWithdrawRequestSelectColumn[/** column name */ "Comment"] = "comment";
    VAdminWithdrawRequestSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VAdminWithdrawRequestSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VAdminWithdrawRequestSelectColumn[/** column name */ "GateGroupBalance"] = "gate_group_balance";
    VAdminWithdrawRequestSelectColumn[/** column name */ "GateId"] = "gate_id";
    VAdminWithdrawRequestSelectColumn[/** column name */ "Id"] = "id";
    VAdminWithdrawRequestSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VAdminWithdrawRequestSelectColumn[/** column name */ "MerchantWithdrawFeeAmount"] = "merchant_withdraw_fee_amount";
    VAdminWithdrawRequestSelectColumn[/** column name */ "Phone"] = "phone";
    VAdminWithdrawRequestSelectColumn[/** column name */ "ProviderBalance"] = "provider_balance";
    VAdminWithdrawRequestSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    VAdminWithdrawRequestSelectColumn[/** column name */ "RejectReason"] = "reject_reason";
    VAdminWithdrawRequestSelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    VAdminWithdrawRequestSelectColumn[/** column name */ "Status"] = "status";
    VAdminWithdrawRequestSelectColumn[/** column name */ "TotalBalance"] = "total_balance";
    VAdminWithdrawRequestSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(VAdminWithdrawRequestSelectColumn || (VAdminWithdrawRequestSelectColumn = {}));
var VGateGroupBalanceSelectColumn;
(function(VGateGroupBalanceSelectColumn) {
    VGateGroupBalanceSelectColumn[/** column name */ "CalculatedBalance"] = "calculated_balance";
    VGateGroupBalanceSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VGateGroupBalanceSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VGateGroupBalanceSelectColumn[/** column name */ "DeletedAt"] = "deleted_at";
    VGateGroupBalanceSelectColumn[/** column name */ "Id"] = "id";
    VGateGroupBalanceSelectColumn[/** column name */ "InvoiceGateId"] = "invoice_gate_id";
    VGateGroupBalanceSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VGateGroupBalanceSelectColumn[/** column name */ "Name"] = "name";
    VGateGroupBalanceSelectColumn[/** column name */ "ProviderFamily"] = "provider_family";
    VGateGroupBalanceSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    VGateGroupBalanceSelectColumn[/** column name */ "WithdrawGateId"] = "withdraw_gate_id";
})(VGateGroupBalanceSelectColumn || (VGateGroupBalanceSelectColumn = {}));
var VHasuraPermissionSelectColumn;
(function(VHasuraPermissionSelectColumn) {
    VHasuraPermissionSelectColumn[/** column name */ "Id"] = "id";
    VHasuraPermissionSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VHasuraPermissionSelectColumn[/** column name */ "Role"] = "role";
    VHasuraPermissionSelectColumn[/** column name */ "UserId"] = "user_id";
})(VHasuraPermissionSelectColumn || (VHasuraPermissionSelectColumn = {}));
var VLkChargebackSelectColumn;
(function(VLkChargebackSelectColumn) {
    VLkChargebackSelectColumn[/** column name */ "Amount"] = "amount";
    VLkChargebackSelectColumn[/** column name */ "ChargebackFee"] = "chargeback_fee";
    VLkChargebackSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    VLkChargebackSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    VLkChargebackSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    VLkChargebackSelectColumn[/** column name */ "GateId"] = "gate_id";
    VLkChargebackSelectColumn[/** column name */ "Id"] = "id";
    VLkChargebackSelectColumn[/** column name */ "InvoiceTransactionUid"] = "invoice_transaction_uid";
    VLkChargebackSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    VLkChargebackSelectColumn[/** column name */ "WithdrawTransactionUid"] = "withdraw_transaction_uid";
})(VLkChargebackSelectColumn || (VLkChargebackSelectColumn = {}));
var VLkGateFeeSelectColumn;
(function(VLkGateFeeSelectColumn) {
    VLkGateFeeSelectColumn[/** column name */ "Id"] = "id";
    VLkGateFeeSelectColumn[/** column name */ "MerchantConstantFee"] = "merchant_constant_fee";
    VLkGateFeeSelectColumn[/** column name */ "MerchantFeeMinAmount"] = "merchant_fee_min_amount";
    VLkGateFeeSelectColumn[/** column name */ "MerchantFeePercent"] = "merchant_fee_percent";
    VLkGateFeeSelectColumn[/** column name */ "MerchantSettlementUsdtFeePercent"] = "merchant_settlement_usdt_fee_percent";
    VLkGateFeeSelectColumn[/** column name */ "MerchantTransactionDeclineFeeAmount"] = "merchant_transaction_decline_fee_amount";
    VLkGateFeeSelectColumn[/** column name */ "MerchantTransactionFeeAmount"] = "merchant_transaction_fee_amount";
})(VLkGateFeeSelectColumn || (VLkGateFeeSelectColumn = {}));
var WidgetTypeConstraint;
(function(WidgetTypeConstraint) {
    WidgetTypeConstraint[/** unique or primary key constraint on columns "id" */ "WidgetTypePkey"] = "widget_type_pkey";
})(WidgetTypeConstraint || (WidgetTypeConstraint = {}));
var WidgetTypeSelectColumn;
(function(WidgetTypeSelectColumn) {
    WidgetTypeSelectColumn[/** column name */ "Id"] = "id";
    WidgetTypeSelectColumn[/** column name */ "Name"] = "name";
})(WidgetTypeSelectColumn || (WidgetTypeSelectColumn = {}));
var WidgetTypeUpdateColumn;
(function(WidgetTypeUpdateColumn) {
    WidgetTypeUpdateColumn[/** column name */ "Id"] = "id";
    WidgetTypeUpdateColumn[/** column name */ "Name"] = "name";
})(WidgetTypeUpdateColumn || (WidgetTypeUpdateColumn = {}));
var WithdrawConstraint;
(function(WithdrawConstraint) {
    WithdrawConstraint[/** unique or primary key constraint on columns "external_id", "merchant_id", "gate_id" */ "WithdrawMerchantIdExternalIdGateIdKey"] = "withdraw_merchant_id_external_id_gate_id_key";
    WithdrawConstraint[/** unique or primary key constraint on columns "id" */ "WithdrawPkey"] = "withdraw_pkey";
    WithdrawConstraint[/** unique or primary key constraint on columns "provider_transaction_uid" */ "WithdrawProviderTransactionUidKey"] = "withdraw_provider_transaction_uid_key";
    WithdrawConstraint[/** unique or primary key constraint on columns "transaction_uid" */ "WithdrawTransactionUidKey"] = "withdraw_transaction_uid_key";
})(WithdrawConstraint || (WithdrawConstraint = {}));
var WithdrawRequestConstraint;
(function(WithdrawRequestConstraint) {
    WithdrawRequestConstraint[/** unique or primary key constraint on columns "id" */ "WithdrawRequestPkey"] = "withdraw_request_pkey";
})(WithdrawRequestConstraint || (WithdrawRequestConstraint = {}));
var WithdrawRequestSelectColumn;
(function(WithdrawRequestSelectColumn) {
    WithdrawRequestSelectColumn[/** column name */ "Amount"] = "amount";
    WithdrawRequestSelectColumn[/** column name */ "ApprovedAt"] = "approved_at";
    WithdrawRequestSelectColumn[/** column name */ "ClientIp"] = "client_ip";
    WithdrawRequestSelectColumn[/** column name */ "Comment"] = "comment";
    WithdrawRequestSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    WithdrawRequestSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    WithdrawRequestSelectColumn[/** column name */ "GateId"] = "gate_id";
    WithdrawRequestSelectColumn[/** column name */ "Id"] = "id";
    WithdrawRequestSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    WithdrawRequestSelectColumn[/** column name */ "MerchantWithdrawFeeAmount"] = "merchant_withdraw_fee_amount";
    WithdrawRequestSelectColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    WithdrawRequestSelectColumn[/** column name */ "Phone"] = "phone";
    WithdrawRequestSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    WithdrawRequestSelectColumn[/** column name */ "RejectReason"] = "reject_reason";
    WithdrawRequestSelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    WithdrawRequestSelectColumn[/** column name */ "Status"] = "status";
    WithdrawRequestSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(WithdrawRequestSelectColumn || (WithdrawRequestSelectColumn = {}));
var WithdrawRequestStatusConstraint;
(function(WithdrawRequestStatusConstraint) {
    WithdrawRequestStatusConstraint[/** unique or primary key constraint on columns "id" */ "WithdrawRequestStatusPkey"] = "withdraw_request_status_pkey";
})(WithdrawRequestStatusConstraint || (WithdrawRequestStatusConstraint = {}));
var WithdrawRequestStatusSelectColumn;
(function(WithdrawRequestStatusSelectColumn) {
    WithdrawRequestStatusSelectColumn[/** column name */ "Id"] = "id";
    WithdrawRequestStatusSelectColumn[/** column name */ "Name"] = "name";
})(WithdrawRequestStatusSelectColumn || (WithdrawRequestStatusSelectColumn = {}));
var WithdrawRequestStatusUpdateColumn;
(function(WithdrawRequestStatusUpdateColumn) {
    WithdrawRequestStatusUpdateColumn[/** column name */ "Id"] = "id";
    WithdrawRequestStatusUpdateColumn[/** column name */ "Name"] = "name";
})(WithdrawRequestStatusUpdateColumn || (WithdrawRequestStatusUpdateColumn = {}));
var WithdrawRequestUpdateColumn;
(function(WithdrawRequestUpdateColumn) {
    WithdrawRequestUpdateColumn[/** column name */ "Amount"] = "amount";
    WithdrawRequestUpdateColumn[/** column name */ "ApprovedAt"] = "approved_at";
    WithdrawRequestUpdateColumn[/** column name */ "ClientIp"] = "client_ip";
    WithdrawRequestUpdateColumn[/** column name */ "Comment"] = "comment";
    WithdrawRequestUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    WithdrawRequestUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    WithdrawRequestUpdateColumn[/** column name */ "GateId"] = "gate_id";
    WithdrawRequestUpdateColumn[/** column name */ "Id"] = "id";
    WithdrawRequestUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    WithdrawRequestUpdateColumn[/** column name */ "MerchantWithdrawFeeAmount"] = "merchant_withdraw_fee_amount";
    WithdrawRequestUpdateColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    WithdrawRequestUpdateColumn[/** column name */ "Phone"] = "phone";
    WithdrawRequestUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    WithdrawRequestUpdateColumn[/** column name */ "RejectReason"] = "reject_reason";
    WithdrawRequestUpdateColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    WithdrawRequestUpdateColumn[/** column name */ "Status"] = "status";
    WithdrawRequestUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
})(WithdrawRequestUpdateColumn || (WithdrawRequestUpdateColumn = {}));
var WithdrawSelectColumn;
(function(WithdrawSelectColumn) {
    WithdrawSelectColumn[/** column name */ "AdditionalData"] = "additional_data";
    WithdrawSelectColumn[/** column name */ "Amount"] = "amount";
    WithdrawSelectColumn[/** column name */ "BankId"] = "bank_id";
    WithdrawSelectColumn[/** column name */ "CallbackUrl"] = "callback_url";
    WithdrawSelectColumn[/** column name */ "CardSystemId"] = "card_system_id";
    WithdrawSelectColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    WithdrawSelectColumn[/** column name */ "ClientIp"] = "client_ip";
    WithdrawSelectColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    WithdrawSelectColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    WithdrawSelectColumn[/** column name */ "Comment"] = "comment";
    WithdrawSelectColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    WithdrawSelectColumn[/** column name */ "CreatedAt"] = "created_at";
    WithdrawSelectColumn[/** column name */ "CurrencyId"] = "currency_id";
    WithdrawSelectColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    WithdrawSelectColumn[/** column name */ "CurrencyRateProviderId"] = "currency_rate_provider_id";
    WithdrawSelectColumn[/** column name */ "ExternalId"] = "external_id";
    WithdrawSelectColumn[/** column name */ "FortStoreId"] = "fort_store_id";
    WithdrawSelectColumn[/** column name */ "GateCurrencyAmount"] = "gate_currency_amount";
    WithdrawSelectColumn[/** column name */ "GateCurrencyRate"] = "gate_currency_rate";
    WithdrawSelectColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    WithdrawSelectColumn[/** column name */ "GateId"] = "gate_id";
    WithdrawSelectColumn[/** column name */ "Id"] = "id";
    WithdrawSelectColumn[/** column name */ "InputCurrencyAmount"] = "input_currency_amount";
    WithdrawSelectColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    WithdrawSelectColumn[/** column name */ "IsChargeback"] = "is_chargeback";
    WithdrawSelectColumn[/** column name */ "IsClientLimit"] = "is_client_limit";
    WithdrawSelectColumn[/** column name */ "IsHidden"] = "is_hidden";
    WithdrawSelectColumn[/** column name */ "IsManual"] = "is_manual";
    WithdrawSelectColumn[/** column name */ "IsRefund"] = "is_refund";
    WithdrawSelectColumn[/** column name */ "IsSettlement"] = "is_settlement";
    WithdrawSelectColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    WithdrawSelectColumn[/** column name */ "MerchantId"] = "merchant_id";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeIsPayed"] = "merchant_withdraw_decline_transaction_fee_is_payed";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawFee"] = "merchant_withdraw_fee";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    WithdrawSelectColumn[/** column name */ "MerchantWithdrawTransactionFeeIsPayed"] = "merchant_withdraw_transaction_fee_is_payed";
    WithdrawSelectColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    WithdrawSelectColumn[/** column name */ "PaymentSystem"] = "payment_system";
    WithdrawSelectColumn[/** column name */ "Profit"] = "profit";
    WithdrawSelectColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    WithdrawSelectColumn[/** column name */ "ProviderFamily"] = "provider_family";
    WithdrawSelectColumn[/** column name */ "ProviderId"] = "provider_id";
    WithdrawSelectColumn[/** column name */ "ProviderPayload"] = "provider_payload";
    WithdrawSelectColumn[/** column name */ "ProviderStatus"] = "provider_status";
    WithdrawSelectColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    WithdrawSelectColumn[/** column name */ "ProviderWithdrawFee"] = "provider_withdraw_fee";
    WithdrawSelectColumn[/** column name */ "ProviderWithdrawFeePercent"] = "provider_withdraw_fee_percent";
    WithdrawSelectColumn[/** column name */ "ProviderWithdrawId"] = "provider_withdraw_id";
    WithdrawSelectColumn[/** column name */ "ReconciliatedAt"] = "reconciliated_at";
    WithdrawSelectColumn[/** column name */ "Refund"] = "refund";
    WithdrawSelectColumn[/** column name */ "RefundTransactionUid"] = "refund_transaction_uid";
    WithdrawSelectColumn[/** column name */ "Remark"] = "remark";
    WithdrawSelectColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    WithdrawSelectColumn[/** column name */ "SmartRemark"] = "smart_remark";
    WithdrawSelectColumn[/** column name */ "Status"] = "status";
    WithdrawSelectColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    WithdrawSelectColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    WithdrawSelectColumn[/** column name */ "UpdatedAt"] = "updated_at";
    WithdrawSelectColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
    WithdrawSelectColumn[/** column name */ "WithdrawUrl"] = "withdraw_url";
})(WithdrawSelectColumn || (WithdrawSelectColumn = {}));
var WithdrawUpdateColumn;
(function(WithdrawUpdateColumn) {
    WithdrawUpdateColumn[/** column name */ "AdditionalData"] = "additional_data";
    WithdrawUpdateColumn[/** column name */ "Amount"] = "amount";
    WithdrawUpdateColumn[/** column name */ "BankId"] = "bank_id";
    WithdrawUpdateColumn[/** column name */ "CallbackUrl"] = "callback_url";
    WithdrawUpdateColumn[/** column name */ "CardSystemId"] = "card_system_id";
    WithdrawUpdateColumn[/** column name */ "CascadeRequestId"] = "cascade_request_id";
    WithdrawUpdateColumn[/** column name */ "ClientIp"] = "client_ip";
    WithdrawUpdateColumn[/** column name */ "ClientLimitDuration"] = "client_limit_duration";
    WithdrawUpdateColumn[/** column name */ "ClientLimitPeriod"] = "client_limit_period";
    WithdrawUpdateColumn[/** column name */ "Comment"] = "comment";
    WithdrawUpdateColumn[/** column name */ "ConstantWithdrawFee"] = "constant_withdraw_fee";
    WithdrawUpdateColumn[/** column name */ "CreatedAt"] = "created_at";
    WithdrawUpdateColumn[/** column name */ "CurrencyId"] = "currency_id";
    WithdrawUpdateColumn[/** column name */ "CurrencyRate"] = "currency_rate";
    WithdrawUpdateColumn[/** column name */ "CurrencyRateProviderId"] = "currency_rate_provider_id";
    WithdrawUpdateColumn[/** column name */ "ExternalId"] = "external_id";
    WithdrawUpdateColumn[/** column name */ "FortStoreId"] = "fort_store_id";
    WithdrawUpdateColumn[/** column name */ "GateCurrencyAmount"] = "gate_currency_amount";
    WithdrawUpdateColumn[/** column name */ "GateCurrencyRate"] = "gate_currency_rate";
    WithdrawUpdateColumn[/** column name */ "GateGroupId"] = "gate_group_id";
    WithdrawUpdateColumn[/** column name */ "GateId"] = "gate_id";
    WithdrawUpdateColumn[/** column name */ "Id"] = "id";
    WithdrawUpdateColumn[/** column name */ "InputCurrencyAmount"] = "input_currency_amount";
    WithdrawUpdateColumn[/** column name */ "InputCurrencyId"] = "input_currency_id";
    WithdrawUpdateColumn[/** column name */ "IsChargeback"] = "is_chargeback";
    WithdrawUpdateColumn[/** column name */ "IsClientLimit"] = "is_client_limit";
    WithdrawUpdateColumn[/** column name */ "IsHidden"] = "is_hidden";
    WithdrawUpdateColumn[/** column name */ "IsManual"] = "is_manual";
    WithdrawUpdateColumn[/** column name */ "IsRefund"] = "is_refund";
    WithdrawUpdateColumn[/** column name */ "IsSettlement"] = "is_settlement";
    WithdrawUpdateColumn[/** column name */ "MerchantConstantWithdrawFee"] = "merchant_constant_withdraw_fee";
    WithdrawUpdateColumn[/** column name */ "MerchantId"] = "merchant_id";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeAmount"] = "merchant_withdraw_decline_transaction_fee_amount";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawDeclineTransactionFeeIsPayed"] = "merchant_withdraw_decline_transaction_fee_is_payed";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawFee"] = "merchant_withdraw_fee";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawFeeMinAmount"] = "merchant_withdraw_fee_min_amount";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawFeePercent"] = "merchant_withdraw_fee_percent";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawTransactionFeeAmount"] = "merchant_withdraw_transaction_fee_amount";
    WithdrawUpdateColumn[/** column name */ "MerchantWithdrawTransactionFeeIsPayed"] = "merchant_withdraw_transaction_fee_is_payed";
    WithdrawUpdateColumn[/** column name */ "PaymentSourceId"] = "payment_source_id";
    WithdrawUpdateColumn[/** column name */ "PaymentSystem"] = "payment_system";
    WithdrawUpdateColumn[/** column name */ "Profit"] = "profit";
    WithdrawUpdateColumn[/** column name */ "ProviderAmount"] = "provider_amount";
    WithdrawUpdateColumn[/** column name */ "ProviderFamily"] = "provider_family";
    WithdrawUpdateColumn[/** column name */ "ProviderId"] = "provider_id";
    WithdrawUpdateColumn[/** column name */ "ProviderPayload"] = "provider_payload";
    WithdrawUpdateColumn[/** column name */ "ProviderStatus"] = "provider_status";
    WithdrawUpdateColumn[/** column name */ "ProviderTransactionUid"] = "provider_transaction_uid";
    WithdrawUpdateColumn[/** column name */ "ProviderWithdrawFee"] = "provider_withdraw_fee";
    WithdrawUpdateColumn[/** column name */ "ProviderWithdrawFeePercent"] = "provider_withdraw_fee_percent";
    WithdrawUpdateColumn[/** column name */ "ProviderWithdrawId"] = "provider_withdraw_id";
    WithdrawUpdateColumn[/** column name */ "ReconciliatedAt"] = "reconciliated_at";
    WithdrawUpdateColumn[/** column name */ "Refund"] = "refund";
    WithdrawUpdateColumn[/** column name */ "RefundTransactionUid"] = "refund_transaction_uid";
    WithdrawUpdateColumn[/** column name */ "Remark"] = "remark";
    WithdrawUpdateColumn[/** column name */ "SanitizedMask"] = "sanitized_mask";
    WithdrawUpdateColumn[/** column name */ "SmartRemark"] = "smart_remark";
    WithdrawUpdateColumn[/** column name */ "Status"] = "status";
    WithdrawUpdateColumn[/** column name */ "StatusUpdatedAt"] = "status_updated_at";
    WithdrawUpdateColumn[/** column name */ "TransactionUid"] = "transaction_uid";
    WithdrawUpdateColumn[/** column name */ "UpdatedAt"] = "updated_at";
    WithdrawUpdateColumn[/** column name */ "WithdrawTransactionFeeAmount"] = "withdraw_transaction_fee_amount";
    WithdrawUpdateColumn[/** column name */ "WithdrawUrl"] = "withdraw_url";
})(WithdrawUpdateColumn || (WithdrawUpdateColumn = {}));
var SendFeedbackDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SendFeedback"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "feedbackForm"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "FeedbackForm"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sendInfoToGoogleSheet"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "feedbackForm"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feedbackForm"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};

;// CONCATENATED MODULE: ./generated/gql.ts
/* eslint-disable */ 
/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */ var documents = {
    "\n  mutation SendFeedback($feedbackForm: FeedbackForm!) {\n    sendInfoToGoogleSheet(feedbackForm: $feedbackForm)\n  }\n": SendFeedbackDocument
};
function gql(source) {
    var _source;
    return (_source = documents[source]) !== null && _source !== void 0 ? _source : {};
}

;// CONCATENATED MODULE: ./generated/index.ts



// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
;// CONCATENATED MODULE: ./src/hooks/use-common-apollo-options.ts

function useCommonApolloOptions() {
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    return {
        onError: function(error) {
            enqueueSnackbar(error.message, {
                variant: "error"
            });
        }
    };
}

// EXTERNAL MODULE: ./src/hooks/use-lk-base-path.ts
var use_lk_base_path = __webpack_require__(14620);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
;// CONCATENATED MODULE: ./src/utils/apollo.ts


function getErrors(error) {
    return (0,_instanceof/* default */.Z)(error, errors/* ApolloError */.c) ? error.graphQLErrors.length ? error.graphQLErrors : [
        error
    ] : error !== null && error !== void 0 ? error : [];
}

;// CONCATENATED MODULE: ./src/components/icons/ArrowsForm1V4Icon.tsx

var ArrowsForm1V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M30 31V1H0",
            stroke: "#FFDD00",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsForm2V4Icon.tsx

var ArrowsForm2V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 31V1H31",
            stroke: "#FFDD00",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsForm3V4Icon.tsx

var ArrowsForm3V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 0V30H31",
            stroke: "#FFDD00",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsForm4V4Icon.tsx

var ArrowsForm4V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M30 0V30H0",
            stroke: "#FFDD00",
            strokeWidth: "2"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Checkbox/index.ts + 1 modules
var Checkbox = __webpack_require__(48872);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Control/Control.module.scss
var Control_module = __webpack_require__(33249);
var Control_module_default = /*#__PURE__*/__webpack_require__.n(Control_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Control/Control.tsx




var Control = function(props) {
    var className = props.className, controlId = props.controlId, label = props.label, error = props.error, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        className: (0,clsx_m/* default */.Z)((Control_module_default()).root, className),
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Control_module_default()).label,
                htmlFor: controlId,
                children: label
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Control_module_default()).error,
                children: error || "\xa0"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Control/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/hooks/use-immutable-callback.ts


function useImmutableCallback(callback) {
    var _connectedRef;
    var connectedRef = (0,react.useRef)(callback);
    connectedRef.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (_connectedRef = connectedRef).current.apply(_connectedRef, (0,_to_consumable_array/* default */.Z)(args));
    }, []);
}

;// CONCATENATED MODULE: ./src/hooks/use-combine-refs.ts

function useCombineRefs(refs) {
    return useImmutableCallback(function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") {
                ref(value);
            } else if (ref) {
                ref.current = value;
            }
        });
    });
}

// EXTERNAL MODULE: ./src/utils/dom.ts
var dom = __webpack_require__(46734);
;// CONCATENATED MODULE: ./src/hooks/use-element-size.ts


var useElementSize = function() {
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), size = ref[0], setSize = ref[1];
    var ref1 = (0,react.useState)(null), element = ref1[0], setElement = ref1[1];
    (0,react.useLayoutEffect)(function() {
        var setElementSize = function() {
            if (!element) {
                return;
            }
            var ref = element.getBoundingClientRect(), width = ref.width, height = ref.height;
            setSize(function(currentSize) {
                return currentSize.width === width && currentSize.height === height ? currentSize : {
                    width: width,
                    height: height
                };
            });
        };
        setElementSize();
        if (!element) {
            return;
        }
        return (0,dom/* addResizeListener */.kp)(element, setElementSize);
    }, [
        element
    ]);
    return {
        ref: setElement,
        size: size
    };
};

;// CONCATENATED MODULE: ./src/hooks/use-previous.ts

var usePrevious = function(value) {
    var ref = (0,react.useRef)(value);
    (0,react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

// EXTERNAL MODULE: ./src/components/landingV4/common/Button/index.ts + 1 modules
var Button = __webpack_require__(27362);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Spinner/Spinner.tsx



var Spinner = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                    cx: 12,
                    cy: 12,
                    r: 9.5,
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "stroke-dasharray",
                            calcMode: "spline",
                            dur: "1.5s",
                            keySplines: "0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1",
                            keyTimes: "0;0.475;0.95;1",
                            repeatCount: "indefinite",
                            values: "0 150;42 150;42 150;42 150"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "stroke-dashoffset",
                            calcMode: "spline",
                            dur: "1.5s",
                            keySplines: "0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1",
                            keyTimes: "0;0.475;0.95;1",
                            repeatCount: "indefinite",
                            values: "0;-16;-59;-59"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    dur: "2s",
                    repeatCount: "indefinite",
                    type: "rotate",
                    values: "0 12 12;360 12 12"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Spinner/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/common/FormSubmitButton/FormSubmitButton.tsx











var FormSubmitButton = /*#__PURE__*/ (0,react.forwardRef)(function(props, propsRef) {
    var className = props.className, style = props.style, children = props.children, _saveWidth = props.saveWidth, saveWidth = _saveWidth === void 0 ? true : _saveWidth, iconLeft = props.iconLeft, buttonProps = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "style",
        "children",
        "saveWidth",
        "iconLeft"
    ]);
    var ref = (0,react.useState)(""), buttonWidth = ref[0], setButtonWidth = ref[1];
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), isSubmitting = ref1.formState.isSubmitting;
    var ref2 = useElementSize(), ref3 = ref2.ref, _size = ref2.size, calculatedButtonWidth = _size.width;
    var combinedRef = useCombineRefs([
        ref3,
        propsRef
    ]);
    var prevIsSubmitting = usePrevious(isSubmitting);
    (0,react.useLayoutEffect)(function() {
        if (isSubmitting && !prevIsSubmitting) {
            setButtonWidth(calculatedButtonWidth);
        } else if (!isSubmitting && prevIsSubmitting) {
            setButtonWidth("");
        }
    }, [
        calculatedButtonWidth,
        isSubmitting,
        prevIsSubmitting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonProps), {
        className: className,
        ref: combinedRef,
        type: "submit",
        disabled: buttonProps.disabled || isSubmitting,
        iconLeft: isSubmitting ? null : iconLeft,
        style: saveWidth && buttonWidth ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            width: isSubmitting ? buttonWidth : undefined
        }) : style,
        children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {}) : children
    }));
});
FormSubmitButton.displayName = "FormSubmitButton";

;// CONCATENATED MODULE: ./src/components/landingV4/common/FormSubmitButton/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-text-mask/dist/reactTextMask.js
var reactTextMask = __webpack_require__(91749);
var reactTextMask_default = /*#__PURE__*/__webpack_require__.n(reactTextMask);
// EXTERNAL MODULE: ./src/hooks/use-boolean.ts
var use_boolean = __webpack_require__(47758);
;// CONCATENATED MODULE: ./src/utils/css.ts
function getCssSizeValue(value) {
    // @ts-ignore
    return value == null ? undefined : typeof value === "number" ? "".concat(value, "px") : value;
}

;// CONCATENATED MODULE: ./src/utils/is.ts
var isDefined = function(value) {
    return value != null;
};
var isTruthy = function(value) {
    return Boolean(value);
};
var isArray = Array.isArray;

;// CONCATENATED MODULE: ./src/components/icons/EyeV4Icon.tsx



var EyeV4Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.01662 11.1645C4.06662 6.79251 8.02127 4.5 11.9831 4.5C16.6362 4.5 20.6443 7.53129 23.0091 11.1836L23.0102 11.1853C23.1667 11.4285 23.2499 11.7115 23.2499 12.0007C23.2499 12.2893 23.167 12.5719 23.0111 12.8147C20.6483 16.5141 16.6661 19.5 11.9831 19.5C7.25032 19.5 3.34483 16.5203 0.987915 12.8317C0.827766 12.583 0.744702 12.2925 0.749197 11.9968C0.753702 11.7002 0.845999 11.4117 1.01443 11.1676L1.01662 11.1645ZM2.24903 12.0196L2.25111 12.0228C4.42804 15.4304 7.91716 18 11.9831 18C16.0036 18 19.5679 15.4195 21.7474 12.0065L21.7489 12.0043C21.7495 12.0032 21.7499 12.002 21.7499 12.0007C21.7499 12.0002 21.7498 11.9996 21.7497 11.9991C21.7496 11.9985 21.7493 11.9979 21.749 11.9973C19.5611 8.61915 15.9676 6 11.9831 6C8.63897 6 5.09927 7.93555 2.24903 12.0196ZM11.9991 9C10.3422 9 8.99907 10.3431 8.99907 12C8.99907 13.6569 10.3422 15 11.9991 15C13.6559 15 14.9991 13.6569 14.9991 12C14.9991 10.3431 13.6559 9 11.9991 9ZM7.49907 12C7.49907 9.51472 9.51379 7.5 11.9991 7.5C14.4844 7.5 16.4991 9.51472 16.4991 12C16.4991 14.4853 14.4844 16.5 11.9991 16.5C9.51379 16.5 7.49907 14.4853 7.49907 12Z",
            fill: "#CEFFF4",
            fillOpacity: "0.5"
        })
    }));
};

// EXTERNAL MODULE: ./src/components/landingV4/common/TextInput/TextInput.module.scss
var TextInput_module = __webpack_require__(35037);
var TextInput_module_default = /*#__PURE__*/__webpack_require__.n(TextInput_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/TextInput/TextInput.tsx
"use client";














var MaskedInput = (reactTextMask_default());
var TextInput = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var className = props.className, value = props.value, type = props.type, multiline = props.multiline, _variant = props.variant, variant = _variant === void 0 ? "default" : _variant, prefix = props.prefix, suffix = props.suffix, _state = props.state, state = _state === void 0 ? "default" : _state, mask = props.mask, onChange = props.onChange, inputProps = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "value",
        "type",
        "multiline",
        "variant",
        "prefix",
        "suffix",
        "state",
        "mask",
        "onChange"
    ]);
    var _$ref = (0,use_boolean/* useBoolean */.k)(false), openedPassword = _$ref.value, toggleOpenedPassword = _$ref.toggle;
    var inputElementProps = (0,_object_spread/* default */.Z)({
        className: (TextInput_module_default()).input,
        type: type === "password" && openedPassword ? "text" : type,
        value: value !== null && value !== void 0 ? value : ""
    }, inputProps);
    var suffixNode = suffix !== null && suffix !== void 0 ? suffix : type === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeV4Icon, {
        onClick: toggleOpenedPassword
    }) : inputProps.required ? "*" : null;
    var _$ref1 = useElementSize(), prefixSize = _$ref1.size, prefixRef = _$ref1.ref;
    var _$ref2 = useElementSize(), suffixSize = _$ref2.size, suffixRef = _$ref2.ref;
    var combinedInputRef = useCombineRefs([
        ref
    ]);
    var Element = multiline ? "textarea" : "input";
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((TextInput_module_default()).root, (TextInput_module_default())["variant_".concat(variant)], (TextInput_module_default())["state_".concat(state)], (_obj = {}, (0,_define_property/* default */.Z)(_obj, (TextInput_module_default()).withPrefix, prefix), (0,_define_property/* default */.Z)(_obj, (TextInput_module_default()).withSuffix, suffixNode), (0,_define_property/* default */.Z)(_obj, (TextInput_module_default()).multiline, multiline), _obj), className),
        style: {
            "--text-input-prefix-width": getCssSizeValue(prefixSize.width),
            "--text-input-suffix-width": getCssSizeValue(suffixSize.width)
        },
        children: [
            mask ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInput, {
                mask: mask,
                onChange: onChange,
                render: function(ref, restProps) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({
                        ref: function(input) {
                            combinedInputRef(input);
                            if (input) {
                                ref(input);
                            }
                        }
                    }, restProps, inputElementProps));
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({
                ref: combinedInputRef,
                onChange: onChange
            }, inputElementProps)),
            isDefined(prefix) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TextInput_module_default()).prefix,
                ref: prefixRef,
                children: prefix
            }),
            isDefined(suffixNode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TextInput_module_default()).suffix,
                ref: suffixRef,
                children: suffixNode
            })
        ]
    });
});
TextInput.displayName = "TextInput";

;// CONCATENATED MODULE: ./src/components/landingV4/common/TextInput/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/common/FormTextInput/FormTextInput.tsx







var FormTextInput = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var name = props.name, label = props.label, textInputProps = (0,_object_without_properties/* default */.Z)(props, [
        "name",
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        render: function(param) {
            var field = param.field, fieldState = param.fieldState;
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Control, {
                label: label,
                error: (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput, (0,_object_spread/* default */.Z)({
                    state: fieldState.invalid ? "error" : "default"
                }, textInputProps, field))
            });
        }
    });
});
FormTextInput.displayName = "FormTextInput";

;// CONCATENATED MODULE: ./src/components/landingV4/common/FormTextInput/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/common/TextLink/index.ts + 1 modules
var TextLink = __webpack_require__(46370);
// EXTERNAL MODULE: ./src/components/landingV4/FeedbackBlock/FeedbackBlock.module.scss
var FeedbackBlock_module = __webpack_require__(68588);
var FeedbackBlock_module_default = /*#__PURE__*/__webpack_require__.n(FeedbackBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/FeedbackBlock/FeedbackBlock.tsx
































var useFormSchema = function() {
    return (0,react.useMemo)(function() {
        return lib.z.object({
            name: lib.z.string().min(1, {
                message: "Field is required"
            }),
            email: lib.z.string().email(),
            phone: lib.z.string(),
            currency: lib.z.string(),
            business_sector: lib.z.string(),
            comment: lib.z.string(),
            privacyConsent: lib.z.boolean().refine(function(v) {
                return v;
            }, {
                message: "You must accept the processing of your personal data"
            })
        });
    }, []);
};
var ADVANTAGES = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsForm1V4Icon, {}),
        title: "Compliance-first mindset"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsForm2V4Icon, {}),
        title: "Partner network"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsForm3V4Icon, {}),
        title: "Dedicated support"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsForm4V4Icon, {}),
        title: "Transparent operations "
    }, 
];
var SendFeedback = gql("\n  mutation SendFeedback($feedbackForm: FeedbackForm!) {\n    sendInfoToGoogleSheet(feedbackForm: $feedbackForm)\n  }\n");
var FeedbackBlock = function(props) {
    var className = props.className;
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    var commonApolloOptions = useCommonApolloOptions();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SendFeedback, (0,_object_spread/* default */.Z)({}, commonApolloOptions)), 1), sendFeedback = ref[0];
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            name: "",
            email: "",
            phone: "",
            currency: "",
            business_sector: "",
            comment: "",
            privacyConsent: false
        },
        resolver: (0,zod/* zodResolver */.F)(useFormSchema()),
        mode: "onBlur",
        reValidateMode: "onChange"
    });
    var register = form.register, handleSubmit = form.handleSubmit, reset = form.reset, control = form.control;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return sendFeedback({
                            variables: {
                                feedbackForm: {
                                    name: data.name,
                                    email: data.email,
                                    phone: data.phone,
                                    currency: data.currency,
                                    business_sector: data.business_sector,
                                    comment: data.comment
                                }
                            }
                        });
                    case 2:
                        errors = _ctx.sent.errors;
                        if (!getErrors(errors).length) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        enqueueSnackbar("Form has been submitted", {
                            variant: "success"
                        });
                        reset();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        enqueueSnackbar,
        reset,
        sendFeedback
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (0,clsx_m/* default */.Z)((FeedbackBlock_module_default()).root, className),
        id: sections/* SECTIONS_IDS.contact */.s.contact,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            className: (FeedbackBlock_module_default()).inner,
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: (FeedbackBlock_module_default()).title,
                    children: [
                        "A payments partner",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "you can rely on"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FeedbackBlock_module_default()).grid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            direction: "column",
                            gap: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular16",
                                    color: "white50",
                                    children: "If you have any questions let us know"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: (FeedbackBlock_module_default()).form,
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (FeedbackBlock_module_default()).formColumns,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (FeedbackBlock_module_default()).formColumn,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name")), {
                                                                required: true,
                                                                placeholder: "Full name"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email")), {
                                                                required: true,
                                                                type: "email",
                                                                placeholder: "Email"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("phone")), {
                                                                type: "tel",
                                                                placeholder: "Phone number"
                                                            }))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (FeedbackBlock_module_default()).formColumn,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("currency")), {
                                                                placeholder: "Currency (e.g. USD)"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("business_sector")), {
                                                                placeholder: "Industry"
                                                            }))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("comment")), {
                                                placeholder: "Comment",
                                                multiline: true,
                                                rows: 5
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                name: "privacyConsent",
                                                control: control,
                                                render: function(param) {
                                                    var field = param.field, fieldState = param.fieldState;
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Control, {
                                                        className: (FeedbackBlock_module_default()).consent,
                                                        error: (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                                            className: (FeedbackBlock_module_default()).consentCheckbox,
                                                            inputId: "feedback-privacy-consent",
                                                            inputName: field.name,
                                                            inputRef: field.ref,
                                                            alignLabel: "start",
                                                            checked: field.value,
                                                            labelType: "regular12",
                                                            onBlur: field.onBlur,
                                                            onChange: field.onChange,
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    "I agree to the processing of my personal data, as described in the",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                                                        className: (FeedbackBlock_module_default()).privacyLink,
                                                                        href: "/doc/privacy",
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        type: "regular12",
                                                                        variant: "white-50p",
                                                                        children: "Privacy policy"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitButton, {
                                                children: "Send"
                                            })
                                        ]
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (FeedbackBlock_module_default()).rightColumn,
                            direction: "column",
                            gap: 8,
                            justifyContent: "spaceBetween",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    direction: "column",
                                    gap: 10,
                                    children: ADVANTAGES.map(function(param, index) {
                                        var icon = param.icon, title = param.title;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            gap: 6,
                                            alignItems: "center",
                                            children: [
                                                icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    type: "medium18",
                                                    children: title
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    href: "".concat(lkBasePath, "/registration"),
                                    isOutsideLink: true,
                                    children: "Sign up"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/FeedbackBlock/index.ts



/***/ }),

/***/ 60830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/icons/paySystems/index.ts + 12 modules
var paySystems = __webpack_require__(71834);
// EXTERNAL MODULE: ./src/components/icons/PciDssIcon.tsx
var PciDssIcon = __webpack_require__(51500);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Logo/index.ts + 1 modules
var Logo = __webpack_require__(54447);
// EXTERNAL MODULE: ./src/components/landingV4/common/LogoText/index.ts + 1 modules
var LogoText = __webpack_require__(71004);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/common/TextLink/index.ts + 1 modules
var TextLink = __webpack_require__(46370);
// EXTERNAL MODULE: ./src/components/landingV4/Footer/Footer.module.scss
var Footer_module = __webpack_require__(32162);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./src/components/landingV4/Footer/Footer.tsx











var BADGE_HEIGHT = 48;
var BADGE_WIDTH = Math.round(142 / 69 * BADGE_HEIGHT);
var SECTIONS = [
    {
        title: "Company",
        links: [
            {
                title: "Why SmartGates",
                link: "/why-sg"
            },
            {
                title: "Integrations",
                link: "/integrations"
            }, 
        ]
    },
    {
        title: "Documents",
        links: [
            {
                title: "Terms of use",
                link: "/doc/terms-of-use",
                target: "_blank"
            },
            {
                title: "Privacy policy",
                link: "/doc/privacy",
                target: "_blank"
            },
            {
                title: "KYC policy",
                link: "/doc/kyc",
                target: "_blank"
            }, 
        ]
    },
    {
        title: "Developers",
        links: [
            {
                title: "API reference",
                link: "/docs",
                isOutsideLink: true
            }, 
        ]
    },
    {
        title: "Contacts",
        links: [
            {
                title: "Support",
                link: "mailto:support@smart-gates.net"
            }, 
        ]
    }, 
];
var Footer = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx_m/* default */.Z)((Footer_module_default()).root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).grid,
                    children: SECTIONS.map(function(param, index) {
                        var title = param.title, links = param.links;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (Footer_module_default()).section,
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "medium18",
                                    children: title
                                }),
                                links.map(function(param, index) {
                                    var title = param.title, link = param.link, target = param.target, isOutsideLink = param.isOutsideLink;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                        href: link,
                                        target: target,
                                        isOutsideLink: isOutsideLink,
                                        variant: "white-50p",
                                        children: title
                                    }, index);
                                })
                            ]
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).badgesInner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (Footer_module_default()).badgesRow,
                        alignItems: "center",
                        justifyContent: "flexStart",
                        wrap: "wrap",
                        gap: 8,
                        childMinSize: "unset",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(paySystems/* VisaWordmarkIcon */.T$, {
                                className: (Footer_module_default()).badgeIcon,
                                width: BADGE_WIDTH,
                                height: BADGE_HEIGHT
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(paySystems/* MastercardWordmarkIcon */.wr, {
                                className: (Footer_module_default()).badgeIcon,
                                width: BADGE_WIDTH,
                                height: BADGE_HEIGHT
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PciDssIcon/* PciDssIcon */.n, {
                                className: (Footer_module_default()).badgeIcon,
                                width: BADGE_WIDTH,
                                height: BADGE_HEIGHT
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    className: (Footer_module_default()).bottomRow,
                    alignItems: "center",
                    justifyContent: "spaceBetween",
                    wrap: "wrap",
                    gap: 4,
                    childMinSize: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (Footer_module_default()).logoGroup,
                            gap: 3,
                            alignItems: "center",
                            childMinSize: "unset",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText/* LogoText */.Y, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            className: (Footer_module_default()).companyBlock,
                            type: "regular12",
                            color: "white50",
                            children: [
                                "LEAD GATES LTD. UIC: 207064979. Apt. 20, Fl. 6, 14 Miziya Str., Town of Plovdiv, Republic of Bulgaria",
                                " ",
                                "support@smart-gates.net"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/Footer/index.ts



/***/ }),

/***/ 13906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/hooks/use-lk-base-path.ts
var use_lk_base_path = __webpack_require__(14620);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/use-main-landing-href.ts


function useLandingLocalePrefix() {
    var locale = (0,router.useRouter)().locale;
    if (!locale || locale === "default") {
        return "/en";
    }
    return "/".concat(locale);
}
/** Resolve #section on home; `/{locale}/#section` on other landing routes. Must be called once per component. */ function useMainLandingSectionHrefFactory() {
    var pathname = (0,router.useRouter)().pathname;
    var prefix = useLandingLocalePrefix();
    return (0,react.useMemo)(function() {
        return function(sectionId) {
            return pathname === "/" ? "#".concat(sectionId) : "".concat(prefix, "/#").concat(sectionId);
        };
    }, [
        pathname,
        prefix
    ]);
}

;// CONCATENATED MODULE: ./src/components/icons/BurderV4Icon.tsx

var BurgerV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "7",
                y1: "13",
                x2: "25",
                y2: "13",
                stroke: "#00FFBB",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "7",
                y1: "19",
                x2: "25",
                y2: "19",
                stroke: "#00FFBB",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Link/index.ts + 1 modules
var Link = __webpack_require__(43602);
// EXTERNAL MODULE: ./src/components/landingV4/common/Logo/index.ts + 1 modules
var Logo = __webpack_require__(54447);
// EXTERNAL MODULE: ./src/components/landingV4/common/LogoText/index.ts + 1 modules
var LogoText = __webpack_require__(71004);
// EXTERNAL MODULE: ./src/components/landingV4/common/TextLink/index.ts + 1 modules
var TextLink = __webpack_require__(46370);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 36 modules
var dist = __webpack_require__(5038);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var react_visually_hidden_dist = __webpack_require__(96219);
// EXTERNAL MODULE: ./src/components/icons/ChevronForwardV4Icon.tsx
var ChevronForwardV4Icon = __webpack_require__(18805);
;// CONCATENATED MODULE: ./src/components/icons/MenuCloseV4Icon.tsx

var MenuCloseV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 21.5L21.5 10",
                stroke: "#00FFBB",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 10L21.5 21.5",
                stroke: "#00FFBB",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/hooks/use-svg-id.ts

function useSvgId() {
    var id = (0,react.useId)();
    return {
        id: id,
        idUrl: "url(#".concat(id, ")")
    };
}

;// CONCATENATED MODULE: ./src/components/icons/ProfileV4Icon.tsx


var ProfileV4Icon = function() {
    var ref = useSvgId(), id = ref.id, idUrl = ref.idUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "34",
        height: "34",
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: idUrl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "32",
                        height: "32",
                        rx: "16",
                        fill: "#2DB0AB",
                        fillOpacity: "0.03"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.4348 14.9301C11.4348 11.847 13.9265 9.34766 17.0001 9.34766C20.0736 9.34766 22.5653 11.847 22.5653 14.9301C22.5653 18.0132 20.0736 20.5125 17.0001 20.5125C13.9265 20.5125 11.4348 18.0132 11.4348 14.9301Z",
                        fill: "#00FFBB"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.2175 23.2262C9.60708 23.2262 5.86963 26.9753 5.86963 31.5999C5.86963 33.1415 7.11545 34.3911 8.65224 34.3911H25.3479C26.8847 34.3911 28.1305 33.1415 28.1305 31.5999C28.1305 26.9753 24.3931 23.2262 19.7827 23.2262H14.2175Z",
                        fill: "#00FFBB"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "33",
                height: "33",
                rx: "16.5",
                stroke: "#00FFBB",
                strokeOpacity: "0.16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: id,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "32",
                        height: "32",
                        rx: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/Header/components/MobileModalMenu/MobileModalMenu.module.scss
var MobileModalMenu_module = __webpack_require__(61045);
var MobileModalMenu_module_default = /*#__PURE__*/__webpack_require__.n(MobileModalMenu_module);
;// CONCATENATED MODULE: ./src/components/landingV4/Header/components/MobileModalMenu/MobileModalMenu.tsx
















var SECTION_LINKS = [
    {
        sectionId: sections/* SECTIONS_IDS.products */.s.products,
        title: "What we do"
    },
    {
        sectionId: sections/* SECTIONS_IDS.solutions */.s.solutions,
        title: "Solutions"
    },
    {
        sectionId: sections/* SECTIONS_IDS.developers */.s.developers,
        title: "Developers"
    },
    {
        sectionId: sections/* SECTIONS_IDS.resources */.s.resources,
        title: "Resources"
    }, 
];
var MobileModalMenu = function(props) {
    var children = props.children;
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    var sectionHref = useMainLandingSectionHrefFactory();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Root */.fC, {
        defaultOpen: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Trigger */.xz, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Portal */.h_, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_visually_hidden_dist/* Root */.fC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Title */.Dx, {
                                children: "Mobile menu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Description */.dk, {
                                children: "Mobile menu"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Content */.VY, {
                        className: (MobileModalMenu_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (MobileModalMenu_module_default()).container,
                            direction: "column",
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    alignItems: "center",
                                    justifyContent: "spaceBetween",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                className: (MobileModalMenu_module_default()).link,
                                                href: sectionHref(sections/* SECTIONS_IDS.first */.s.first),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                    className: (MobileModalMenu_module_default()).logoContainer,
                                                    gap: 3,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText/* LogoText */.Y, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {})
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                className: (MobileModalMenu_module_default()).closeButton,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCloseV4Icon, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    className: (MobileModalMenu_module_default()).menu,
                                    direction: "column",
                                    gap: 4,
                                    justifyContent: "spaceBetween",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            direction: "column",
                                            gap: 16,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                    direction: "column",
                                                    gap: 8,
                                                    children: [
                                                        SECTION_LINKS.map(function(param, index) {
                                                            var sectionId = param.sectionId, title = param.title;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                                                asChild: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                                    className: (MobileModalMenu_module_default()).link,
                                                                    href: sectionHref(sectionId),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                            type: "regular16",
                                                                            children: title
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {})
                                                                    ]
                                                                })
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                                            asChild: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                                className: (MobileModalMenu_module_default()).link,
                                                                href: "/why-sg",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        type: "regular16",
                                                                        children: "Why SmartGates"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {})
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                                            asChild: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                                className: (MobileModalMenu_module_default()).link,
                                                                href: "/integrations",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        type: "regular16",
                                                                        children: "Integrations"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {})
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                    gap: 4,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileV4Icon, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                                            href: "".concat(lkBasePath, "/account/login"),
                                                            isOutsideLink: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                gap: 2,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Log in"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {})
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                                href: sectionHref(sections/* SECTIONS_IDS.contact */.s.contact),
                                                children: "Contact"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/Header/components/MobileModalMenu/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/Header/Header.module.scss
var Header_module = __webpack_require__(86623);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/landingV4/Header/Header.tsx














var Header = function(props) {
    var className = props.className;
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    var sectionHref = useMainLandingSectionHrefFactory();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (0,clsx_m/* default */.Z)((Header_module_default()).root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                className: (Header_module_default()).desktopHeader,
                alignItems: "center",
                wrap: "nowrap",
                childMinSize: "unset",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: (Header_module_default()).logoLink,
                        href: sectionHref(sections/* SECTIONS_IDS.first */.s.first),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (Header_module_default()).logoContainer,
                            gap: 3,
                            alignItems: "center",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText/* LogoText */.Y, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (Header_module_default()).linksContainer,
                        alignItems: "center",
                        wrap: "nowrap",
                        childMinSize: "unset",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: sectionHref(sections/* SECTIONS_IDS.products */.s.products),
                                variant: "white-50p",
                                children: "What we do"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: sectionHref(sections/* SECTIONS_IDS.solutions */.s.solutions),
                                variant: "white-50p",
                                children: "Solutions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: sectionHref(sections/* SECTIONS_IDS.developers */.s.developers),
                                variant: "white-50p",
                                children: "Developers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: sectionHref(sections/* SECTIONS_IDS.resources */.s.resources),
                                variant: "white-50p",
                                children: "Resources"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: "/why-sg",
                                variant: "white-50p",
                                children: "Why SmartGates"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: "/integrations",
                                variant: "white-50p",
                                children: "Integrations"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (Header_module_default()).loginBlock,
                        gap: 6,
                        alignItems: "center",
                        wrap: "nowrap",
                        childMinSize: "unset",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: "".concat(lkBasePath, "/account/login"),
                                isOutsideLink: true,
                                children: "Log in"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                href: sectionHref(sections/* SECTIONS_IDS.contact */.s.contact),
                                children: "Contact"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                className: (Header_module_default()).mobileHeader,
                alignItems: "center",
                justifyContent: "spaceBetween",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: sectionHref(sections/* SECTIONS_IDS.first */.s.first),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileModalMenu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            className: (Header_module_default()).burgerContainer,
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerV4Icon, {})
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/Header/index.ts



/***/ }),

/***/ 7513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ SnackbarProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(20377);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/icons/CloseV4Icon.tsx



var CloseV4Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.85355 4.14645C4.65829 3.95118 4.34171 3.95118 4.14645 4.14645C3.95118 4.34171 3.95118 4.65829 4.14645 4.85355L7.29289 8L4.14645 11.1464C3.95118 11.3417 3.95118 11.6583 4.14645 11.8536C4.34171 12.0488 4.65829 12.0488 4.85355 11.8536L8 8.70711L11.1464 11.8536C11.3417 12.0488 11.6583 12.0488 11.8536 11.8536C12.0488 11.6583 12.0488 11.3417 11.8536 11.1464L8.70711 8L11.8536 4.85355C12.0488 4.65829 12.0488 4.34171 11.8536 4.14645C11.6583 3.95118 11.3417 3.95118 11.1464 4.14645L8 7.29289L4.85355 4.14645Z",
            fill: "currentColor"
        })
    }));
};

// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/SnackbarProvider/components/Notification/Notification.module.scss
var Notification_module = __webpack_require__(84142);
var Notification_module_default = /*#__PURE__*/__webpack_require__.n(Notification_module);
;// CONCATENATED MODULE: ./src/components/landingV4/SnackbarProvider/components/Notification/Notification.tsx








var ICONS = {
    success: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.5 8C1.5 4.41136 4.41136 1.5 8 1.5C11.5886 1.5 14.5 4.41136 14.5 8C14.5 11.5886 11.5886 14.5 8 14.5C4.41136 14.5 1.5 11.5886 1.5 8ZM8 2.5C4.96364 2.5 2.5 4.96364 2.5 8C2.5 11.0364 4.96364 13.5 8 13.5C11.0364 13.5 13.5 11.0364 13.5 8C13.5 4.96364 11.0364 2.5 8 2.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.3216 5.11715C11.533 5.29476 11.5605 5.61015 11.3829 5.8216L7.18285 10.8216C7.08977 10.9324 6.95324 10.9975 6.80854 10.9999C6.66384 11.0024 6.52517 10.9421 6.42835 10.8345L4.62835 8.83448C4.44362 8.62923 4.46026 8.31308 4.66552 8.12835C4.87077 7.94362 5.18692 7.96026 5.37165 8.16552L6.78699 9.73812L10.6171 5.1784C10.7948 4.96696 11.1102 4.93954 11.3216 5.11715Z",
                fill: "currentColor"
            })
        ]
    }),
    warning: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.5 8C1.5 4.41136 4.41136 1.5 8 1.5C11.5886 1.5 14.5 4.41136 14.5 8C14.5 11.5886 11.5886 14.5 8 14.5C4.41136 14.5 1.5 11.5886 1.5 8ZM8 2.5C4.96364 2.5 2.5 4.96364 2.5 8C2.5 11.0364 4.96364 13.5 8 13.5C11.0364 13.5 13.5 11.0364 13.5 8C13.5 4.96364 11.0364 2.5 8 2.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.99341 4.50158C8.08572 4.50071 8.17724 4.51865 8.26239 4.55432C8.34758 4.59002 8.4246 4.64271 8.48874 4.70917C8.55288 4.77564 8.6028 4.85449 8.63543 4.94089C8.66806 5.0273 8.68274 5.11946 8.67855 5.21173L8.49945 9.02347C8.48692 9.29018 8.26703 9.49999 8.00002 9.5C7.73301 9.50001 7.51311 9.29022 7.50055 9.02351L7.32114 5.21173C7.317 5.12055 7.33128 5.02948 7.36312 4.94394C7.39495 4.8584 7.4437 4.78016 7.50645 4.71388C7.5692 4.64759 7.64465 4.59463 7.72832 4.55816C7.81194 4.52171 7.90205 4.50247 7.99326 4.50159",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 11.4972C7.87639 11.4972 7.75555 11.4605 7.65277 11.3919C7.54999 11.3232 7.46988 11.2256 7.42258 11.1114C7.37527 10.9972 7.36289 10.8715 7.38701 10.7503C7.41112 10.629 7.47065 10.5177 7.55806 10.4302C7.64547 10.3428 7.75683 10.2833 7.87807 10.2592C7.99931 10.2351 8.12497 10.2475 8.23918 10.2948C8.35338 10.3421 8.45099 10.4222 8.51967 10.525C8.58834 10.6277 8.625 10.7486 8.625 10.8722C8.625 11.0379 8.55915 11.1969 8.44194 11.3141C8.32473 11.4313 8.16576 11.4972 8 11.4972Z",
                fill: "currentColor"
            })
        ]
    })
};
var Notification = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var className = props.className, id = props.id, variant = props.variant, message = props.message;
    var closeSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().closeSnackbar;
    var icon = variant === "error" || variant === "warning" ? ICONS.warning : ICONS.success;
    var title = variant === "error" ? "Error" : variant === "warning" ? "Warning" : "Success";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        className: (0,clsx_m/* default */.Z)((Notification_module_default()).root, (Notification_module_default())["variant_".concat(variant)], className),
        ref: ref,
        direction: "column",
        gap: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                className: (Notification_module_default()).title,
                gap: 2,
                alignItems: "center",
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "regular12",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseV4Icon, {
                        className: (Notification_module_default()).closeIcon,
                        onClick: function() {
                            closeSnackbar(id);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                type: "regular12",
                lineCount: 2,
                color: "white",
                children: message
            })
        ]
    });
});
Notification.displayName = "Notification";

;// CONCATENATED MODULE: ./src/components/landingV4/SnackbarProvider/components/Notification/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/SnackbarProvider/SnackbarProvider.tsx
"use client";



var SnackbarProvider = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(notistack_esm/* SnackbarProvider */.wT, {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        dense: true,
        Components: {
            default: Notification,
            error: Notification,
            success: Notification,
            warning: Notification,
            info: Notification
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/SnackbarProvider/index.ts



/***/ }),

/***/ 64791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ButtonLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landingV4/common/Button/index.ts + 1 modules
var Button = __webpack_require__(27362);
// EXTERNAL MODULE: ./src/components/landingV4/common/Link/index.ts + 1 modules
var Link = __webpack_require__(43602);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/ButtonLink.module.scss
var ButtonLink_module = __webpack_require__(10988);
var ButtonLink_module_default = /*#__PURE__*/__webpack_require__.n(ButtonLink_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/ButtonLink/ButtonLink.tsx








var ButtonLink = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var className = props.className, href = props.href, target = props.target, rel = props.rel, isOutsideLink = props.isOutsideLink, buttonProps = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "href",
        "target",
        "rel",
        "isOutsideLink"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        className: (0,clsx_m/* default */.Z)((ButtonLink_module_default()).root, className),
        href: href,
        target: target,
        rel: rel,
        isOutsideLink: isOutsideLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
            className: (ButtonLink_module_default()).button,
            ref: ref
        }, buttonProps))
    });
});
ButtonLink.displayName = "ButtonLink";

;// CONCATENATED MODULE: ./src/components/landingV4/common/ButtonLink/index.ts



/***/ }),

/***/ 67306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/Container.module.scss
var Container_module = __webpack_require__(43936);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Container/Container.tsx






var Container = function(props) {
    var className = props.className, children = props.children, flexProps = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((Container_module_default()).root, className)
    }, flexProps), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Container/index.ts



/***/ }),

/***/ 54447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Logo/Logo.tsx

var Logo = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "var(--yellow)",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.05566 36.4102C4.08614 36.4103 4.11035 36.4353 4.11035 36.4658C4.11049 40.5656 7.4345 43.8896 11.5498 43.8896L11.5713 43.8936C11.5912 43.9019 11.6054 43.9214 11.6055 43.9443C11.6055 43.9749 11.5804 44 11.5498 44H4.05566C4.02507 44 4 43.9749 4 43.9443V36.4658C4 36.4352 4.02507 36.4102 4.05566 36.4102ZM7.32715 23.9609C7.34115 23.9748 7.34676 23.9956 7.3418 24.0146C7.2466 24.3759 7.19534 24.7557 7.19531 25.1475C7.19531 26.813 8.11288 28.2614 9.46191 29L21.7256 35.7139C23.1098 36.4655 24.0557 37.9547 24.0557 39.667C24.0555 41.7406 22.6675 43.4861 20.7822 43.998C20.7632 44.0032 20.7426 43.9982 20.7285 43.9844C20.7145 43.9704 20.7088 43.9498 20.7139 43.9307C20.8089 43.5695 20.8594 43.1896 20.8594 42.7979C20.8594 41.0853 19.8902 39.6046 18.5947 38.9492L18.6191 38.9014L18.5928 38.9482L6.3418 32.2383C4.94826 31.4841 4.00004 29.9936 4 28.2793C4 26.2053 5.38783 24.4593 7.27344 23.9473C7.29241 23.9421 7.31312 23.9472 7.32715 23.9609ZM24.001 16.4648C24.0315 16.465 24.0557 16.49 24.0557 16.5205C24.0558 20.6201 27.3799 23.9442 31.4951 23.9443L31.5166 23.9482C31.5365 23.9566 31.5507 23.9761 31.5508 23.999C31.5508 24.0296 31.5257 24.0547 31.4951 24.0547H24.0547V31.4795C24.0547 31.5101 24.0296 31.5352 23.999 31.5352C23.9685 31.5351 23.9434 31.51 23.9434 31.4795C23.9432 27.508 20.825 24.2644 16.8887 24.0654L16.5049 24.0557C16.4744 24.0557 16.4494 24.0315 16.4492 24.001C16.4492 23.9704 16.4743 23.9453 16.5049 23.9453H23.9453V16.5205C23.9453 16.4899 23.9704 16.4648 24.001 16.4648ZM43.9443 13.9727C43.9589 13.9727 43.9731 13.9789 43.9834 13.9893C43.9936 13.9996 43.999 14.0137 43.999 14.0283V16.5215C43.9989 20.6826 40.6256 24.0558 36.4492 24.0557H33.6494C33.6188 24.0557 33.5938 24.0306 33.5938 24C33.5938 23.9695 33.6189 23.9443 33.6494 23.9443C35.5544 23.9443 37.2389 23.0194 38.2783 21.5957C38.749 20.842 39.0204 19.9513 39.0205 18.9971C39.0205 16.2836 36.821 14.083 34.1074 14.083C34.077 14.0829 34.0529 14.0587 34.0527 14.0283C34.0527 13.9978 34.077 13.9728 34.1074 13.9727H43.9443ZM43.9453 4C43.9759 4.00003 44.001 4.02508 44.001 4.05566V9.96484C44.001 9.98905 43.985 10.0113 43.9619 10.0186C43.9388 10.0258 43.9132 10.0169 43.8994 9.99707C42.9229 8.59347 41.3668 7.53834 39.6885 6.83398C38.0103 6.12977 36.2151 5.77836 34.7676 5.77832C31.5159 5.77832 28.9966 6.51369 27.2119 7.75879C25.4282 9.00331 24.3745 10.7592 24.0557 12.8076C24.0512 12.8362 24.0249 12.8567 23.9961 12.8545C23.9675 12.8521 23.9455 12.8285 23.9453 12.7998C23.9453 9.75491 25.2539 7.55181 27.2637 6.1123C29.2713 4.67435 31.9757 4 34.7676 4H43.9453Z"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Logo/index.ts



/***/ }),

/***/ 71004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ LogoText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/landingV4/common/LogoText/LogoText.tsx

var LogoText = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "104",
        height: "12",
        viewBox: "0 0 104 12",
        fill: "var(--yellow)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.4758 11.21C96.8358 11.21 95.2158 9.83004 95.2158 7.65504H97.5558C97.5558 8.66004 98.3058 9.24504 99.4608 9.24504C100.451 9.24504 101.081 8.84004 101.081 8.13504C101.081 7.40004 100.406 6.96504 98.9208 6.65004C96.4608 6.12504 95.3058 5.10504 95.3058 3.39504C95.3058 1.47504 96.8058 0.290039 99.2208 0.290039C101.711 0.290039 103.301 1.64004 103.301 3.75504H101.006C101.006 2.81004 100.346 2.24004 99.2508 2.24004C98.2458 2.24004 97.6308 2.66004 97.6308 3.35004C97.6308 3.99504 98.1858 4.40004 99.7908 4.77504C102.401 5.39004 103.496 6.38004 103.496 8.04504C103.496 10.025 101.966 11.21 99.4758 11.21Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.8217 11V0.5H93.7217V2.51H89.1917V4.685H93.3167V6.68H89.1917V8.975H93.8867V11H86.8217Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M79.3953 11V2.735H76.0653V0.5H85.1103V2.735H81.7803V11H79.3953Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.9359 11L70.1059 0.5H72.4459L76.6159 11H74.0659L73.3609 9.185H69.1909L68.4859 11H65.9359ZM69.8059 7.31H72.7609L71.2759 3.47L69.8059 7.31Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.2175 11.21C56.9925 11.21 54.7125 8.96004 54.7125 5.75004C54.7125 2.55504 56.9775 0.290039 60.1725 0.290039C62.7225 0.290039 64.8075 1.73004 65.4375 3.93504H62.8725C62.3625 3.02004 61.3875 2.48004 60.2175 2.48004C58.3725 2.48004 57.0975 3.83004 57.0975 5.75004C57.0975 7.64004 58.3275 9.02004 60.2475 9.02004C61.7775 9.02004 62.8575 8.16504 63.1575 6.89004H59.7525V5.04504H65.6775C65.9175 8.64504 63.6825 11.21 60.2175 11.21Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.4871 11V2.735H45.1571V0.5H54.2021V2.735H50.8721V11H48.4871Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.8304 11V0.5H40.3154C42.7154 0.5 44.2454 1.88 44.2454 4.115C44.2454 5.66 43.5104 6.8 42.2504 7.355L44.4254 11H41.6654L39.7904 7.73H38.2154V11H35.8304ZM38.1854 5.72H40.0004C41.1704 5.72 41.8304 5.15 41.8304 4.13C41.8304 3.11 41.1704 2.54 40.0004 2.54H38.1854V5.72Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.7484 11L27.9184 0.5H30.2584L34.4284 11H31.8784L31.1734 9.185H27.0034L26.2984 11H23.7484ZM27.6184 7.31H30.5734L29.0884 3.47L27.6184 7.31Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8695 11V0.5H12.8945L16.6295 5.945L20.3495 0.5H22.3595V11H19.9895V4.685L17.4395 8.405H15.7895L13.2395 4.67V11H10.8695Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.92016 11.21C2.28016 11.21 0.660156 9.83004 0.660156 7.65504H3.00016C3.00016 8.66004 3.75016 9.24504 4.90516 9.24504C5.89516 9.24504 6.52516 8.84004 6.52516 8.13504C6.52516 7.40004 5.85016 6.96504 4.36516 6.65004C1.90516 6.12504 0.750156 5.10504 0.750156 3.39504C0.750156 1.47504 2.25016 0.290039 4.66516 0.290039C7.15516 0.290039 8.74516 1.64004 8.74516 3.75504H6.45016C6.45016 2.81004 5.79016 2.24004 4.69516 2.24004C3.69016 2.24004 3.07516 2.66004 3.07516 3.35004C3.07516 3.99504 3.63016 4.40004 5.23516 4.77504C7.84516 5.39004 8.94016 6.38004 8.94016 8.04504C8.94016 10.025 7.41016 11.21 4.92016 11.21Z"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/LogoText/index.ts



/***/ }),

/***/ 46615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ EmptyLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36336);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62097);
/* harmony import */ var _FloatMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46489);
/* harmony import */ var _Snackbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44564);
/* harmony import */ var _MainLayout_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54048);
/* harmony import */ var _MainLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_MainLayout_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var EmptyLayout = function(param) {
    var pageContentClassName = param.pageContentClassName, _withFloatMenu = param.withFloatMenu, withFloatMenu = _withFloatMenu === void 0 ? true : _withFloatMenu, children = param.children;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        disableGutters: true,
        maxWidth: false,
        sx: {
            display: "flex"
        },
        "data-theme": theme.palette.mode,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "page-content page-content-noSidebar ".concat(pageContentClassName !== null && pageContentClassName !== void 0 ? pageContentClassName : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Snackbar__WEBPACK_IMPORTED_MODULE_2__/* .Snackbar */ .A, {
                    classes: {
                        containerRoot: (_MainLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().snackbarContainerRoot),
                        root: (_MainLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().snackbarRoot)
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    disableGutters: true,
                    maxWidth: false,
                    className: "page-container",
                    children: children
                }),
                withFloatMenu && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FloatMenu__WEBPACK_IMPORTED_MODULE_1__/* .FloatMenu */ .M, {})
            ]
        })
    });
};


/***/ }),

/***/ 6872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SECTIONS_IDS; }
/* harmony export */ });
var SECTIONS_IDS = {
    first: "first",
    products: "products",
    solutions: "solutions",
    developers: "developers",
    resources: "resources",
    faq: "faq",
    contact: "contact"
};


/***/ }),

/***/ 47758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBoolean; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useBoolean = function(init) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(init), value = ref[0], setValue = ref[1];
    return {
        value: value,
        setValue: setValue,
        toggle: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            return setValue(function(stateValue) {
                return !stateValue;
            });
        }, []),
        setTrue: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            return setValue(true);
        }, []),
        setFalse: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            return setValue(false);
        }, [])
    };
};


/***/ }),

/***/ 14620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useLkBasePath; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useLkBasePath() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    return "/lk/".concat(locale);
}


/***/ }),

/***/ 46734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZL": function() { return /* binding */ getWindowMaxScrollY; },
/* harmony export */   "kp": function() { return /* binding */ addResizeListener; }
/* harmony export */ });
/* unused harmony exports getWindow, getDocument, addEventListener */
function getWindow() {
    return  false ? 0 : window;
}
function getDocument() {
    return typeof document === "undefined" ? null : document;
}
function addEventListener(element, event, listener, options) {
    // @ts-ignore
    element.addEventListener(event, listener, options);
    return function() {
        // @ts-ignore
        element.removeEventListener(event, listener, options);
    };
}
function addResizeListener(element, listener) {
    var observer = new ResizeObserver(listener);
    observer.observe(element);
    return function() {
        observer.disconnect();
    };
}
function getWindowMaxScrollY() {
    var body = document.body;
    var html = document.documentElement;
    return Math.max(0, Math.min(Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) - window.innerHeight));
}


/***/ }),

/***/ 44341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQBlock_root__20GXI","inner":"FAQBlock_inner__7GQiM","intro":"FAQBlock_intro__cshHx","title":"FAQBlock_title__mBWGo","list":"FAQBlock_list__o1c8X","item":"FAQBlock_item__8waQ0","itemButton":"FAQBlock_itemButton__GSElQ","itemQuestionText":"FAQBlock_itemQuestionText__SFGuf","chevronWrap":"FAQBlock_chevronWrap__HtKBK","open":"FAQBlock_open__gCzuk","answerAccordion":"FAQBlock_answerAccordion__iI6pG","answerAccordion_open":"FAQBlock_answerAccordion_open__EelZJ","answerAccordionInner":"FAQBlock_answerAccordionInner__ByV0a","answer":"FAQBlock_answer__wQDTC","answerText":"FAQBlock_answerText__qnFeV","ctaWrap":"FAQBlock_ctaWrap__17cRy"};

/***/ }),

/***/ 68588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FeedbackBlock_root__4MNQR","inner":"FeedbackBlock_inner__dcfnG","title":"FeedbackBlock_title__kjEmj","grid":"FeedbackBlock_grid__IrMvJ","form":"FeedbackBlock_form__JWp6e","formColumns":"FeedbackBlock_formColumns__8IWUA","formColumn":"FeedbackBlock_formColumn___iLGk","consent":"FeedbackBlock_consent__DOJmP","consentCheckbox":"FeedbackBlock_consentCheckbox__OegGy","privacyLink":"FeedbackBlock_privacyLink__iASCp","rightColumn":"FeedbackBlock_rightColumn__sQd18"};

/***/ }),

/***/ 32162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__xpAP4","badgesInner":"Footer_badgesInner__ll92g","badgesRow":"Footer_badgesRow__uoxp_","badgeIcon":"Footer_badgeIcon__Nb8Wf","bottomRow":"Footer_bottomRow__K4EYD","companyBlock":"Footer_companyBlock__AmfkP","logoGroup":"Footer_logoGroup__UHhI5","grid":"Footer_grid__Led7p","section":"Footer_section__na_Qz"};

/***/ }),

/***/ 86623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vfkpT","mobileHeader":"Header_mobileHeader__w0XT4","burgerContainer":"Header_burgerContainer__eXVYV","desktopHeader":"Header_desktopHeader__4KSp0","logoLink":"Header_logoLink___qIcU","logoContainer":"Header_logoContainer__uUtHz","linksContainer":"Header_linksContainer__cXQ_M","loginBlock":"Header_loginBlock__uppDW"};

/***/ }),

/***/ 61045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"MobileModalMenu_content__EI79f","container":"MobileModalMenu_container__6cKiz","menu":"MobileModalMenu_menu__RJHzR","link":"MobileModalMenu_link__S4Rv_","closeButton":"MobileModalMenu_closeButton__Dmlpe"};

/***/ }),

/***/ 84142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__dwIT_","title":"Notification_title__erETd","closeIcon":"Notification_closeIcon__Yc2sP","variant_default":"Notification_variant_default__VANba","variant_success":"Notification_variant_success__uYj2i","variant_info":"Notification_variant_info__bJhPY","variant_warning":"Notification_variant_warning__Mq9hE","variant_error":"Notification_variant_error__FzEEe"};

/***/ }),

/***/ 10988:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLink_root__QYRIO","button":"ButtonLink_button__04ypO"};

/***/ }),

/***/ 43936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root___GV4U"};

/***/ }),

/***/ 33249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Control_root__jX3ko","label":"Control_label__lTf8E","error":"Control_error__hzyNo"};

/***/ }),

/***/ 35037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextInput_root__B_w6m","state_error":"TextInput_state_error__E2dL3","prefix":"TextInput_prefix__0zJ5p","suffix":"TextInput_suffix__HkJAL","input":"TextInput_input__7tkob","variant_default":"TextInput_variant_default__Aid6g","variant_box":"TextInput_variant_box__0xnRk","withPrefix":"TextInput_withPrefix___ZSKU","withSuffix":"TextInput_withSuffix__MzGaA","multiline":"TextInput_multiline__lD7lg"};

/***/ })

}]);